// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../lib/styles/chart-theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../lib/styles/chart-splitter.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23787b86%27 d=%27M0 2.5 L4 6.5 L8 2.5 Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2718%27 viewBox=%270 0 18 18%27%3E%3Cpath d=%27M5 2h2.5v3a1.5 1.5 0 0 0 3 0V2H13v4a4 4 0 0 1-8 0V2Zm2.5 0V5a1.5 1.5 0 0 0 3 0V2h-3Z%27 fill=%27%23d97706%27/%3E%3Cpath d=%27M4.5 14.5A1.5 1.5 0 1 1 7.5 14.5A1.5 1.5 0 0 1 4.5 14.5Zm6 0A1.5 1.5 0 1 1 13.5 14.5A1.5 1.5 0 0 1 10.5 14.5Z%27 fill=%27%23d97706%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
[data-chart-theme] {
	--gc-bg: var(--rsc-bg, #08101d);
	--gc-surface: var(--rsc-surface, #0f172a);
	--gc-surface-sub: var(--rsc-surface-sub, #111827);
	--gc-border: var(--rsc-border, rgba(148, 163, 184, 0.18));
	--gc-border-mid: var(--rsc-border-mid, rgba(148, 163, 184, 0.26));
	--gc-text: var(--rsc-text, #e2e8f0);
	--gc-text-muted: var(--rsc-text-muted, #94a3b8);
	--gc-text-micro: var(--rsc-text-micro, #64748b);
	--gc-accent: var(--rsc-accent, #22d3ee);
	--gc-accent-bg: var(--rsc-accent-bg, rgba(34, 211, 238, 0.14));
	--gc-up: var(--rsc-up, rgb(38, 166, 154));
	--gc-dn: var(--rsc-dn, rgb(239, 83, 80));
	/* UI/UX GAP AUDIT: Chart-first layout adjustments */
	--gc-topbar-h: 48px;
	--gc-bottombar-h: 32px;
	--gc-toolbar-w: 40px;
	--gc-toolbar-handle-w: 20px;
	--gc-toolbar-handle-h: 44px;
	--gc-toolbar-button-size: 32px;
	--gc-toolbar-gap: 4px;
	--gc-toolbar-section-gap: 4px;
	--gc-toolbar-flyout-padding: 6px;
	--gc-toolbar-flyout-margin: 8px;
	--gc-toolbar-flyout-button-size: 32px;
	--gc-toolbar-flyout-button-size-compact: 32px;
	/* UI/UX: Touch target min 44px per accessibility checklist */
	--gc-touch-target-min: 44px;
	--gc-touch-spacing-min: 8px;
	--gc-safe-top: env(safe-area-inset-top, 0px);
	--gc-safe-right: env(safe-area-inset-right, 0px);
	--gc-safe-bottom: env(safe-area-inset-bottom, 0px);
	--gc-safe-left: env(safe-area-inset-left, 0px);
	--gc-keyboard-inset-bottom: 0px;
	--gc-toolbar-motion-fast: 120ms;
	--gc-toolbar-motion-default: 150ms;
	/* UI/UX: Unified radius token */
	--gc-radius: 8px;
	--gc-radius-btn: 6px;
	/* UI/UX: Context rail width - narrower for chart-first */
	--gc-context-rail-w: 240px;
	--gc-context-rail-collapsed-w: 48px;
	--gc-font: "Inter", "Segoe UI Variable Text", "Aptos", "Segoe UI", system-ui, sans-serif;
	--gc-mono: "JetBrains Mono", "Cascadia Code", "Consolas", monospace;
	--demo-bg: #0b1120;
	--demo-bg-soft: #111827;
	--demo-panel: rgba(15, 23, 42, 0.82);
	--demo-panel-border: rgba(148, 163, 184, 0.18);
	--demo-panel-border-strong: rgba(148, 163, 184, 0.26);
	--demo-text: #e2e8f0;
	--demo-text-soft: #94a3b8;
	--demo-accent: #22d3ee;
	--demo-accent-alt: #f59e0b;
	--demo-success: rgb(38, 166, 154);
	--demo-danger: rgb(239, 83, 80);
	--demo-warning: #fb923c;
}

html, body, #root {
	height: 100%;
	overflow: hidden;
}

html[data-chart-theme="classic-dark"],
html[data-chart-theme="trading-night"],
html[data-chart-theme="high-contrast"] {
	color-scheme: dark;
}

html[data-chart-theme="modern-light"],
html[data-chart-theme="neutral-pro"] {
	color-scheme: light;
}

body {
	margin: 0;
	background: linear-gradient(180deg, #08101d 0%, #0b1120 38%, #0d1525 100%);
	color: var(--gc-text);
	font-family: "Inter", "Segoe UI Variable Text", "Aptos", "Segoe UI", sans-serif;
	overflow: hidden;
}

html[data-chart-theme="classic-dark"] body,
html[data-chart-theme="trading-night"] body,
html[data-chart-theme="high-contrast"] body {
	background:
		radial-gradient(circle at top left, rgba(34, 211, 238, 0.16), transparent 28%),
		radial-gradient(circle at top right, rgba(245, 158, 11, 0.14), transparent 26%),
		linear-gradient(180deg, #08101d 0%, #0b1120 38%, #0d1525 100%);
}

html[data-chart-theme="modern-light"] body,
html[data-chart-theme="neutral-pro"] body {
	background:
		radial-gradient(circle at top left, rgba(11, 116, 222, 0.1), transparent 28%),
		radial-gradient(circle at top right, rgba(245, 158, 11, 0.08), transparent 24%),
		linear-gradient(180deg, #f0f4ff 0%, #f8fbff 42%, #eef2f8 100%);
}

body::before {
	content: "";
	position: fixed;
	inset: 0;
	pointer-events: none;
	background-image:
		linear-gradient(rgba(148, 163, 184, 0.05) 1px, transparent 1px),
		linear-gradient(90deg, rgba(148, 163, 184, 0.05) 1px, transparent 1px);
	background-size: 42px 42px;
	opacity: 0.35;
	mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.9), transparent 92%);
}

html[data-chart-mode="light"] body::before {
	opacity: 0.18;
}

#root {
	height: 100%;
}

/* Legacy demo layout restored for the current JSX markup. */
.gc-terminal {
	display: grid;
	grid-template-rows: var(--gc-topbar-h) minmax(0, 1fr) var(--gc-bottombar-h);
	height: 100%;
	padding: var(--gc-safe-top) var(--gc-safe-right) var(--gc-safe-bottom) var(--gc-safe-left);
	box-sizing: border-box;
	background: var(--gc-bg);
	border: 1px solid var(--gc-border);
	overflow: hidden;
	user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
}

.gc-terminal input,
.gc-terminal textarea {
	user-select: text;
	-webkit-user-select: text;
	-ms-user-select: text;
}

.gc-topbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 12px;
	border-bottom: 1px solid var(--gc-border);
	background: var(--gc-surface);
	gap: 4px;
	min-width: 0;
}

.gc-topbar__left,
.gc-topbar__right {
	display: flex;
	align-items: center;
	gap: 4px;
	min-width: 0;
}

.gc-logo {
	flex-shrink: 0;
	width: 28px;
	height: 28px;
	display: grid;
	place-items: center;
	border-radius: 7px;
	border: 1px solid var(--gc-border);
	background: linear-gradient(135deg, var(--gc-surface-sub), var(--gc-surface));
	color: var(--gc-text);
	font-size: 10px;
	font-weight: 800;
	letter-spacing: -0.3px;
}

.gc-symbol-block {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	padding: 0 4px;
}

.gc-symbol-name {
	font-size: 15px;
	font-weight: 700;
	color: var(--gc-text);
	white-space: nowrap;
}

.gc-symbol-name--btn {
	display: inline-flex;
	align-items: center;
	gap: 3px;
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	transition: color 0.15s;
}

.gc-symbol-name--btn:hover {
	color: var(--gc-accent, #2196f3);
}

.gc-symbol-exchange {
	font-size: 9px;
	font-weight: 500;
	color: var(--gc-text-muted);
	letter-spacing: 0.4px;
	text-transform: uppercase;
}

.gc-symbol-exchange__caret {
	font-size: 9px;
	opacity: 0.55;
}

.gc-topbar-sep {
	width: 1px;
	height: 20px;
	background: var(--gc-border);
	flex-shrink: 0;
	margin: 0 4px;
}

.gc-tf-chips {
	display: flex;
	gap: 2px;
	flex-wrap: wrap;
}

.gc-tf-chip {
	appearance: none;
	border: none;
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 12px;
	font-weight: 500;
	padding: 4px 7px;
	border-radius: var(--gc-radius-btn);
	cursor: pointer;
	transition: background 100ms, color 100ms;
	white-space: nowrap;
}

.gc-tf-chip:hover {
	background: var(--gc-surface-sub);
	color: var(--gc-text);
}

.gc-tf-chip--active {
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
	font-weight: 700;
}

.gc-topbar-btn {
	appearance: none;
	border: 1px solid transparent;
	background: transparent;
	color: var(--gc-text);
	font-size: 12px;
	padding: 0 8px;
	height: 28px;
	box-sizing: border-box;
	border-radius: var(--gc-radius-btn);
	cursor: pointer;
	white-space: nowrap;
	transition: background 120ms, color 120ms;
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.gc-topbar-btn:hover {
	background: var(--gc-surface-sub);
	color: var(--gc-text);
}

.gc-topbar-btn--active {
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
}

.gc-datasource-switcher {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	flex-wrap: wrap;
	min-width: 0;
}

.gc-datasource-btn {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 11.5px;
	padding: 5px 9px;
	border-radius: var(--gc-radius-btn);
	cursor: pointer;
	white-space: nowrap;
	transition: background 100ms, color 100ms, border-color 100ms;
}

.gc-datasource-btn:hover {
	background: var(--gc-surface-sub);
	color: var(--gc-text);
}

.gc-datasource-btn--active {
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
	border-color: transparent;
	font-weight: 700;
}

.gc-paper-trade-panel {
	position: absolute;
	left: 16px;
	bottom: 16px;
	z-index: 37;
	width: min(320px, calc(100vw - 32px));
	padding: 12px 14px;
	border-radius: 16px;
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-surface);
	box-shadow: 0 16px 38px rgba(2, 6, 23, 0.18);
	display: grid;
	gap: 10px;
	color: var(--gc-text);
}

html[data-chart-mode="dark"] .gc-paper-trade-panel {
	background: rgba(var(--gc-surface, 30 33 48) / 0.96);
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
}

.gc-paper-trade-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	min-width: 0;
}

.gc-paper-trade-panel__header-actions {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.gc-paper-trade-panel__chip {
	display: inline-flex;
	align-items: center;
	padding: 5px 8px;
	border-radius: 999px;
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
}

.gc-paper-trade-panel__header strong {
	font-size: 13px;
	font-weight: 800;
	color: var(--gc-text);
}

.gc-paper-trade-panel__reset {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 11px;
	font-weight: 600;
	padding: 5px 8px;
	border-radius: 5px;
	cursor: pointer;
	white-space: nowrap;
	transition: background 100ms ease, color 100ms ease, border-color 100ms ease;
}

.gc-paper-trade-panel__reset:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.gc-paper-trade-panel__hint {
	font-size: 11px;
	line-height: 1.45;
	color: var(--gc-text-muted);
}

.gc-paper-trade-panel__report {
	display: grid;
	gap: 10px;
	padding-top: 4px;
	border-top: 1px solid var(--gc-border);
}

.gc-paper-trade-panel__section-title {
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--gc-text-muted);
}

.gc-paper-trade-panel__stats {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 8px;
}

.gc-paper-trade-panel__stat {
	display: grid;
	gap: 4px;
	padding: 8px 9px;
	border-radius: 10px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
}

.gc-paper-trade-panel__label {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: var(--gc-text-muted);
}

.gc-paper-trade-panel__value {
	font-size: 13px;
	font-weight: 800;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}

.gc-paper-trade-panel__position {
	display: grid;
	gap: 4px;
	padding: 8px 9px;
	border-radius: 10px;
	border: 1px solid var(--gc-border);
	background: var(--gc-accent-bg);
	color: var(--gc-text);
}

.gc-paper-trade-panel__position-label {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: var(--gc-text-muted);
}

.gc-paper-trade-panel__position strong {
	font-size: 13px;
	font-weight: 800;
	color: var(--gc-text);
}

.gc-paper-trade-panel__position-meta {
	display: flex;
	flex-wrap: wrap;
	gap: 6px 10px;
	font-size: 11px;
	color: var(--gc-text-muted);
	font-variant-numeric: tabular-nums;
}

.gc-paper-trade-panel__position--idle {
	background: var(--gc-surface-sub);
	color: var(--gc-text-muted);
	font-size: 11px;
	font-weight: 600;
}

.gc-paper-trade-panel__journal-list {
	display: grid;
	gap: 8px;
}

.gc-paper-trade-panel__journal-item {
	display: grid;
	gap: 5px;
	padding: 10px 11px;
	border-radius: 12px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
}

.gc-paper-trade-panel__journal-item--positive {
	border-color: rgba(16, 185, 129, 0.3);
	box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.08) inset;
}

.gc-paper-trade-panel__journal-item--negative {
	border-color: rgba(239, 68, 68, 0.3);
	box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.08) inset;
}

.gc-paper-trade-panel__journal-top,
.gc-paper-trade-panel__journal-meta {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	font-size: 11px;
	font-variant-numeric: tabular-nums;
	color: var(--gc-text-muted);
	flex-wrap: wrap;
}

.gc-paper-trade-panel__journal-top strong {
	font-size: 12px;
	font-weight: 800;
	color: var(--gc-text);
}

.gc-paper-trade-panel__journal-empty {
	padding: 12px 10px;
	border-radius: 12px;
	border: 1px dashed var(--gc-border-mid);
	background: rgba(15, 23, 42, 0.35);
	color: var(--gc-text-muted);
	font-size: 11px;
	line-height: 1.5;
}

.gc-theme-toggle {
	width: 28px;
	height: 28px;
	justify-content: center;
	padding: 0;
}

.vnsc-candle-type-select {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	min-width: 110px;
	height: 28px;
	padding: 0 20px 0 8px;
	border: 1px solid transparent;
	border-radius: var(--gc-radius-btn);
	background-color: transparent;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: right 8px center;
	color: var(--gc-text);
	font-family: var(--gc-font);
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 120ms, color 120ms;
}

.vnsc-candle-type-select:hover {
	background-color: var(--gc-surface-sub);
}

.vnsc-candle-type-select:focus-visible {
	outline: none;
	background-color: var(--gc-surface-sub);
}

.vnsc-candle-type-select--tf {
	min-width: 54px;
	padding: 0 16px 0 8px;
	background-position: right 6px center;
}

.gc-source-label-btn {
	display: inline-flex;
	align-items: center;
	gap: 2px;
	height: 28px;
	padding: 0 8px;
	border: 1px solid var(--gc-border);
	border-radius: var(--gc-radius-btn);
	background: var(--gc-surface);
	color: var(--gc-text);
	font-family: var(--gc-font);
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	white-space: nowrap;
}

.gc-source-label-btn:hover {
	background: var(--gc-surface-sub);
}

.gc-chart-type-wrap {
	position: relative;
}

.gc-chart-type-btn {
	display: inline-flex;
	align-items: center;
}

.gc-chart-type-menu {
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	z-index: 220;
	min-width: 170px;
	padding: 4px;
	border-radius: 8px;
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-surface);
	box-shadow: 0 8px 24px rgba(17, 24, 39, 0.16);
}

.gc-chart-type-menu--right {
	left: auto;
	right: 0;
}

.gc-chart-type-item {
	width: 100%;
	appearance: none;
	border: none;
	background: transparent;
	color: var(--gc-text);
	font-family: var(--gc-font);
	font-size: 12.5px;
	padding: 7px 10px;
	border-radius: var(--gc-radius-btn);
	text-align: left;
	cursor: pointer;
	display: flex;
	align-items: center;
}

.gc-chart-type-item:hover {
	background: var(--gc-surface-sub);
}

.gc-chart-type-item--active {
	color: var(--gc-accent);
	font-weight: 600;
}

.gc-chart-type-item--inline {
	width: auto;
	padding: 6px 10px;
}

.gc-profile-menu__lang-row {
	display: flex;
	gap: 2px;
	padding: 2px 4px;
}

.gc-profile-menu__section-label {
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 6px 10px 2px;
	font-size: 11px;
	font-weight: 600;
	color: var(--gc-text-soft);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.gc-profile-menu__divider {
	height: 1px;
	margin: 4px 0;
	background: var(--gc-border);
}

/* Icon + text alignment for profile menu items */
.gc-profile-menu .gc-chart-type-item {
	gap: 8px;
}

.gc-profile-menu .gc-chart-type-item svg {
	flex-shrink: 0;
	opacity: 0.75;
}

.gc-version-text {
	font-size: 11px;
	color: var(--gc-text-micro);
}

.gc-live-badge {
	font-size: 10.5px;
	font-weight: 700;
	color: var(--gc-up);
	background: var(--gc-accent-bg);
	border: 1px solid var(--gc-border-mid);
	padding: 3px 8px;
	border-radius: 999px;
	white-space: nowrap;
}

.gc-offline-badge {
	font-size: 10.5px;
	font-weight: 600;
	color: var(--demo-warning, #fb923c);
	background: var(--gc-surface-sub);
	border: 1px solid var(--gc-border-mid);
	padding: 3px 8px;
	border-radius: 999px;
	cursor: help;
	white-space: nowrap;
}

.gc-loading-badge {
	font-size: 10.5px;
	color: var(--gc-text-muted);
	white-space: nowrap;
}

.gc-upgrade-btn {
	appearance: none;
	border: none;
	background: #6e3fef;
	color: #fff;
	font-size: 11.5px;
	font-weight: 700;
	padding: 6px 14px;
	border-radius: 999px;
	cursor: pointer;
	transition: opacity 120ms;
}

.gc-upgrade-btn:hover {
	opacity: 0.9;
}

.gc-main {
	display: grid;
	grid-template-columns: var(--gc-context-rail-w, 240px) var(--gc-toolbar-w) minmax(0, 1fr);
	grid-template-rows: minmax(0, 1fr);
	min-height: 0;
	overflow: hidden;
	position: relative;
	/* GAP 1 FIX: Contain layout/style/paint to prevent layout trashing */
	contain: layout style paint;
}

/* Context rail collapsed state */
.gc-main:has(.gc-context-rail--collapsed) {
	grid-template-columns: var(--gc-context-rail-collapsed-w, 48px) var(--gc-toolbar-w) minmax(0, 1fr);
}

/* Mobile: context rail becomes overlay */
@media (max-width: 768px) {
	.gc-main {
		grid-template-columns: var(--gc-toolbar-w) minmax(0, 1fr);
	}
	
	.gc-main:has(.gc-context-rail--open) {
		grid-template-columns: var(--gc-toolbar-w) minmax(0, 1fr);
	}
}

.gc-tools {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: var(--gc-toolbar-w);
	border-right: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
	gap: 3px;
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-width: thin;
	scrollbar-color: color-mix(in srgb, var(--gc-border-mid) 86%, transparent) transparent;
}

.gc-tools-shell {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: var(--gc-toolbar-w);
	z-index: 360;
	overflow: visible;
	transition: width var(--gc-toolbar-motion-default) ease;
}

.gc-tools-handle {
	display: none;
}

@media (min-width: 768px) and (hover: hover) and (pointer: fine) {
	.gc-tools-shell {
		width: var(--gc-toolbar-handle-w);
		pointer-events: none;
		z-index: 360;
	}

	.gc-tools {
		left: calc(-1 * var(--gc-toolbar-w));
		overflow: visible;
		border-right-color: transparent;
		box-shadow: none;
		pointer-events: auto;
		z-index: 3;
		transition: left var(--gc-toolbar-motion-default) ease, box-shadow var(--gc-toolbar-motion-default) ease, border-color var(--gc-toolbar-motion-default) ease;
	}

	.gc-tools-shell:hover .gc-tools,
	.gc-tools:hover,
	.gc-tools:focus-within,
	.gc-tools-shell:focus-within .gc-tools {
		left: 0;
		box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
		border-right-color: var(--gc-border);
	}

	.gc-tools-handle {
		display: flex;
		position: absolute;
		top: 50%;
		left: 0;
		width: var(--gc-toolbar-handle-w);
		height: var(--gc-toolbar-handle-h);
		transform: translateY(-50%);
		align-items: center;
		justify-content: center;
		border-radius: 0 999px 999px 0;
		border: 1px solid color-mix(in srgb, var(--gc-border-mid) 100%, transparent);
		border-left: none;
		background: linear-gradient(
			180deg,
			color-mix(in srgb, var(--gc-surface) 92%, var(--gc-accent) 8%),
			color-mix(in srgb, var(--gc-surface-sub) 88%, var(--gc-accent) 12%)
		);
		box-shadow: 6px 10px 22px rgba(15, 23, 42, 0.16);
		pointer-events: auto;
		opacity: 1;
		z-index: 2;
		transition: opacity var(--gc-toolbar-motion-fast) ease, transform var(--gc-toolbar-motion-fast) ease, box-shadow var(--gc-toolbar-motion-fast) ease;
	}

	.gc-tools-handle::before {
		content: "";
		width: 3px;
		height: 3px;
		border-radius: 999px;
		background: color-mix(in srgb, var(--gc-text-muted) 82%, white 18%);
		box-shadow:
			0 -6px 0 color-mix(in srgb, var(--gc-text-muted) 82%, white 18%),
			0 6px 0 color-mix(in srgb, var(--gc-text-muted) 82%, white 18%);
	}

	.gc-tools-shell:hover .gc-tools-handle,
	.gc-tools-shell:focus-within .gc-tools-handle {
		box-shadow: 8px 12px 24px rgba(15, 23, 42, 0.2);
	}

}

.gc-tools-group {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--gc-toolbar-section-gap);
}

.rsc-toolbar-divider {
	width: 24px;
	height: 1px;
	margin: 5px 0;
	background: rgba(148, 163, 184, 0.28);
}

.gc-tool-btn {
	appearance: none;
	border: 1px solid transparent;
	background: transparent;
	color: var(--gc-text-muted);
	width: var(--gc-toolbar-button-size);
	height: var(--gc-toolbar-button-size);
	padding: 0;
	display: grid;
	place-items: center;
	border-radius: 9px;
	cursor: pointer;
	transition: background 100ms, color 100ms, border-color 100ms, transform 100ms;
}

.gc-tool-btn:hover {
	transform: translateY(-1px);
}

/* PRIORITY 3 FIX: Focus visible outline for accessibility */
.gc-tool-btn:focus-visible {
	outline: 2px solid var(--gc-accent);
	outline-offset: 2px;
}

.gc-tool-btn--active {
	background: linear-gradient(180deg, var(--gc-accent-bg), color-mix(in srgb, var(--gc-accent-bg) 68%, transparent));
	color: var(--gc-accent);
	border-color: color-mix(in srgb, var(--gc-accent) 38%, transparent);
	box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--gc-accent) 16%, transparent);
}

.gc-chart-area {
	position: absolute;
	inset: 0 0 0 var(--gc-toolbar-w);
	min-width: 0;
	min-height: 0;
	display: grid;
	grid-template-rows: 32px minmax(0, 1fr);
	background: var(--gc-surface);
	overflow: hidden;
}

@media (min-width: 768px) and (hover: hover) and (pointer: fine) {
	.gc-chart-area {
		inset: 0;
	}
}

.gc-ohlc-strip {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 0 12px;
	font-size: 11.5px;
	color: var(--gc-text-muted);
	border-bottom: 1px solid var(--gc-border);
	white-space: nowrap;
	overflow: hidden;
	transition: padding-left var(--gc-toolbar-motion-default, 150ms) ease;
}

@media (min-width: 768px) and (hover: hover) and (pointer: fine) {
	.gc-ohlc-strip {
		padding-left: calc(var(--gc-toolbar-handle-w, 24px) + 12px);
	}
	.gc-tools-shell:hover ~ .gc-chart-area .gc-ohlc-strip,
	.gc-tools-shell:focus-within ~ .gc-chart-area .gc-ohlc-strip {
		padding-left: calc(var(--gc-toolbar-w, 56px) + 12px);
	}
}

.gc-ohlc-pair {
	font-weight: 600;
	color: var(--gc-text);
}

.gc-ohlc-tf {
	font-weight: 400;
	color: var(--gc-text-muted);
}

.gc-ohlc-item b {
	font-weight: 600;
	color: var(--gc-text);
	margin-left: 2px;
}

.gc-ohlc-vol {
	color: var(--gc-text-micro);
}

.gc-col-up {
	color: var(--gc-up) !important;
}

.gc-col-dn {
	color: var(--gc-dn) !important;
}

.gc-chart-shell {
	min-height: 0;
	height: 100%;
	overflow: hidden;
	background: var(--gc-surface);
	position: relative;
}

.gc-vni-panel {
	display: grid;
	gap: 10px;
	padding: 10px 12px;
	border-bottom: 1px solid var(--gc-border);
	background: linear-gradient(180deg, rgba(41, 98, 255, 0.08), rgba(41, 98, 255, 0.02));
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
}

.gc-vni-panel__row {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	min-width: 0;
}

.gc-vni-panel__error {
	font-size: 12px;
	color: var(--gc-dn);
	line-height: 1.35;
}

.gc-symbol-search {
	position: relative;
	min-width: min(280px, 100%);
	flex: 1 1 280px;
}

/* In topbar, constrain to compact inline width */
.gc-symbol-block .gc-symbol-search {
	flex: 0 1 180px;
	min-width: 120px;
}

.gc-symbol-search__input,
.gc-form-input {
	width: 100%;
	box-sizing: border-box;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface);
	color: var(--gc-text);
	font: inherit;
	font-size: 12px;
	line-height: 1.4;
	padding: 8px 10px;
	border-radius: 6px;
	outline: none;
	transition: border-color 100ms ease, box-shadow 100ms ease;
}

/* Compact height when inside topbar symbol block */
.gc-symbol-block .gc-symbol-search__input {
	height: 28px;
	padding: 0 8px;
	box-sizing: border-box;
}

.gc-symbol-search__input:focus,
.gc-form-input:focus {
	border-color: var(--gc-accent);
	box-shadow: 0 0 0 2px rgba(41, 98, 255, 0.12);
}

.gc-symbol-search__dropdown {
	position: absolute;
	z-index: 22;
	top: calc(100% + 6px);
	left: 0;
	right: 0;
	margin: 0;
	padding: 0;
	list-style: none;
	border: 1px solid var(--gc-border-mid);
	border-radius: 10px;
	background: var(--gc-surface);
	box-shadow: 0 20px 40px rgba(2, 6, 23, 0.2);
	max-height: 320px;
	overflow: auto;
}

/* Inner ul inside results panel */
.gc-symbol-search__dropdown ul {
	margin: 0;
	padding: 6px;
	list-style: none;
}

.gc-symbol-search__item {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	padding: 8px 10px;
	border-radius: 8px;
	cursor: pointer;
	color: var(--gc-text-muted);
	font-size: 12px;
	transition: background 100ms ease, color 100ms ease;
}

.gc-symbol-search__item:hover,
.gc-symbol-search__item--highlighted {
	background: var(--gc-surface-sub);
	color: var(--gc-text);
}

.gc-symbol-search__symbol {
	font-weight: 700;
	color: inherit;
}

.gc-symbol-search__name {
	font-size: 11px;
	color: inherit;
}

/* M-02: Exchange filter bar inside dropdown */
.gc-symbol-search__exchange-bar {
	display: flex;
	gap: 4px;
	padding: 6px 8px 4px;
	border-bottom: 1px solid var(--gc-border);
}

.gc-symbol-search__ex-btn {
	padding: 2px 8px;
	border-radius: 4px;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 11px;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
}

.gc-symbol-search__ex-btn:hover {
	background: var(--gc-bg-active);
	color: var(--gc-text);
}

.gc-symbol-search__ex-btn--active {
	background: var(--gc-accent, #3b82f6);
	border-color: var(--gc-accent, #3b82f6);
	color: #fff;
}

/* Exchange badge in result rows */
.gc-symbol-search__ex-badge {
	font-size: 9px;
	font-weight: 700;
	padding: 1px 4px;
	border-radius: 3px;
	background: var(--gc-bg-active);
	color: var(--gc-text-muted);
	flex-shrink: 0;
}

.gc-symbol-search__ex-badge--hose { background: rgba(16, 185, 129, 0.18); color: #10b981; }
.gc-symbol-search__ex-badge--hnx { background: rgba(59, 130, 246, 0.18); color: #3b82f6; }
.gc-symbol-search__ex-badge--upcom { background: rgba(245, 158, 11, 0.18); color: #f59e0b; }

/* M-03/M-04: Empty-query panel sections */
.gc-symbol-search__section {
	padding: 6px 8px 4px;
}

.gc-symbol-search__section + .gc-symbol-search__section {
	border-top: 1px solid var(--gc-border);
}

.gc-symbol-search__section-label {
	font-size: 10px;
	font-weight: 700;
	color: var(--gc-text-muted);
	text-transform: uppercase;
	letter-spacing: 0.06em;
	margin-bottom: 5px;
}

.gc-symbol-search__chip-row {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
}

.gc-symbol-search__chip {
	padding: 2px 7px;
	border-radius: 4px;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text);
	font-size: 11px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.12s;
}

.gc-symbol-search__chip:hover {
	background: var(--gc-bg-active);
}

.gc-symbol-search__chip--vn30 {
	border-color: rgba(16, 185, 129, 0.35);
	color: #10b981;
}

.gc-symbol-search__chip--vn30:hover {
	background: rgba(16, 185, 129, 0.12);
}

/* M-05: Top bar company breadcrumb */
.gc-symbol-breadcrumb {
	display: flex;
	align-items: center;
	gap: 5px;
	max-width: 220px;
	overflow: hidden;
}

.gc-symbol-ex-badge {
	font-size: 9px;
	font-weight: 700;
	padding: 1px 5px;
	border-radius: 3px;
	background: var(--gc-bg-active);
	color: var(--gc-text-muted);
	flex-shrink: 0;
}

.gc-symbol-ex-badge--hose { background: rgba(16, 185, 129, 0.18); color: #10b981; }
.gc-symbol-ex-badge--hnx { background: rgba(59, 130, 246, 0.18); color: #3b82f6; }
.gc-symbol-ex-badge--upcom { background: rgba(245, 158, 11, 0.18); color: #f59e0b; }

.gc-symbol-company-name {
	font-size: 11px;
	color: var(--gc-text-muted);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.gc-whale-panel {
	display: grid;
	gap: 8px;
	padding: 10px 12px;
	border: 1px solid var(--gc-border);
	border-radius: 10px;
	background: rgba(15, 23, 42, 0.04);
	min-width: min(420px, 100%);
}

.gc-whale-panel--empty {
	color: var(--gc-text-muted);
	font-size: 12px;
	min-width: 0;
}

.gc-whale-panel__title {
	font-size: 12px;
	font-weight: 700;
	color: var(--gc-text);
}

.gc-whale-panel__net {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: 10px;
	padding: 8px 10px;
	border-radius: 8px;
	background: var(--gc-surface-sub);
	font-size: 12px;
	font-weight: 600;
}

.gc-whale-panel__net[data-positive="true"] {
	color: var(--gc-up);
}

.gc-whale-panel__net[data-positive="false"] {
	color: var(--gc-dn);
}

.gc-whale-panel__net-value {
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}

.gc-whale-panel__table {
	width: 100%;
	border-collapse: collapse;
	font-size: 11.5px;
	color: var(--gc-text-muted);
}

.gc-whale-panel__table th,
.gc-whale-panel__table td {
	padding: 5px 0;
	text-align: right;
	font-variant-numeric: tabular-nums;
}

.gc-whale-panel__table th:first-child,
.gc-whale-panel__table td:first-child {
	text-align: left;
}

.gc-whale-panel__row-label {
	color: var(--gc-text);
	font-weight: 600;
}

.gc-whale-panel__buy {
	color: var(--gc-up);
}

.gc-whale-panel__sell {
	color: var(--gc-dn);
}

.gc-form-label {
	display: inline-block;
	font-size: 11px;
	font-weight: 600;
	color: var(--gc-text-muted);
	margin-bottom: 6px;
}

.gc-btn {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	font: inherit;
	font-size: 12px;
	padding: 8px 12px;
	border-radius: 6px;
	cursor: pointer;
	transition: background 100ms ease, color 100ms ease, border-color 100ms ease;
}

.gc-btn:hover {
	background: var(--gc-surface-sub);
	color: var(--gc-text);
}

.gc-btn--primary {
	background: var(--gc-accent);
	border-color: var(--gc-accent);
	color: #fff;
}

.gc-btn--primary:hover {
	background: color-mix(in srgb, var(--gc-accent) 88%, black);
	border-color: var(--gc-accent);
	color: #fff;
}

.gc-btn--ghost {
	background: transparent;
}

.gc-form-feedback {
	padding: 10px 12px;
	border-radius: 8px;
	font-size: 12px;
	line-height: 1.4;
	border: 1px solid transparent;
}

.gc-form-feedback--success {
	color: var(--gc-up);
	background: rgba(0, 166, 81, 0.08);
	border-color: rgba(0, 166, 81, 0.18);
}

.gc-form-feedback--error {
	color: var(--gc-dn);
	background: rgba(239, 68, 68, 0.08);
	border-color: rgba(239, 68, 68, 0.18);
}

.gc-modal-backdrop {
	position: fixed;
	inset: 0;
	z-index: var(--vnsc-z-modal-backdrop);
	display: grid;
	place-items: center;
	padding: 24px;
	background: rgba(2, 6, 23, 0.62);
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
}

.gc-modal {
	width: min(640px, 100%);
	max-height: min(88vh, 860px);
	display: grid;
	grid-template-rows: auto auto minmax(0, 1fr);
	border-radius: 18px;
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-surface);
	box-shadow: 0 28px 80px rgba(2, 6, 23, 0.42);
	overflow: hidden;
}

.gc-pat-modal {
	width: min(560px, 100%);
}

.gc-modal__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 16px 18px 12px;
	border-bottom: 1px solid var(--gc-border);
}

.gc-modal__title {
	font-size: 15px;
	font-weight: 700;
	color: var(--gc-text);
	letter-spacing: -0.01em;
}

.gc-modal__close {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	width: 30px;
	height: 30px;
	border-radius: 8px;
	cursor: pointer;
	transition: background 100ms ease, color 100ms ease, border-color 100ms ease;
}

.gc-modal__close:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.gc-modal__tabs {
	display: flex;
	gap: 6px;
	padding: 10px 18px 0;
	border-bottom: 1px solid var(--gc-border);
	background: linear-gradient(180deg, rgba(15, 23, 42, 0.06), transparent);
}

.gc-modal__tab {
	appearance: none;
	border: 1px solid var(--gc-border);
	border-bottom-color: transparent;
	background: transparent;
	color: var(--gc-text-muted);
	font: inherit;
	font-size: 12px;
	font-weight: 600;
	padding: 8px 12px;
	border-radius: 10px 10px 0 0;
	cursor: pointer;
	transform: translateY(1px);
}

.gc-modal__tab--active {
	background: var(--gc-surface);
	color: var(--gc-text);
	border-color: var(--gc-border-mid);
	border-bottom-color: var(--gc-surface);
	font-weight: 700;
}

.gc-modal__body {
	display: grid;
	gap: 14px;
	padding: 18px;
	overflow: auto;
	min-height: 0;
}

.gc-pat-tab,
.gc-login-tab,
.gc-pat-offline {
	display: grid;
	gap: 10px;
}

.gc-pat-offline__hint {
	font-size: 11px;
	color: var(--gc-text-muted);
	margin: 0;
}

.gc-pat-offline__loaded {
	font-size: 12px;
	color: var(--gc-text-muted);
	max-width: 220px;
	truncate: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.gc-pat-source-info {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	padding: 10px 12px;
	border-radius: 8px;
	background: var(--gc-surface-sub, rgba(37,99,235,0.07));
	color: var(--gc-text-muted);
	font-size: 12.5px;
}

.gc-pat-tab__actions {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-top: 4px;
}

.rsc-drawing-storage-toolbar,
.rsc-drawing-dock,
.rsc-drawing-inspector,
.rsc-drawing-list-panel {
	position: absolute;
	z-index: 36;
	backdrop-filter: blur(18px);
	-webkit-backdrop-filter: blur(18px);
}

.rsc-drawing-dock {
	width: min(364px, calc(100vw - 32px));
	border-radius: calc(var(--gc-radius) + 2px);
	border: 1px solid var(--gc-border-mid);
	background: color-mix(in srgb, var(--gc-surface) 92%, transparent);
	box-shadow: 0 12px 34px rgba(2, 6, 23, 0.34);
	color: var(--gc-text);
	display: grid;
	grid-template-rows: auto auto minmax(0, 1fr);
	overflow: hidden;
	max-height: calc(100% - 32px);
}

.rsc-drawing-dock__header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 14px 10px;
	border-bottom: 1px solid var(--gc-border);
	background: color-mix(in srgb, var(--gc-surface-sub) 86%, transparent);
}

.rsc-drawing-dock__title-block {
	display: grid;
	gap: 3px;
	min-width: 0;
}

.rsc-drawing-dock__title-block strong {
	font-size: 13px;
	font-weight: 700;
	letter-spacing: 0.01em;
	color: var(--gc-text);
}

.rsc-drawing-dock__title-block span {
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--gc-text-muted);
}

.rsc-drawing-dock__header-actions {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.rsc-drawing-dock__icon,
.rsc-drawing-dock__tab {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	cursor: pointer;
	transition: background 100ms ease, color 100ms ease, border-color 100ms ease;
}

.rsc-drawing-dock__icon {
	width: 28px;
	height: 28px;
	border-radius: 5px;
	font-size: 12px;
	font-weight: 700;
}

.rsc-drawing-dock__tabs {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 6px;
	padding: 10px 14px 0;
}

.rsc-drawing-dock__tab {
	border-radius: 999px;
	padding: 7px 10px;
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	white-space: nowrap;
}

.rsc-drawing-dock__tab--active {
	border-color: var(--gc-accent);
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
}

.rsc-drawing-dock__icon:hover,
.rsc-drawing-dock__tab:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.rsc-drawing-dock__body {
	min-height: 0;
	overflow: auto;
	padding: 12px 14px 14px;
	overscroll-behavior: contain;
}

.rsc-drawing-dock__stack {
	display: grid;
	gap: 12px;
}

.rsc-drawing-dock__empty {
	padding: 14px;
	border-radius: var(--gc-radius);
	border: 1px dashed var(--gc-border-mid);
	background: var(--gc-surface-sub);
	color: var(--gc-text-muted);
	font-size: 13px;
	line-height: 1.5;
}

.rsc-drawing-point-legend {
	display: grid;
	gap: 10px;
	padding: 12px 14px 14px;
	border-radius: calc(var(--gc-radius) + 1px);
	border: 1px solid var(--gc-border-mid);
	background: color-mix(in srgb, var(--gc-surface-sub) 72%, transparent);
}

.rsc-drawing-point-legend--empty {
	color: var(--gc-text-muted);
	font-size: 12px;
	line-height: 1.5;
	padding: 12px 14px 14px;
}

.rsc-drawing-point-legend__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.rsc-drawing-point-legend__header strong {
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.rsc-drawing-point-legend__clear {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	border-radius: 999px;
	padding: 5px 10px;
	font-size: 10px;
	font-weight: 700;
	cursor: pointer;
}

.rsc-drawing-point-legend__clear:hover {
	color: var(--gc-text);
	background: var(--gc-surface);
	border-color: var(--gc-border-mid);
}

.rsc-drawing-point-legend__hint {
	color: var(--gc-text-muted);
	font-size: 11px;
	line-height: 1.5;
}

.rsc-drawing-point-legend__items {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(74px, 1fr));
	gap: 8px;
}

.rsc-drawing-point-legend__item {
	appearance: none;
	border: 1px solid var(--gc-border);
	border-radius: 10px;
	background: rgba(15, 23, 42, 0.36);
	color: var(--gc-text);
	padding: 9px 10px;
	display: grid;
	gap: 5px;
	justify-items: center;
	cursor: pointer;
	transition: transform 120ms ease, background 120ms ease, border-color 120ms ease, box-shadow 120ms ease;
}

.rsc-drawing-point-legend__item:hover,
.rsc-drawing-point-legend__item:focus-visible,
.rsc-drawing-point-legend__item--active {
	background: var(--gc-accent-bg);
	border-color: var(--gc-accent);
	box-shadow: 0 0 0 1px color-mix(in srgb, var(--gc-accent) 55%, transparent);
	transform: translateY(-1px);
}

.rsc-drawing-point-legend__index {
	font-size: 11px;
	font-weight: 800;
	letter-spacing: 0.04em;
	color: var(--gc-text-muted);
	text-transform: uppercase;
}

.rsc-drawing-point-legend__label {
	font-size: 12px;
	font-weight: 700;
	color: var(--gc-text);
}

.rsc-drawing-storage-toolbar {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 6px 8px;
	border-radius: var(--gc-radius);
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-surface);
	box-shadow: 0 4px 16px rgba(2, 6, 23, 0.24);
	flex-wrap: wrap;
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
}

.rsc-drawing-storage-toolbar__button {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.02em;
	padding: 5px 9px;
	border-radius: 5px;
	cursor: pointer;
	transition: background 100ms ease, color 100ms ease, border-color 100ms ease;
}

.rsc-drawing-storage-toolbar__button:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.rsc-drawing-inspector,
.rsc-drawing-list-panel {
	width: min(348px, calc(100vw - 32px));
	border-radius: var(--gc-radius);
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-surface);
	box-shadow: 0 8px 28px rgba(2, 6, 23, 0.32);
	color: var(--gc-text);
	padding: 14px;
	display: grid;
	gap: 14px;
	max-height: calc(100% - 32px);
	overflow: auto;
	overscroll-behavior: contain;
}

.rsc-drawing-inspector--embedded,
.rsc-drawing-list-panel--embedded {
	position: static;
	z-index: auto;
	width: auto;
	max-height: none;
	overflow: visible;
	padding: 0;
	border: none;
	background: transparent;
	box-shadow: none;
	backdrop-filter: none;
	-webkit-backdrop-filter: none;
}

.rsc-drawing-inspector--embedded .rsc-drawing-inspector__header,
.rsc-drawing-list-panel--embedded .rsc-drawing-list-panel__header {
	display: none;
}

.rsc-drawing-inspector__header,
.rsc-drawing-list-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}

.rsc-drawing-inspector__title {
	display: grid;
	gap: 4px;
	min-width: 0;
}

.rsc-drawing-inspector__title strong,
.rsc-drawing-list-panel__header strong {
	font-size: 13px;
	font-weight: 700;
	color: var(--gc-text);
	letter-spacing: 0.01em;
}

.rsc-drawing-inspector__title span,
.rsc-drawing-list-panel__header span {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.1em;
	color: var(--gc-text-muted);
}

.rsc-drawing-inspector__icon,
.rsc-drawing-list-panel__icon {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	width: 28px;
	height: 28px;
	border-radius: 5px;
	cursor: pointer;
	transition: background 100ms ease, color 100ms ease, border-color 100ms ease;
}

.rsc-drawing-inspector__icon:hover,
.rsc-drawing-list-panel__icon:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.rsc-drawing-inspector__swatches {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
}

.rsc-drawing-inspector__field {
	display: grid;
	gap: 8px;
	color: var(--gc-text-muted);
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
}

.rsc-drawing-inspector__field label {
	display: grid;
	gap: 8px;
}

.rsc-drawing-inspector__field input[type="color"] {
	appearance: none;
	width: 100%;
	height: 36px;
	border: 1px solid var(--gc-border);
	border-radius: var(--gc-radius);
	background: var(--gc-surface-sub);
	padding: 3px;
	cursor: pointer;
}

.rsc-drawing-inspector__field input[type="range"] {
	width: 100%;
	accent-color: var(--gc-accent);
}

.rsc-drawing-inspector__field select {
	appearance: none;
	width: 100%;
	border: 1px solid var(--gc-border);
	border-radius: var(--gc-radius);
	background: var(--gc-surface-sub);
	color: var(--gc-text);
	padding: 8px 10px;
	font-size: 12px;
}

.rsc-drawing-inspector__actions {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
}

.rsc-drawing-inspector__button {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	border-radius: var(--gc-radius);
	padding: 8px 10px;
	font-size: 11.5px;
	font-weight: 600;
	cursor: pointer;
	transition: background 100ms ease, border-color 100ms ease, color 100ms ease;
}

.rsc-drawing-inspector__button:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.rsc-drawing-inspector__button:disabled {
	opacity: 0.42;
	cursor: default;
	transform: none;
}

.rsc-drawing-inspector__button--danger {
	grid-column: 1 / -1;
	border-color: rgba(239, 68, 68, 0.28);
	background: rgba(239, 68, 68, 0.1);
	color: #fecaca;
}

.rsc-drawing-inspector__button--danger:hover {
	background: rgba(239, 68, 68, 0.18);
	border-color: rgba(239, 68, 68, 0.38);
	color: #fff1f2;
}

/* Drawing list panel: flex layout with sticky header + scrollable items */
.rsc-drawing-list-panel {
	display: flex;
	flex-direction: column;
	max-height: min(560px, calc(100vh - 160px));
	overflow: hidden;
	padding: 0;
	gap: 0;
}

.rsc-drawing-list-panel--embedded {
	gap: 0;
	max-height: none;
	min-height: 0;
}

.rsc-drawing-list-panel--embedded .rsc-drawing-list-panel__items {
	padding: 0;
}

.rsc-drawing-list-panel--embedded .rsc-drawing-list-panel__empty {
	margin: 0;
}

.rsc-drawing-list-panel__header {
	flex-shrink: 0;
	padding: 12px 14px;
	border-bottom: 1px solid var(--gc-border);
}

.rsc-drawing-list-panel__items {
	display: grid;
	gap: 8px;
	overflow-y: auto;
	overflow-x: hidden;
	overscroll-behavior: contain;
	flex: 1 1 auto;
	min-height: 0;
	padding: 10px 14px 12px;
	scrollbar-width: thin;
	scrollbar-color: var(--gc-border-mid) transparent;
}

.rsc-drawing-list-panel__items::-webkit-scrollbar {
	width: 4px;
}

.rsc-drawing-list-panel__items::-webkit-scrollbar-track {
	background: transparent;
}

.rsc-drawing-list-panel__items::-webkit-scrollbar-thumb {
	background: var(--gc-border-mid);
	border-radius: 4px;
}

.rsc-drawing-list-panel__empty {
	margin: 10px 14px 12px;
	padding: 16px 14px;
	border-radius: var(--gc-radius);
	border: 1px dashed var(--gc-border-mid);
	background: var(--gc-surface-sub);
	color: var(--gc-text-muted);
	font-size: 13px;
	line-height: 1.5;
}

.rsc-drawing-list-panel__item {
	display: grid;
	gap: 10px;
	padding: 12px;
	border-radius: var(--gc-radius);
	border: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
	transition: border-color 120ms ease;
}

.rsc-drawing-list-panel__item--selected {
	border-color: var(--gc-accent);
	box-shadow: 0 0 0 1px var(--gc-accent-bg) inset;
}

.rsc-drawing-list-panel__select {
	appearance: none;
	border: none;
	background: transparent;
	padding: 0;
	text-align: left;
	cursor: pointer;
	display: grid;
	gap: 4px;
	color: inherit;
}

.rsc-drawing-list-panel__label {
	font-size: 13px;
	font-weight: 700;
	color: var(--gc-text);
	letter-spacing: 0.01em;
}

.rsc-drawing-list-panel__meta {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--gc-text-muted);
}

.rsc-drawing-list-panel__actions {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	align-items: center;
}

.rsc-drawing-list-panel__badge {
	display: inline-flex;
	align-items: center;
	padding: 4px 9px;
	border-radius: 999px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--gc-text-muted);
}

.rsc-drawing-list-panel__icon {
	width: auto;
	height: auto;
	padding: 5px 10px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.08em;
}

.rsc-long-tp-zone {
	fill: rgba(34, 197, 94, 0.16);
}

.rsc-long-sl-zone {
	fill: rgba(239, 68, 68, 0.16);
}

.rsc-short-tp-zone {
	fill: rgba(239, 68, 68, 0.16);
}

.rsc-short-sl-zone {
	fill: rgba(34, 197, 94, 0.16);
}

.rsc-rr-badge {
	font-family: "Segoe UI Variable Text", "Aptos", "Segoe UI", sans-serif;
	font-size: 11px;
	font-weight: 800;
	letter-spacing: 0.08em;
	fill: #e2e8f0;
}

.gc-chart-placeholder {
	height: 100%;
	display: grid;
	place-items: center;
	color: var(--gc-text-muted);
	font-size: 13px;
}

.gc-chart-loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
}

.gc-spinner {
	width: 28px;
	height: 28px;
	border: 3px solid var(--gc-border);
	border-top-color: var(--gc-accent);
	border-radius: 50%;
	animation: gc-spin 0.7s linear infinite;
}

.gc-spinner--sm {
	width: 16px;
	height: 16px;
	border-width: 2px;
}

/* N-06: Shimmer overlay for VNI backfill / range reload while chart is visible */
.gc-vni-backfill-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	background: rgba(0, 0, 0, 0.18);
	color: var(--gc-text);
	font-size: 12px;
	pointer-events: none;
	z-index: 20;
}

/* ── Dark Flow Strength Badge (H-04) ─────────────────────────────────────── */
.gc-darkflow-badge {
	position: absolute;
	top: 8px;
	right: 72px; /* clear the y-axis */
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 3px 8px;
	border-radius: 4px;
	font-size: 11px;
	font-weight: 600;
	pointer-events: none;
	z-index: 6;
	background: rgba(0, 0, 0, 0.5);
	color: #ccc;
	border: 1px solid rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(4px);
}

.gc-darkflow-badge__label {
	opacity: 0.7;
	font-weight: 400;
}

.gc-darkflow-badge__strength {
	font-size: 13px;
}

.gc-darkflow-badge__tier,
.gc-darkflow-badge__sig {
	font-size: 10px;
	opacity: 0.85;
}

.gc-darkflow-badge--strong {
	color: #ff5252;
	border-color: rgba(255, 82, 82, 0.4);
}

.gc-darkflow-badge--mid {
	color: #29b6f6;
	border-color: rgba(41, 182, 246, 0.4);
}

.gc-darkflow-badge--low {
	color: #ffb300;
	border-color: rgba(255, 179, 0, 0.35);
}

.gc-darkflow-badge--none {
	color: #888;
	border-color: rgba(136, 136, 136, 0.25);
}

@keyframes gc-spin {
	to { transform: rotate(360deg); }
}

.gc-row {
	display: flex;
	flex-wrap: wrap;
}

.gc-gap4 {
	gap: 4px;
}

.gc-btn {
	appearance: none;
	border: 1px solid var(--gc-border-mid);
	background: var(--gc-surface);
	color: var(--gc-text);
	font-size: 11px;
	padding: 5px 9px;
	border-radius: var(--gc-radius);
	cursor: pointer;
	transition: background 100ms;
	white-space: nowrap;
}

.gc-btn:hover {
	background: var(--gc-border);
}

.gc-btn:disabled {
	opacity: 0.4;
	cursor: default;
}

.gc-btn--accent {
	background: var(--gc-accent);
	border-color: var(--gc-accent);
	color: #fff;
}

.gc-btn--accent:hover {
	opacity: 0.9;
}

.gc-btn--danger {
	color: #fecaca;
	border-color: rgba(239, 68, 68, 0.28);
	background: rgba(239, 68, 68, 0.1);
}

.gc-btn--danger:hover {
	background: rgba(239, 68, 68, 0.18);
	color: #fff1f2;
}


.gc-bottombar {
	display: flex;
	align-items: center;
	gap: 3px;
	padding: 0 calc(10px + var(--gc-safe-right)) 0 calc(10px + var(--gc-safe-left));
	border-top: 1px solid var(--gc-border);
	background: var(--gc-surface);
}

.gc-bottombar-sep {
	width: 1px;
	height: 16px;
	background: var(--gc-border);
	margin: 0 5px;
	flex-shrink: 0;
}

.gc-bottom-btn {
	appearance: none;
	border: none;
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 11.5px;
	padding: 4px 8px;
	border-radius: 4px;
	cursor: pointer;
	transition: background 100ms, color 100ms;
}

.gc-bottom-btn:hover {
	background: var(--gc-border);
	color: var(--gc-text);
}

.gc-bottom-btn--active {
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
	font-weight: 700;
}

.gc-grow {
	flex: 1;
}

.gc-version-badge {
	font-size: 10px;
	color: var(--gc-text-micro);
	font-family: var(--gc-mono);
	padding: 0 4px;
}

.gc-publish-btn {
	appearance: none;
	border: none;
	background: #2962ff;
	color: #fff;
	font-size: 11.5px;
	font-weight: 700;
	padding: 5px 13px;
	border-radius: 4px;
	cursor: pointer;
	transition: opacity 120ms;
}

.gc-publish-btn:hover {
	opacity: 0.9;
}

/* Canvas DrawTools helpers */
.rsc-drawing-snap-active {
	cursor: crosshair;
}

.vninvestcharts-widget-magnet-cursor {
	cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 9 9, crosshair;
}

.rsc-long-tp-zone {
	fill: rgba(34, 171, 92, 0.18);
}

.rsc-long-sl-zone {
	fill: rgba(215, 50, 75, 0.18);
}

.rsc-short-tp-zone {
	fill: rgba(34, 171, 92, 0.18);
}

.rsc-short-sl-zone {
	fill: rgba(215, 50, 75, 0.18);
}

@media (max-width: 1150px) {
	.gc-main {
		grid-template-columns: var(--gc-toolbar-w) minmax(0, 1fr);
	}

	.gc-tf-chips .gc-tf-chip:nth-child(n+7) {
		display: none;
	}
}

@media (max-width: 820px) {
	.gc-tf-chips {
		display: none;
	}

	.gc-topbar-btn:not(.gc-theme-toggle) {
		display: none;
	}

	.gc-upgrade-btn {
		display: none;
	}

	.gc-symbol-name {
		font-size: 13px;
	}
}

/* UI/UX LAYOUT PROPOSAL: Chart-first context rail */
.gc-context-rail {
	width: var(--gc-context-rail-w, 240px);
	background: var(--gc-surface);
	border-right: 1px solid var(--gc-border);
	overflow-y: auto;
	overflow-x: hidden;
	transition: width var(--gc-toolbar-motion-default) ease;
	/* Chart-first: sidebar should support overlay mode */
	position: relative;
}

.gc-context-rail--collapsed {
	width: var(--gc-context-rail-collapsed-w, 48px);
}

/* UI/UX Phase 1.1: Collapsible context rail toggle */
.gc-context-rail__toggle {
	appearance: none;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
	color: var(--gc-text-muted);
	width: 28px;
	height: 28px;
	border-radius: var(--gc-radius);
	cursor: pointer;
	display: grid;
	place-items: center;
	transition: background 100ms, color 100ms;
}

.gc-context-rail__toggle:hover {
	background: var(--gc-border);
	color: var(--gc-text);
}

/* UI/UX Phase 1.1: Accordion for long content */
.gc-context-rail__accordion {
	border: 1px solid var(--gc-border);
	border-radius: var(--gc-radius);
	overflow: hidden;
}

.gc-context-rail__accordion-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 12px;
	background: var(--gc-surface-sub);
	cursor: pointer;
	transition: background 100ms;
}

.gc-context-rail__accordion-header:hover {
	background: var(--gc-surface);
}

.gc-context-rail__accordion-title {
	font-size: 12px;
	font-weight: 700;
	color: var(--gc-text);
}

.gc-context-rail__accordion-chevron {
	font-size: 10px;
	color: var(--gc-text-muted);
	transition: transform 150ms ease;
}

.gc-context-rail__accordion-content {
	padding: 12px;
	border-top: 1px solid var(--gc-border);
}

.gc-context-rail__accordion--collapsed .gc-context-rail__accordion-content {
	display: none;
}

.gc-context-rail__accordion--collapsed .gc-context-rail__accordion-chevron {
	transform: rotate(-90deg);
}

/* UI/UX: Header grouping - prioritized clusters */
.gc-topbar__cluster {
	display: flex;
	align-items: center;
	gap: 8px;
}

.gc-topbar__cluster--primary {
	/* Brand, symbol, timeframe - most important */
}

.gc-topbar__cluster--secondary {
	/* Mode, actions - less important */
}

.gc-topbar__cluster--tertiary {
	/* Panes, status, profile - least important, right-aligned */
	margin-left: auto;
}

/* Right-aligned cluster for status badges and profile */
.gc-topbar__right {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-left: auto;
}

/* UI/UX CHECKLIST: Unified card styling */
.gc-card {
	border-radius: var(--gc-radius, 6px);
	border: 1px solid var(--gc-border);
	padding: 12px;
	margin-bottom: 8px;
}

/* UI/UX LAYOUT PROPOSAL: Mobile context rail overlay */
@media (max-width: 768px) {
	.gc-context-rail {
		position: fixed;
		left: 0;
		top: var(--gc-topbar-h, 48px);
		bottom: 0;
		z-index: 100;
		transform: translateX(-100%);
		transition: transform var(--gc-toolbar-motion-default) ease;
	}
	
	.gc-context-rail--open {
		transform: translateX(0);
	}
}

.gc-context-rail__summary {
	padding: 12px;
	border-bottom: 1px solid var(--gc-border);
}

.gc-context-rail__summary-title {
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--gc-text-muted);
	margin-bottom: 8px;
}

.gc-context-rail__chips {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.gc-context-rail__chip {
	padding: 4px 8px;
	border-radius: 999px;
	border: 1px solid var(--gc-border);
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 11px;
	font-weight: 600;
	cursor: pointer;
	transition: background 100ms, color 100ms, border-color 100ms;
}

.gc-context-rail__chip:hover {
	background: var(--gc-surface-sub);
	color: var(--gc-text);
}

.gc-context-rail__chip--active {
	background: var(--gc-accent-bg);
	border-color: var(--gc-accent);
	color: var(--gc-accent);
}

.gc-context-rail__notes {
	padding: 12px;
	display: grid;
	gap: 8px;
}

.gc-context-rail__note {
	font-size: 11px;
	line-height: 1.5;
	color: var(--gc-text-muted);
}

.gc-context-rail__note-title {
	font-weight: 700;
	color: var(--gc-text);
	margin-bottom: 2px;
}

/* UI/UX: Chart stage with more breathing room */
.gc-chart-stage {
	flex: 1;
	min-width: 0;
	min-height: 0;
	display: flex;
	flex-direction: column;
	background: var(--gc-surface);
	position: relative;
}

/* UI/UX: Chart-first - give chart more width */
@media (min-width: 1280px) {
	.gc-chart-stage {
		/* Chart should take ~65%+ of width in chart-first layout */
	}
}

/* UI/UX: Accessibility - enhanced focus states */
.gc-tool-btn:focus-visible,
.gc-topbar-btn:focus-visible,
.gc-tf-chip:focus-visible {
	outline: 2px solid var(--gc-accent);
	outline-offset: 2px;
}

/* UI/UX: Progressive disclosure - accordion patterns */
.gc-accordion {
	border: 1px solid var(--gc-border);
	border-radius: var(--gc-radius);
	overflow: hidden;
}

.gc-accordion__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 12px;
	background: var(--gc-surface-sub);
	cursor: pointer;
	transition: background 100ms;
}

.gc-accordion__header:hover {
	background: var(--gc-surface);
}

.gc-accordion__title {
	font-size: 12px;
	font-weight: 700;
	color: var(--gc-text);
}

.gc-accordion__chevron {
	font-size: 10px;
	color: var(--gc-text-muted);
	transition: transform 150ms ease;
}

.gc-accordion__content {
	padding: 12px;
	border-top: 1px solid var(--gc-border);
}

.gc-accordion--collapsed .gc-accordion__content {
	display: none;
}

.gc-accordion--collapsed .gc-accordion__chevron {
	transform: rotate(-90deg);
}

.demo-page {
	position: relative;
	min-height: 100%;
	padding: 12px;
	background: transparent;
}

.demo-page--classic {
	padding: 12px;
}

.demo-page--terminal {
	box-sizing: border-box;
	height: 100%;
	padding: 12px;
}

.demo-page::before,
.demo-page::after {
	content: "";
	position: absolute;
	border-radius: 999px;
	filter: blur(60px);
	pointer-events: none;
	opacity: 0.38;
}

.demo-page::before {
	top: 5%;
	right: 6%;
	width: 260px;
	height: 260px;
	background: rgba(34, 211, 238, 0.18);
}

.demo-page::after {
	left: 4%;
	bottom: 8%;
	width: 320px;
	height: 320px;
	background: rgba(245, 158, 11, 0.12);
}

.demo-frame {
	position: relative;
	z-index: 1;
	max-width: 1640px;
	margin: 0 auto;
	display: grid;
	gap: 12px;
}

.demo-frame--classic {
	max-width: 1400px;
	gap: 12px;
}

.demo-frame--terminal {
	height: 100%;
	min-height: 0;
	gap: 12px;
}

.demo-frame--full-bleed {
	max-width: none;
	width: 100%;
}

.demo-hero {
	display: grid;
	grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
	gap: 24px;
	align-items: stretch;
	animation: demo-reveal 520ms ease-out both;
}

.demo-hero__content,
.demo-summary-card,
.demo-chart-card,
.demo-panel {
	background: var(--demo-panel);
	border: 1px solid var(--demo-panel-border);
	border-radius: 28px;
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);
	box-shadow: 0 30px 80px rgba(2, 6, 23, 0.38);
}

.demo-chart-card--terminal {
	min-height: 0;
	overflow: hidden;
}

.gc-terminal--embedded {
	height: 100%;
	min-height: 0;
	border: 0;
}

.demo-hero__content {
	padding: clamp(24px, 3vw, 40px);
	display: grid;
	gap: 18px;
	align-content: start;
	border: 1px solid rgba(34, 211, 238, 0.16);
	background:
		linear-gradient(140deg, rgba(15, 23, 42, 0.82), rgba(2, 6, 23, 0.74)),
		radial-gradient(circle at top right, rgba(245, 158, 11, 0.18), transparent 42%);
}

.demo-eyebrow {
	display: inline-flex;
	width: fit-content;
	padding: 8px 14px;
	border-radius: 999px;
	background: rgba(34, 211, 238, 0.12);
	border: 1px solid rgba(34, 211, 238, 0.24);
	color: #c0f9ff;
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.14em;
	text-transform: uppercase;
}

.demo-title {
	margin: 0;
	max-width: 15ch;
	font-family: "Bahnschrift", "Segoe UI Variable Display", "Aptos Display", sans-serif;
	font-size: clamp(2.5rem, 6vw, 4.8rem);
	line-height: 0.92;
	letter-spacing: -0.05em;
	color: #f8fafc;
}

.demo-subtitle {
	margin: 0;
	max-width: 72ch;
	font-size: 1.02rem;
	line-height: 1.7;
	color: var(--demo-text-soft);
}

.demo-badges {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.demo-badge {
	display: inline-flex;
	align-items: center;
	padding: 8px 12px;
	border-radius: 999px;
	border: 1px solid rgba(148, 163, 184, 0.18);
	background: rgba(15, 23, 42, 0.72);
	color: #dbeafe;
	font-size: 0.86rem;
	font-weight: 600;
}

.demo-summary-card {
	padding: 20px;
	display: grid;
	gap: 16px;
	align-content: start;
	background:
		linear-gradient(180deg, rgba(15, 23, 42, 0.88), rgba(15, 23, 42, 0.74)),
		radial-gradient(circle at top left, rgba(34, 211, 238, 0.12), transparent 48%);
	animation: demo-reveal 620ms ease-out both;
	animation-delay: 70ms;
}

.demo-summary-card__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
}

.demo-summary-card__meta {
	color: var(--demo-text-soft);
	font-size: 0.92rem;
	font-weight: 600;
}

.demo-summary-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.metric-tile {
	min-height: 120px;
	padding: 16px;
	border-radius: 22px;
	background: rgba(255, 255, 255, 0.03);
	border: 1px solid rgba(255, 255, 255, 0.08);
	display: grid;
	gap: 8px;
	align-content: start;
}

.metric-tile__label {
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.14em;
	text-transform: uppercase;
	color: var(--demo-text-soft);
}

.metric-tile__value {
	font-size: 1.22rem;
	font-weight: 800;
	line-height: 1.15;
	color: #f8fafc;
	font-family: "Bahnschrift", "Segoe UI Variable Display", "Aptos Display", sans-serif;
}

.metric-tile__detail {
	font-size: 0.9rem;
	line-height: 1.45;
	color: var(--demo-text-soft);
}

.metric-tile--positive .metric-tile__value { color: #86efac; }
.metric-tile--negative .metric-tile__value { color: #fca5a5; }
.metric-tile--accent .metric-tile__value { color: #67e8f9; }

.demo-grid {
	display: grid;
	grid-template-columns: minmax(0, 1.68fr) minmax(300px, 0.82fr);
	gap: 24px;
	align-items: start;
	animation: demo-reveal 720ms ease-out both;
	animation-delay: 90ms;
}

.demo-chart-card {
	overflow: hidden;
	border: 1px solid rgba(148, 163, 184, 0.16);
	background:
		linear-gradient(180deg, rgba(15, 23, 42, 0.86), rgba(15, 23, 42, 0.78)),
		radial-gradient(circle at top left, rgba(34, 211, 238, 0.08), transparent 36%);
}

.demo-chart-card__header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 16px;
	padding: 12px 16px 10px;
	border-bottom: 1px solid rgba(148, 163, 184, 0.12);
	flex-wrap: wrap;
}

.demo-chart-card__header--classic {
	padding: 12px 16px 10px;
}

.demo-chart-card__chips {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 10px;
	align-items: center;
}

.demo-chart-card__title {
	margin: 0;
	font-size: 1.18rem;
	font-weight: 800;
	color: #f8fafc;
	letter-spacing: -0.02em;
}

.demo-chart-card__meta {
	margin: 8px 0 0;
	color: var(--demo-text-soft);
	font-size: 0.94rem;
	line-height: 1.55;
}

.source-switch {
	display: inline-flex;
	padding: 4px;
	border-radius: 999px;
	border: 1px solid rgba(148, 163, 184, 0.14);
	background: rgba(15, 23, 42, 0.72);
	gap: 4px;
}

.source-switch__button {
	appearance: none;
	border: 0;
	border-radius: 999px;
	padding: 11px 16px;
	background: transparent;
	color: var(--demo-text-soft);
	font-size: 0.92rem;
	font-weight: 700;
	cursor: pointer;
	transition: background-color 160ms ease, color 160ms ease, transform 160ms ease, box-shadow 160ms ease;
}

.source-switch__button:hover {
	color: #f8fafc;
	transform: translateY(-1px);
}

.source-switch__button[aria-pressed="true"] {
	background: linear-gradient(135deg, rgba(34, 211, 238, 0.92), rgba(245, 158, 11, 0.92));
	color: #07111f;
	box-shadow: 0 10px 24px rgba(34, 211, 238, 0.24);
}

.chart-shell {
	padding: 8px;
}

.chart-shell--classic {
	padding: 4px;
}

.chart-surface {
	min-height: 600px;
	width: 100%;
	border-radius: 24px;
	overflow: hidden;
	background: rgba(2, 6, 23, 0.56);
	border: 1px solid rgba(148, 163, 184, 0.12);
}

.chart-surface--classic {
	min-height: 0;
}

.demo-chart-card--classic {
	overflow: hidden;
}

.chart-placeholder {
	min-height: 600px;
	display: grid;
	place-items: center;
	padding: 24px;
	color: var(--demo-text-soft);
	text-align: center;
	font-size: 0.98rem;
	letter-spacing: 0.01em;
	background:
		radial-gradient(circle at center, rgba(34, 211, 238, 0.08), transparent 42%),
		rgba(2, 6, 23, 0.48);
}

.demo-side {
	display: grid;
	gap: 16px;
}

.demo-panel {
	padding: 20px;
	display: grid;
	gap: 14px;
	animation: demo-reveal 720ms ease-out both;
	animation-delay: 110ms;
}

.demo-panel h2 {
	margin: 0;
	font-size: 1rem;
	font-weight: 800;
	letter-spacing: -0.01em;
	color: #f8fafc;
}

.feature-list,
.legend-list {
	display: grid;
	gap: 12px;
}

.feature-item {
	display: grid;
	grid-template-columns: 10px minmax(0, 1fr);
	gap: 12px;
	align-items: start;
	color: var(--demo-text-soft);
	line-height: 1.55;
	font-size: 0.95rem;
}

.feature-dot {
	width: 10px;
	height: 10px;
	margin-top: 7px;
	border-radius: 999px;
	background: linear-gradient(135deg, var(--demo-accent), var(--demo-accent-alt));
	box-shadow: 0 0 16px rgba(34, 211, 238, 0.26);
}

.legend-row {
	display: grid;
	gap: 6px;
	padding: 12px 14px;
	border-radius: 18px;
	background: rgba(255, 255, 255, 0.04);
	border: 1px solid rgba(255, 255, 255, 0.06);
}

.legend-row__key {
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
}

.legend-row__label {
	font-weight: 700;
	color: #f8fafc;
	flex: 1;
}

.legend-row__detail {
	color: var(--demo-text-soft);
	font-size: 0.9rem;
	line-height: 1.45;
}

.legend-swatch {
	flex: none;
	display: inline-block;
}

.legend-swatch--line {
	width: 18px;
	height: 4px;
	border-radius: 999px;
}

.legend-swatch--block {
	width: 16px;
	height: 16px;
	border-radius: 6px;
}

.demo-note {
	margin: 0;
	color: var(--demo-text-soft);
	line-height: 1.65;
	font-size: 0.95rem;
}

.source-chip {
	display: inline-flex;
	align-items: center;
	padding: 8px 12px;
	border-radius: 999px;
	border: 1px solid rgba(148, 163, 184, 0.18);
	font-size: 0.8rem;
	font-weight: 800;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	white-space: nowrap;
}

.source-chip--neutral {
	background: rgba(148, 163, 184, 0.12);
	color: #cbd5e1;
}

.source-chip--accent {
	background: rgba(34, 211, 238, 0.14);
	color: #c0f9ff;
}

.source-chip--positive {
	background: rgba(16, 185, 129, 0.14);
	color: #bbf7d0;
}

.source-chip--negative {
	background: rgba(239, 68, 68, 0.14);
	color: #fecaca;
}

.source-chip--btn {
	background: rgba(148, 163, 184, 0.10);
	color: #94a3b8;
	cursor: pointer;
	transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.source-chip--btn:hover {
	background: rgba(34, 211, 238, 0.14);
	color: #c0f9ff;
	border-color: rgba(34, 211, 238, 0.4);
}
.source-chip--btn-active {
	background: rgba(34, 211, 238, 0.22);
	color: #22d3ee;
	border-color: rgba(34, 211, 238, 0.6);
}

.gc-btn--danger {
	color: #fecaca;
	border-color: rgba(239, 68, 68, 0.28);
	background: rgba(239, 68, 68, 0.1);
}

.gc-btn--danger:hover {
	background: rgba(239, 68, 68, 0.18);
	color: #fff1f2;
}

.chart-surface .vninvestcharts-widget-crosshair line {
	pointer-events: none;
}

@keyframes demo-reveal {
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@media (max-width: 1200px) {
	.demo-hero,
	.demo-grid {
		grid-template-columns: 1fr;
	}

	.demo-title {
		max-width: 11ch;
	}
}

@media (max-width: 760px) {
	body {
		background:
			radial-gradient(circle at top left, rgba(34, 211, 238, 0.1), transparent 30%),
			linear-gradient(180deg, #08101d 0%, #0b1120 44%, #0d1525 100%);
	}

	.demo-page {
		padding: 16px;
	}

	.demo-hero__content,
	.demo-summary-card,
	.demo-chart-card,
	.demo-panel {
		border-radius: 22px;
	}

	.demo-summary-grid {
		grid-template-columns: 1fr;
	}

	.demo-chart-card__header {
		padding: 18px;
	}

	.chart-shell {
		padding: 12px;
	}

	.chart-surface,
	.chart-placeholder {
		min-height: 420px;
	}

	.source-switch {
		width: 100%;
	}

	.source-switch__button {
		flex: 1;
	}
}

.gc-settings-backdrop {
	position: fixed;
	inset: 0;
	z-index: 400;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	background: rgba(2, 6, 23, 0.58);
	backdrop-filter: blur(6px);
	-webkit-backdrop-filter: blur(6px);
	animation: demo-reveal 180ms ease-out;
}

.gc-settings-modal {
	width: min(980px, calc(100% - 32px));
	max-height: min(88vh, 860px);
	display: flex;
	flex-direction: column;
	border: 1px solid var(--gc-border-mid);
	border-radius: 10px;
	background: var(--gc-surface);
	box-shadow: 0 20px 52px rgba(2, 6, 23, 0.44);
	overflow: hidden;
}

.gc-settings-modal__header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 16px;
	padding: 14px 16px;
	border-bottom: 1px solid var(--gc-border);
	background: linear-gradient(180deg, var(--gc-surface-sub), var(--gc-surface));
}

.gc-settings-modal__header h2,
.gc-settings-panel__header h3,
.gc-settings-composer__head h4 {
	margin: 0;
	color: var(--gc-text);
	letter-spacing: -0.02em;
}

.gc-settings-modal__header h2 {
	font-size: 15px;
	font-weight: 700;
	line-height: 1.35;
}

.gc-settings-modal__hero {
	display: grid;
	gap: 8px;
	min-width: 0;
}

.gc-settings-modal__close {
	appearance: none;
	border: 1px solid var(--gc-border);
	width: 28px;
	height: 28px;
	border-radius: 5px;
	background: transparent;
	color: var(--gc-text-muted);
	font-size: 18px;
	line-height: 1;
	cursor: pointer;
	transition: background 120ms ease, color 120ms ease, border-color 120ms ease;
}

.gc-settings-modal__close:hover {
	background: var(--gc-surface-sub);
	border-color: var(--gc-border-mid);
	color: var(--gc-text);
}

.gc-settings-modal__meta {
	display: flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
}

.gc-settings-badge {
	display: inline-flex;
	align-items: center;
	padding: 3px 8px;
	border-radius: 999px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface);
	color: var(--gc-text-muted);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.04em;
	text-transform: uppercase;
}

.gc-settings-badge--accent {
	border-color: rgba(34, 211, 238, 0.28);
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
}

.gc-settings-modal__body {
	display: grid;
	grid-template-columns: 190px minmax(0, 1fr);
	min-height: 0;
}

.gc-settings-modal__nav {
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 12px;
	border-right: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
	min-width: 0;
}

.gc-settings-modal__nav-head {
	padding: 2px 2px 10px;
	margin-bottom: 4px;
	border-bottom: 1px solid var(--gc-border);
}

.gc-settings-modal__nav-item {
	appearance: none;
	border: 1px solid transparent;
	border-radius: 6px;
	background: transparent;
	color: var(--gc-text-muted);
	font: inherit;
	font-size: 12px;
	font-weight: 600;
	height: 32px;
	line-height: 1;
	padding: 0 10px;
	box-sizing: border-box;
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	cursor: pointer;
	transition: background 120ms ease, color 120ms ease, border-color 120ms ease;
}

.gc-settings-modal__nav-item:hover {
	background: var(--gc-surface);
	color: var(--gc-text);
}

.gc-settings-modal__nav-item--active {
	background: var(--gc-accent-bg);
	border-color: var(--gc-border-mid);
	color: var(--gc-accent);
}

.gc-settings-modal__content {
	min-width: 0;
	overflow: auto;
	padding: 12px;
	background: var(--gc-surface);
}

.gc-settings-modal__content::-webkit-scrollbar,
.gc-settings-modal__nav::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

.gc-settings-modal__content::-webkit-scrollbar-thumb,
.gc-settings-modal__nav::-webkit-scrollbar-thumb {
	background: rgba(148, 163, 184, 0.28);
	border-radius: 999px;
	border: 2px solid transparent;
	background-clip: padding-box;
}

.gc-settings-modal__surface {
	display: grid;
	gap: 12px;
}

.gc-settings-panel {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 14px;
	border-radius: 8px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface-sub);
}

.gc-settings-panel + .gc-settings-panel {
	margin-top: 12px;
}

.gc-settings-panel__header,
.gc-settings-composer__head,
.gc-settings-series__head,
.gc-settings-pane__head,
.gc-settings-pane__footer {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
}

.gc-settings-series__head {
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto auto;
	align-items: center;
	flex-wrap: nowrap;
}

.gc-settings-series__head > :first-child {
	min-width: 0;
}

.gc-settings-series__head .gc-settings-field--compact {
	min-width: 140px;
}

.gc-settings-series__head .gc-settings-series__actions {
	justify-self: end;
	white-space: nowrap;
}

.gc-settings-panel__header h3 {
	font-size: 15px;
	font-weight: 700;
	line-height: 1.3;
}

.gc-settings-composer__head h4 {
	font-size: 13px;
	font-weight: 700;
	line-height: 1.25;
}

.gc-settings-kicker {
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--gc-text-micro);
	margin-bottom: 2px;
}

.gc-settings-stat {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
	border-radius: 999px;
	border: 1px solid var(--gc-border);
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
	font-size: 10px;
	font-weight: 700;
	white-space: nowrap;
	letter-spacing: 0.04em;
}

/* =========================================================
   Color picker for indicator settings
   ========================================================= */
.gc-settings-field--color {
	flex-direction: row;
	align-items: center;
	gap: 8px;
}

.gc-settings-field--color > span {
	flex: 1;
}

.gc-settings-bollinger-stack {
	display: grid;
	gap: 10px;
	min-width: 0;
}

.gc-settings-bollinger-grid {
	grid-template-columns: minmax(100px, 0.6fr) minmax(120px, 0.7fr) minmax(92px, 0.5fr) minmax(260px, 1.3fr);
	align-items: end;
}

.gc-settings-bollinger-grid--fill {
	grid-template-columns: minmax(130px, 0.85fr) minmax(0, 1.15fr) minmax(92px, 0.6fr);
	align-items: end;
}

.gc-settings-bollinger-grid--fill .gc-settings-field--color > span {
	flex: 0 0 auto;
}

.gc-settings-bollinger-grid__short-field {
	min-width: 0;
}

.gc-settings-bollinger-grid .gc-settings-field--compact {
	min-width: 0;
}

.gc-settings-color-input {
	width: 36px;
	height: 28px;
	padding: 2px 3px;
	border: 1px solid var(--gc-border);
	border-radius: 6px;
	background: var(--gc-bg);
	cursor: pointer;
	flex-shrink: 0;
}

.gc-settings-color-input:focus-visible {
	outline: 2px solid var(--gc-accent);
	outline-offset: 1px;
}

/* =========================================================
   Sub-component colors section (MACD, BB, KDJ, etc.)
   ========================================================= */
.gc-settings-sub-colors {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px 16px;
	border-top: 1px solid var(--gc-border);
	padding-top: 10px;
	margin-top: 6px;
	grid-column: 1 / -1;
}

.gc-settings-sub-colors__label {
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--gc-text-muted);
	width: 100%;
	margin-bottom: 0;
}

.gc-settings-sub-colors .gc-settings-field--color {
	flex-direction: column;
	align-items: center;
	gap: 4px;
	flex: 0 0 auto;
}

.gc-settings-sub-colors .gc-settings-field--color > span {
	font-size: 11px;
	white-space: nowrap;
}

/* =========================================================
   Drawing tools grouped flyout sub-menus
   ========================================================= */
.gc-tools-group-container {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.gc-tool-btn--group {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
}

.gc-tools-chevron {
	font-size: 7px;
	line-height: 1;
	opacity: 0.6;
	pointer-events: none;
}

.gc-tools-flyout {
	position: fixed;
	z-index: 2000;
	background: var(--gc-surface);
	border: 1px solid var(--gc-border-mid);
	border-radius: var(--gc-radius);
	box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.22);
	display: flex;
	flex-direction: column;
	gap: var(--gc-toolbar-gap);
	padding: var(--gc-toolbar-flyout-padding);
	min-width: calc(var(--gc-toolbar-button-size) + (var(--gc-toolbar-flyout-padding) * 2));
	max-height: calc(100vh - 24px);
	overflow-y: auto;
	overflow-x: hidden;
}

/* Desktop safety guard: always preserve a visible, scrollable tools region in flyouts. */
@media (min-width: 768px) {
	.gc-tools-flyout {
		overflow: hidden;
	}

	.gc-tools-flyout > div {
		flex-shrink: 0;
	}

	.gc-tools-flyout > div:last-child {
		flex: 1 1 auto;
		min-height: 120px;
		overflow-y: auto !important;
		overflow-x: hidden !important;
	}
}

/* =========================================================
   CE21: Responsive / Mobile (≤767px)
   Toolbar collapses from vertical column to horizontal row
   with touch-friendly tap targets and scroll overflow.
   ========================================================= */
@media (max-width: 767px) {
	/* Reconfigure layout: toolbar becomes top horizontal bar */
	.gc-main {
		display: grid;
		grid-template-columns: minmax(0, 1fr);
		grid-template-rows: auto minmax(0, 1fr);
	}

	.gc-chart-shell {
		padding: 8px;
	}

	/* Toolbar rotates: column → row, scrolls horizontally; reset auto-hide */
	.gc-tools-shell {
		position: relative;
		left: auto;
		top: auto;
		bottom: auto;
		width: auto;
		z-index: auto;
		overflow: visible;
	}

	.gc-tools {
		position: relative;
		left: auto;
		width: auto;
		top: auto;
		bottom: auto;
		flex-direction: row;
		align-items: center;
		padding: 4px calc(8px + var(--gc-safe-right)) 4px calc(8px + var(--gc-safe-left));
		gap: var(--gc-toolbar-gap);
		overflow-x: auto;
		overflow-y: visible;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;
		border-right: none;
		border-bottom: 1px solid var(--gc-border);
		box-shadow: none;
		transition: none;
	}

	.gc-tools-handle {
		display: none;
	}

	.gc-tools::after {
		display: none;
	}

	.gc-tools:hover,
	.gc-tools:focus-within {
		left: auto;
		box-shadow: none;
	}

	.gc-chart-area {
		position: relative;
		inset: auto;
	}

	.gc-tools::-webkit-scrollbar {
		display: none;
	}

	.gc-tools-group {
		flex-direction: row;
		align-items: center;
		gap: var(--gc-toolbar-gap);
	}

	/* Vertical divider instead of horizontal */
	.rsc-toolbar-divider {
		width: 1px;
		height: 20px;
		margin: 0 4px;
	}

	/* Flyout opens downward on mobile (toolbar is horizontal) */
	.gc-tools-flyout {
		flex-direction: row;
		max-width: calc(100vw - 16px);
		max-height: calc(100dvh - 16px - var(--gc-keyboard-inset-bottom));
		overflow-x: auto;
		overflow-y: auto;
	}

	/* Ensure all tool buttons meet 44×44px touch target minimum */
	.gc-tool-btn {
		min-width: var(--gc-toolbar-flyout-button-size-compact);
		min-height: var(--gc-toolbar-flyout-button-size-compact);
		width: var(--gc-toolbar-flyout-button-size-compact);
		height: var(--gc-toolbar-flyout-button-size-compact);
		flex-shrink: 0;
	}

	.rsc-drawing-dock,
	.rsc-drawing-inspector,
	.rsc-drawing-list-panel {
		left: calc(8px + var(--gc-safe-left)) !important;
		right: calc(8px + var(--gc-safe-right)) !important;
		width: auto;
		max-width: none;
	}

	.rsc-drawing-dock {
		top: auto !important;
		bottom: calc(8px + var(--gc-safe-bottom) + var(--gc-keyboard-inset-bottom));
		max-height: min(48vh, 520px);
	}

	.rsc-drawing-dock__tabs {
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 4px;
		padding: 10px 12px 0;
	}

	.rsc-drawing-dock__body {
		padding: 10px 12px 12px;
	}

	.rsc-drawing-dock__icon,
	.rsc-drawing-dock__tab,
	.rsc-drawing-inspector__icon,
	.rsc-drawing-inspector__button,
	.rsc-drawing-list-panel__icon,
	.rsc-drawing-list-panel__select,
	.rsc-drawing-point-legend__item,
	.rsc-drawing-point-legend__clear {
		min-height: 44px;
	}

	.rsc-drawing-inspector,
	.rsc-drawing-list-panel {
		max-height: 44vh;
	}

	.rsc-drawing-inspector--embedded,
	.rsc-drawing-list-panel--embedded {
		padding: 10px;
	}

	.rsc-drawing-inspector__actions,
	.rsc-drawing-list-panel__actions {
		gap: 6px;
	}

	.rsc-drawing-list-panel__item {
		padding: 10px;
	}

	.rsc-drawing-list-panel__select {
		padding: 8px 10px;
	}

	.rsc-drawing-point-legend {
		padding: 10px 12px 12px;
	}

	/* Drawing storage toolbar: stack vertically and widen */
	.rsc-drawing-storage-toolbar {
		flex-wrap: wrap;
		width: calc(100vw - 32px - var(--gc-safe-left) - var(--gc-safe-right));
		left: calc(16px + var(--gc-safe-left)) !important;
		top: auto !important;
		bottom: calc(60px + var(--gc-safe-bottom) + var(--gc-keyboard-inset-bottom));
	}

	.rsc-drawing-storage-toolbar__button {
		min-height: 44px;
		flex: 1;
		font-size: 12px;
	}

	/* Candle type select touch-friendly */
	.vnsc-candle-type-select {
		min-height: 44px;
		font-size: 13px;
	}
}

@media (min-width: 768px) and (max-width: 1023px) {
	.rsc-drawing-dock,
	.rsc-drawing-inspector,
	.rsc-drawing-list-panel {
		left: 12px !important;
		right: 12px !important;
		width: auto;
		max-width: none;
	}

	.rsc-drawing-dock {
		top: 12px !important;
		bottom: auto;
		max-height: min(56vh, 640px);
	}

	.rsc-drawing-inspector,
	.rsc-drawing-list-panel {
		max-height: 38vh;
	}

	.rsc-drawing-dock__tabs {
		padding-left: 12px;
		padding-right: 12px;
	}

	.rsc-drawing-dock__icon,
	.rsc-drawing-dock__tab,
	.rsc-drawing-inspector__icon,
	.rsc-drawing-inspector__button,
	.rsc-drawing-list-panel__icon,
	.rsc-drawing-list-panel__select,
	.rsc-drawing-point-legend__item,
	.rsc-drawing-point-legend__clear {
		min-height: 40px;
	}
}

.gc-settings-row {
	display: flex;
	align-items: flex-end;
	gap: 10px;
	flex-wrap: wrap;
}

.gc-settings-row--split {
	justify-content: space-between;
}

.gc-settings-field {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	color: var(--gc-text-muted);
	font-size: 11px;
	font-weight: 600;
}

.gc-settings-field--compact {
	min-width: 180px;
}

.gc-settings-field > span {
	color: var(--gc-text-muted);
}

.gc-settings-input,
.gc-settings-select {
	width: 100%;
	min-width: 0;
	padding: 8px 10px;
	border: 1px solid var(--gc-border);
	border-radius: 6px;
	background: var(--gc-bg);
	color: var(--gc-text);
	font: inherit;
	font-size: 12px;
	transition: border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;
}

.gc-settings-input:focus,
.gc-settings-select:focus {
	outline: none;
	border-color: var(--gc-accent);
	box-shadow: 0 0 0 2px rgba(34, 211, 238, 0.12);
}

.gc-settings-select {
	appearance: none;
}

.gc-settings-range {
	width: 100%;
	margin-top: 4px;
	accent-color: var(--gc-accent);
}

.gc-settings-slider-shell {
	display: grid;
	gap: 6px;
}

.gc-settings-slider-steps {
	position: relative;
	margin-top: 6px;
	min-height: 16px;
	font-size: 10px;
	color: var(--gc-text-dim);
}

.gc-settings-slider-steps__label {
	position: absolute;
	top: 0;
	transform: translateX(-50%);
	white-space: nowrap;
}

.gc-settings-slider-steps__label--active {
	color: var(--gc-accent);
	font-weight: 700;
}

.gc-settings-slider-steps__current {
	position: absolute;
	top: 0;
	transform: translateX(-50%);
	white-space: nowrap;
	color: var(--gc-accent);
	font-weight: 700;
	pointer-events: none;
}

.gc-settings-slider-readout {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	min-height: 16px;
	font-size: 10px;
	color: var(--gc-text-dim);
}

.gc-settings-slider-readout__edge {
	white-space: nowrap;
}

.gc-settings-slider-readout__edge--active {
	color: var(--gc-accent);
	font-weight: 700;
}

.gc-settings-slider-readout__current {
	position: absolute;
	top: 0;
	transform: translateX(-50%);
	white-space: nowrap;
	color: var(--gc-accent);
	font-weight: 700;
	pointer-events: none;
}

.gc-settings-field--toggle {
	flex-direction: row;
	align-items: flex-start;
	gap: 10px;
	min-width: 220px;
}

.gc-settings-field--toggle > input {
	margin-top: 3px;
	flex: none;
}

.gc-settings-field--toggle > div {
	display: grid;
	gap: 4px;
	min-width: 0;
}

.gc-settings-pane-list,
.gc-settings-series-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.gc-settings-pane {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 14px;
	border-radius: 8px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface);
	cursor: pointer;
	transition: border-color 120ms ease, background 120ms ease;
}

.gc-settings-pane:hover {
	border-color: var(--gc-border-mid);
	background: var(--gc-bg);
}

.gc-settings-pane--hidden {
	opacity: 0.78;
}

.gc-settings-pane--selected {
	border-color: rgba(34, 211, 238, 0.36);
	box-shadow: inset 0 0 0 1px rgba(34, 211, 238, 0.16);
}

.gc-settings-pane__label {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12.5px;
	font-weight: 700;
	color: var(--gc-text);
	flex-wrap: wrap;
}

.gc-settings-pane__meta,
.gc-settings-series__meta {
	font-size: 10.5px;
	line-height: 1.4;
	color: var(--gc-text-micro);
}

.gc-settings-pane__actions,
.gc-settings-pane__arrows,
.gc-settings-series__actions {
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
}

.gc-settings-pane__footer {
	align-items: center;
}

.gc-settings-pane__tags {
	display: flex;
	gap: 6px;
	flex-wrap: wrap;
	min-width: 0;
}

.gc-tag {
	display: inline-flex;
	align-items: center;
	padding: 3px 8px;
	border-radius: 999px;
	border: 1px solid rgba(34, 211, 238, 0.24);
	background: var(--gc-accent-bg);
	color: var(--gc-accent);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.03em;
}

.gc-settings-pill {
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	border-radius: 999px;
	border: 1px solid var(--gc-border);
	background: var(--gc-border);
	color: var(--gc-text-muted);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
}

.gc-settings-pill--ok {
	border-color: rgba(16, 185, 129, 0.24);
	background: rgba(16, 185, 129, 0.12);
	color: #8ef0c4;
}

.gc-settings-pill--muted {
	border-color: rgba(148, 163, 184, 0.16);
	background: rgba(148, 163, 184, 0.08);
	color: var(--gc-text-micro);
}

.gc-settings-note {
	font-size: 11px;
	line-height: 1.55;
	color: var(--gc-text-muted);
}

.gc-settings-note--tight {
	max-width: 28ch;
}

.gc-settings-note--warn {
	color: #fecaca;
}

.gc-settings-empty {
	padding: 24px;
	border-radius: 8px;
	border: 1px dashed var(--gc-border);
	background: var(--gc-surface);
	color: var(--gc-text-muted);
	text-align: center;
}

.gc-settings-pane-summary {
	display: grid;
	gap: 6px;
	padding: 12px 14px;
	border-radius: 8px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface);
}

.gc-settings-pane-summary__title {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	font-size: 12.5px;
	font-weight: 700;
	color: var(--gc-text);
}

.gc-settings-series {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 12px 14px;
	border-radius: 8px;
	border: 1px solid var(--gc-border);
	background: var(--gc-surface);
}

.gc-settings-series__title {
	font-size: 12px;
	font-weight: 700;
	color: var(--gc-text);
}

.gc-settings-series__params {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
	gap: 10px;
	min-width: 0;
}

.gc-settings-param-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
	gap: 10px;
	min-width: 0;
}

.gc-settings-param-grid--three {
	grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.gc-settings-composer {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-top: 12px;
	border-top: 1px solid var(--gc-border);
}

.gc-settings-composer__head {
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto;
	align-items: center;
	gap: 12px;
}

.gc-settings-panel .gc-btn,
.gc-settings-composer .gc-btn,
.gc-settings-series__actions .gc-btn,
.gc-settings-pane__actions .gc-btn,
.gc-settings-pane__arrows .gc-btn {
	min-height: 30px;
	padding: 6px 10px;
	border-radius: 6px;
	font-size: 11.5px;
	font-weight: 600;
}

@media (max-width: 980px) {
	.gc-settings-backdrop {
		padding: 12px;
	}

	.gc-settings-modal__body {
		grid-template-columns: 1fr;
	}

	.gc-settings-modal__nav {
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		border-right: none;
		border-bottom: 1px solid var(--gc-border);
	}

	.gc-settings-modal__nav-head {
		width: 100%;
	}

	.gc-settings-modal__nav-item {
		flex: 1 1 140px;
		justify-content: center;
	}

	.gc-settings-bollinger-row {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 640px) {
	.gc-settings-modal {
		max-height: 92vh;
		border-radius: 8px;
	}

	.gc-settings-modal__header,
	.gc-settings-modal__content,
	.gc-settings-modal__nav,
	.gc-settings-panel {
		padding: 14px;
	}

	.gc-settings-row--split {
		flex-direction: column;
		align-items: stretch;
	}

	.gc-settings-field--compact {
		min-width: 0;
		width: 100%;
	}

	.gc-settings-param-grid,
	.gc-settings-param-grid--three {
		grid-template-columns: 1fr;
	}

	.gc-settings-bollinger-row {
		grid-template-columns: 1fr;
	}

	.gc-settings-series__head,
	.gc-settings-composer__head,
	.gc-settings-panel__header {
		flex-direction: column;
	}

	.gc-settings-modal__header h2 {
		font-size: 14px;
	}
}

/* Custom scrollbars for Sidebar and Tools to make them super thin and clean (WE2 UI/UX) */
.demo-sidebar-aside {
	scrollbar-width: thin;
	scrollbar-color: var(--gc-border-mid) transparent;
}

.demo-sidebar-aside::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}

.demo-sidebar-aside::-webkit-scrollbar-track {
	background: transparent;
}

.demo-sidebar-aside::-webkit-scrollbar-thumb {
	background: var(--gc-border-mid);
	border-radius: 4px;
}

.demo-sidebar-aside::-webkit-scrollbar-thumb:hover {
	background: var(--gc-accent);
}

.gc-tools::-webkit-scrollbar {
	width: 4px;
	height: 4px;
}

.gc-tools::-webkit-scrollbar-track {
	background: transparent;
}

.gc-tools::-webkit-scrollbar-thumb {
	background: var(--gc-border-mid);
	border-radius: 4px;
}

.gc-tools::-webkit-scrollbar-thumb:hover {
	background: var(--gc-accent);
}`, "",{"version":3,"sources":["webpack://./src/demo/demo.css"],"names":[],"mappings":"AAGA;;CAEC,+BAA+B;CAC/B,yCAAyC;CACzC,iDAAiD;CACjD,yDAAyD;CACzD,iEAAiE;CACjE,mCAAmC;CACnC,+CAA+C;CAC/C,+CAA+C;CAC/C,uCAAuC;CACvC,8DAA8D;CAC9D,yCAAyC;CACzC,wCAAwC;CACxC,oDAAoD;CACpD,mBAAmB;CACnB,sBAAsB;CACtB,oBAAoB;CACpB,2BAA2B;CAC3B,2BAA2B;CAC3B,8BAA8B;CAC9B,qBAAqB;CACrB,6BAA6B;CAC7B,gCAAgC;CAChC,+BAA+B;CAC/B,qCAAqC;CACrC,6CAA6C;CAC7C,6DAA6D;CAC7D,2BAA2B;CAC3B,2BAA2B;CAC3B,4CAA4C;CAC5C,gDAAgD;CAChD,kDAAkD;CAClD,8CAA8C;CAC9C,+BAA+B;CAC/B,+BAA+B;CAC/B,kCAAkC;CAClC,gCAAgC;CAChC,gBAAgB;CAChB,oBAAoB;CACpB,yDAAyD;CACzD,0BAA0B;CAC1B,mCAAmC;CACnC,wFAAwF;CACxF,mEAAmE;CACnE,kBAAkB;CAClB,uBAAuB;CACvB,oCAAoC;CACpC,8CAA8C;CAC9C,qDAAqD;CACrD,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,0BAA0B;CAC1B,iCAAiC;CACjC,+BAA+B;CAC/B,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;;;CAGC,kBAAkB;AACnB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,0EAA0E;CAC1E,qBAAqB;CACrB,+EAA+E;CAC/E,gBAAgB;AACjB;;AAEA;;;CAGC;;;gEAG+D;AAChE;;AAEA;;CAEC;;;gEAG+D;AAChE;;AAEA;CACC,WAAW;CACX,eAAe;CACf,QAAQ;CACR,oBAAoB;CACpB;;wEAEuE;CACvE,0BAA0B;CAC1B,aAAa;CACb,wEAAwE;AACzE;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA,4DAA4D;AAC5D;CACC,aAAa;CACb,2EAA2E;CAC3E,YAAY;CACZ,0FAA0F;CAC1F,sBAAsB;CACtB,wBAAwB;CACxB,kCAAkC;CAClC,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,iBAAiB;CACjB,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,yCAAyC;CACzC,6BAA6B;CAC7B,QAAQ;CACR,YAAY;AACb;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,kCAAkC;CAClC,6EAA6E;CAC7E,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,YAAY;CACZ,UAAU;CACV,eAAe;CACf,uBAAuB;AACxB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,2BAA2B;CAC3B,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,aAAa;AACd;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,4BAA4B;CAC5B,cAAc;CACd,aAAa;AACd;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mCAAmC;CACnC,eAAe;CACf,yCAAyC;CACzC,mBAAmB;AACpB;;AAEA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,uBAAuB;CACvB,qBAAqB;CACrB,eAAe;CACf,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,mCAAmC;CACnC,eAAe;CACf,mBAAmB;CACnB,yCAAyC;CACzC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;CAChB,mCAAmC;CACnC,eAAe;CACf,mBAAmB;CACnB,6DAA6D;AAC9D;;AAEA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,uBAAuB;CACvB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,WAAW;CACX,qCAAqC;CACrC,kBAAkB;CAClB,mBAAmB;CACnB,sCAAsC;CACtC,6BAA6B;CAC7B,4CAA4C;CAC5C,aAAa;CACb,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,oDAAoD;CACpD,2BAA2B;CAC3B,mCAAmC;AACpC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,sCAAsC;CACtC,+BAA+B;CAC/B,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,4EAA4E;AAC7E;;AAEA;CACC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,SAAS;CACT,gBAAgB;CAChB,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;CAChB,mBAAmB;CACnB,kCAAkC;CAClC,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kCAAkC;CAClC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;CAChB,mBAAmB;CACnB,kCAAkC;CAClC,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,aAAa;CACb,eAAe;CACf,2BAA2B;CAC3B,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;CACjC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,kBAAkB;CAClB,mBAAmB;CACnB,kCAAkC;CAClC,iCAAiC;AAClC;;AAEA;CACC,qCAAqC;CACrC,oDAAoD;AACrD;;AAEA;CACC,oCAAoC;CACpC,mDAAmD;AACpD;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;CACR,eAAe;CACf,kCAAkC;CAClC,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,uCAAuC;CACvC,kCAAkC;CAClC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;CAChB,YAAY;CACZ,qBAAqB;CACrB,6BAA6B;CAC7B,mCAAmC;CACnC,6BAA6B;CAC7B,yDAAgM;CAChM,4BAA4B;CAC5B,qCAAqC;CACrC,qBAAqB;CACrB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,+CAA+C;AAChD;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,aAAa;CACb,uCAAuC;AACxC;;AAEA;CACC,eAAe;CACf,qBAAqB;CACrB,qCAAqC;AACtC;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,YAAY;CACZ,cAAc;CACd,kCAAkC;CAClC,mCAAmC;CACnC,6BAA6B;CAC7B,qBAAqB;CACrB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,OAAO;CACP,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,sCAAsC;CACtC,6BAA6B;CAC7B,6CAA6C;AAC9C;;AAEA;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;CACrB,2BAA2B;CAC3B,iBAAiB;CACjB,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,0BAA0B;CAC1B,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,4BAA4B;AAC7B;;AAEA,iDAAiD;AACjD;CACC,QAAQ;AACT;;AAEA;CACC,cAAc;CACd,aAAa;AACd;;AAEA;CACC,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,+BAA+B;CAC/B,sCAAsC;CACtC,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,mCAAmC;CACnC,iCAAiC;CACjC,sCAAsC;CACtC,gBAAgB;CAChB,oBAAoB;CACpB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,yFAAyF;CACzF,kCAAkC;CAClC,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,qEAAqE;CACrE,2BAA2B;AAC5B;;AAEA,iCAAiC;AACjC;CACC,kGAAkG;AACnG;;AAEA,yCAAyC;AACzC;CACC;EACC,yDAAyD;CAC1D;;CAEA;EACC,yDAAyD;CAC1D;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,SAAS;CACT,0BAA0B;CAC1B,wCAAwC;CACxC,iCAAiC;CACjC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,cAAc;CACd,QAAQ;CACR,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;CACrB,sFAAsF;AACvF;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,SAAS;CACT,0BAA0B;CAC1B,YAAY;CACZ,iBAAiB;CACjB,uDAAuD;AACxD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,iCAAiC;EACjC,oBAAoB;EACpB,YAAY;CACb;;CAEA;EACC,oCAAoC;EACpC,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,4JAA4J;CAC7J;;CAEA;;;;EAIC,OAAO;EACP,0CAA0C;EAC1C,oCAAoC;CACrC;;CAEA;EACC,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,4EAA4E;EAC5E,iBAAiB;EACjB;;;;GAIC;EACD,gDAAgD;EAChD,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,mJAAmJ;CACpJ;;CAEA;EACC,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mEAAmE;EACnE;;kEAEgE;CACjE;;CAEA;;EAEC,+CAA+C;CAChD;;AAED;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,uBAAuB;CACvB,2BAA2B;CAC3B,oCAAoC;CACpC,qCAAqC;CACrC,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,8EAA8E;AAC/E;;AAEA;CACC,2BAA2B;AAC5B;;AAEA,4DAA4D;AAC5D;CACC,mCAAmC;CACnC,mBAAmB;AACpB;;AAEA;CACC,kHAAkH;CAClH,uBAAuB;CACvB,mEAAmE;CACnE,iFAAiF;AAClF;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,YAAY;CACZ,aAAa;CACb,aAAa;CACb,uCAAuC;CACvC,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC;EACC,QAAQ;CACT;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,yCAAyC;CACzC,mBAAmB;CACnB,gBAAgB;CAChB,qEAAqE;AACtE;;AAEA;CACC;EACC,2DAA2D;CAC5D;CACA;;EAEC,oDAAoD;CACrD;AACD;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,kBAAkB;CAClB,yCAAyC;CACzC,qFAAqF;CACrF,0BAA0B;CAC1B,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,YAAY;AACb;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,eAAe;AAChB;;AAEA,iDAAiD;AACjD;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;CACX,sBAAsB;CACtB,kCAAkC;CAClC,6BAA6B;CAC7B,qBAAqB;CACrB,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,0DAA0D;AAC3D;;AAEA,mDAAmD;AACnD;CACC,YAAY;CACZ,cAAc;CACd,sBAAsB;AACvB;;AAEA;;CAEC,8BAA8B;CAC9B,6CAA6C;AAC9C;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,sCAAsC;CACtC,mBAAmB;CACnB,6BAA6B;CAC7B,2CAA2C;CAC3C,iBAAiB;CACjB,cAAc;AACf;;AAEA,kCAAkC;AAClC;CACC,SAAS;CACT,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,2BAA2B;CAC3B,eAAe;CACf,mDAAmD;AACpD;;AAEA;;CAEC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA,8CAA8C;AAC9C;CACC,aAAa;CACb,QAAQ;CACR,oBAAoB;CACpB,yCAAyC;AAC1C;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,eAAe;CACf,yCAAyC;AAC1C;;AAEA;CACC,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,qCAAqC;CACrC,uCAAuC;CACvC,WAAW;AACZ;;AAEA,kCAAkC;AAClC;CACC,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,+BAA+B;CAC/B,2BAA2B;CAC3B,cAAc;AACf;;AAEA,oCAAoC,oCAAoC,EAAE,cAAc,EAAE;AAC1F,mCAAmC,oCAAoC,EAAE,cAAc,EAAE;AACzF,qCAAqC,oCAAoC,EAAE,cAAc,EAAE;;AAE3F,0CAA0C;AAC1C;CACC,oBAAoB;AACrB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,2BAA2B;CAC3B,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kCAAkC;CAClC,uBAAuB;CACvB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;CACtC,cAAc;AACf;;AAEA;CACC,oCAAoC;AACrC;;AAEA,qCAAqC;AACrC;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,+BAA+B;CAC/B,2BAA2B;CAC3B,cAAc;AACf;;AAEA,4BAA4B,oCAAoC,EAAE,cAAc,EAAE;AAClF,2BAA2B,oCAAoC,EAAE,cAAc,EAAE;AACjF,6BAA6B,oCAAoC,EAAE,cAAc,EAAE;;AAEnF;CACC,eAAe;CACf,2BAA2B;CAC3B,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,kBAAkB;CAClB,kCAAkC;CAClC,mBAAmB;CACnB,kCAAkC;CAClC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,8BAA8B;CAC9B,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,iCAAiC;CACjC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;;CAEC,cAAc;CACd,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,aAAa;CACb,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,4BAA4B;CAC5B,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,2DAA2D;CAC3D,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;CACnB,kCAAkC;CAClC,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,mCAAmC;CACnC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,qCAAqC;CACrC,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,gCAAgC;CAChC,2BAA2B;CAC3B,mCAAmC;AACpC;;AAEA;CACC,uBAAuB;CACvB,4BAA4B;CAC5B,aAAa;CACb,4CAA4C;CAC5C,mBAAmB;CACnB,sCAAsC;CACtC,6BAA6B;CAC7B,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,uBAAuB;CACvB,yCAAyC;AAC1C;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,oBAAoB;CACpB,yCAAyC;CACzC,wEAAwE;AACzE;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,gCAAgC;CAChC,uBAAuB;CACvB,2BAA2B;CAC3B,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,4BAA4B;CAC5B,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;CACrB,kCAAkC;CAClC,sCAAsC;CACtC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,aAAa;CACb,cAAc;CACd,aAAa;AACd;;AAEA;;;CAGC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,SAAS;AACV;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,QAAQ;CACR,kBAAkB;CAClB,kBAAkB;CAClB,uDAAuD;CACvD,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CACR,eAAe;AAChB;;AAEA;;;;CAIC,kBAAkB;CAClB,WAAW;CACX,2BAA2B;CAC3B,mCAAmC;AACpC;;AAEA;CACC,qCAAqC;CACrC,2CAA2C;CAC3C,sCAAsC;CACtC,kEAAkE;CAClE,4CAA4C;CAC5C,qBAAqB;CACrB,aAAa;CACb,4CAA4C;CAC5C,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,8BAA8B;CAC9B,SAAS;CACT,uBAAuB;CACvB,yCAAyC;CACzC,sEAAsE;AACvE;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,yBAAyB;AAC1B;;AAEA;;CAEC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,QAAQ;CACR,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,+BAA+B;CAC/B,uBAAuB;AACxB;;AAEA;;CAEC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,+BAA+B;CAC/B,uCAAuC;CACvC,iCAAiC;CACjC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,uBAAuB;CACvB,2CAA2C;CAC3C,sCAAsC;CACtC,sEAAsE;AACvE;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,oBAAoB;CACpB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,6BAA6B;CAC7B,kCAAkC;AACnC;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,0DAA0D;CAC1D,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,mBAAmB;CACnB,kCAAkC;CAClC,qBAAqB;CACrB,iBAAiB;CACjB,aAAa;CACb,QAAQ;CACR,qBAAqB;CACrB,eAAe;CACf,uGAAuG;AACxG;;AAEA;;;CAGC,+BAA+B;CAC/B,8BAA8B;CAC9B,2EAA2E;CAC3E,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,+BAA+B;CAC/B,sCAAsC;CACtC,6BAA6B;CAC7B,2CAA2C;CAC3C,eAAe;CACf,0BAA0B;CAC1B,kCAAkC;AACnC;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;;CAEC,qCAAqC;CACrC,+BAA+B;CAC/B,sCAAsC;CACtC,6BAA6B;CAC7B,2CAA2C;CAC3C,qBAAqB;CACrB,aAAa;CACb,aAAa;CACb,SAAS;CACT,6BAA6B;CAC7B,cAAc;CACd,4BAA4B;AAC7B;;AAEA;;CAEC,gBAAgB;CAChB,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,UAAU;CACV,YAAY;CACZ,uBAAuB;CACvB,gBAAgB;CAChB,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;;CAEC,aAAa;AACd;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,qBAAqB;CACrB,2BAA2B;AAC5B;;AAEA;;CAEC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,4EAA4E;AAC7E;;AAEA;;CAEC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,SAAS;AACV;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,+BAA+B;CAC/B,iCAAiC;CACjC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kCAAkC;CAClC,+BAA+B;CAC/B,iCAAiC;CACjC,qBAAqB;CACrB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,+BAA+B;CAC/B,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,qCAAqC;CACrC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,mCAAmC;CACnC,qCAAqC;CACrC,cAAc;AACf;;AAEA,0EAA0E;AAC1E;CACC,aAAa;CACb,sBAAsB;CACtB,2CAA2C;CAC3C,gBAAgB;CAChB,UAAU;CACV,MAAM;AACP;;AAEA;CACC,MAAM;CACN,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;CAChB,kBAAkB;CAClB,4BAA4B;CAC5B,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,qBAAqB;CACrB,iDAAiD;AAClD;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,+BAA+B;CAC/B,uCAAuC;CACvC,iCAAiC;CACjC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,aAAa;CACb,+BAA+B;CAC/B,kCAAkC;CAClC,iCAAiC;CACjC,mCAAmC;AACpC;;AAEA;CACC,8BAA8B;CAC9B,+CAA+C;AAChD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,UAAU;CACV,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,kCAAkC;CAClC,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sEAAsE;CACtE,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,kCAAkC;CAClC,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA,iFAAiF;AACjF;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;CACR,+BAA+B;CAC/B,qBAAqB;CACrB,eAAe;CACf,oBAAoB;CACpB,WAAW;AACZ;;AAEA,+EAA+E;AAC/E;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW,EAAE,qBAAqB;CAClC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,oBAAoB;CACpB,UAAU;CACV,8BAA8B;CAC9B,WAAW;CACX,0CAA0C;CAC1C,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,eAAe;CACf,aAAa;AACd;;AAEA;CACC,cAAc;CACd,oCAAoC;AACrC;;AAEA;CACC,cAAc;CACd,qCAAqC;AACtC;;AAEA;CACC,cAAc;CACd,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,uCAAuC;AACxC;;AAEA;CACC,KAAK,yBAAyB,EAAE;AACjC;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,sCAAsC;CACtC,6BAA6B;CAC7B,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,eAAe;CACf,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,qCAAqC;CACrC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;CACnC,cAAc;AACf;;;AAGA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,+EAA+E;CAC/E,sCAAsC;CACtC,6BAA6B;AAC9B;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,4BAA4B;CAC5B,aAAa;CACb,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,yCAAyC;AAC1C;;AAEA;CACC,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA,6BAA6B;AAC7B;CACC,iBAAiB;AAClB;;AAEA;CACC,8DAAqZ;AACtZ;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC;EACC,yDAAyD;CAC1D;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA,oDAAoD;AACpD;CACC,sCAAsC;CACtC,6BAA6B;CAC7B,wCAAwC;CACxC,gBAAgB;CAChB,kBAAkB;CAClB,uDAAuD;CACvD,qDAAqD;CACrD,kBAAkB;AACnB;;AAEA;CACC,+CAA+C;AAChD;;AAEA,qDAAqD;AACrD;CACC,gBAAgB;CAChB,kCAAkC;CAClC,iCAAiC;CACjC,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,+BAA+B;CAC/B,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,yCAAyC;AAC1C;;AAEA;CACC,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA,gDAAgD;AAChD;CACC,kCAAkC;CAClC,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,iCAAiC;CACjC,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,sCAAsC;AACvC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,kDAAkD;AAClD;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,4DAA4D;CAC5D,iBAAiB;AAClB;;AAEA,wDAAwD;AACxD;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;AAClB;;AAEA,0CAA0C;AAC1C;CACC,oCAAoC;CACpC,kCAAkC;CAClC,aAAa;CACb,kBAAkB;AACnB;;AAEA,uDAAuD;AACvD;CACC;EACC,eAAe;EACf,OAAO;EACP,6BAA6B;EAC7B,SAAS;EACT,YAAY;EACZ,4BAA4B;EAC5B,2DAA2D;CAC5D;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,aAAa;CACb,yCAAyC;AAC1C;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;CACpB,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,6DAA6D;AAC9D;;AAEA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA,gDAAgD;AAChD;CACC,OAAO;CACP,YAAY;CACZ,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA,+CAA+C;AAC/C;CACC;EACC,2DAA2D;CAC5D;AACD;;AAEA,iDAAiD;AACjD;;;CAGC,mCAAmC;CACnC,mBAAmB;AACpB;;AAEA,uDAAuD;AACvD;CACC,kCAAkC;CAClC,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,iCAAiC;CACjC,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,sCAAsC;AACvC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,aAAa;AACd;;AAEA;;CAEC,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,OAAO;CACP,SAAS;CACT,YAAY;CACZ,aAAa;CACb,oCAAoC;AACrC;;AAEA;CACC,QAAQ;CACR,UAAU;CACV,YAAY;CACZ,aAAa;CACb,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,iBAAiB;CACjB,cAAc;CACd,aAAa;CACb,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,SAAS;AACV;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,4DAA4D;CAC5D,SAAS;CACT,oBAAoB;CACpB,0CAA0C;AAC3C;;AAEA;;;;CAIC,6BAA6B;CAC7B,0CAA0C;CAC1C,mBAAmB;CACnB,2BAA2B;CAC3B,mCAAmC;CACnC,4CAA4C;AAC7C;;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,SAAS;AACV;;AAEA;CACC,+BAA+B;CAC/B,aAAa;CACb,SAAS;CACT,oBAAoB;CACpB,0CAA0C;CAC1C;;iFAEgF;AACjF;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;CACpB,oCAAoC;CACpC,0CAA0C;CAC1C,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,SAAS;CACT,eAAe;CACf,oFAAoF;CACpF,qCAAqC;CACrC,iBAAiB;CACjB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,SAAS;CACT,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,eAAe;CACf,SAAS;AACV;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;CACpB,2CAA2C;CAC3C,kCAAkC;CAClC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,SAAS;CACT,oBAAoB;CACpB;;gFAE+E;CAC/E,0CAA0C;CAC1C,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,qCAAqC;CACrC,2CAA2C;CAC3C,aAAa;CACb,QAAQ;CACR,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,oFAAoF;AACrF;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,4BAA4B;AAC7B;;AAEA,6CAA6C,cAAc,EAAE;AAC7D,6CAA6C,cAAc,EAAE;AAC7D,2CAA2C,cAAc,EAAE;;AAE3D;CACC,aAAa;CACb,8DAA8D;CAC9D,SAAS;CACT,kBAAkB;CAClB,0CAA0C;CAC1C,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,2CAA2C;CAC3C;;gFAE+E;AAChF;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,uBAAuB;CACvB,SAAS;CACT,uBAAuB;CACvB,kDAAkD;CAClD,eAAe;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,yBAAyB;CACzB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,4BAA4B;CAC5B,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,oBAAoB;CACpB,2CAA2C;CAC3C,kCAAkC;CAClC,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,oBAAoB;CACpB,kBAAkB;CAClB,uBAAuB;CACvB,4BAA4B;CAC5B,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,sGAAsG;AACvG;;AAEA;CACC,cAAc;CACd,2BAA2B;AAC5B;;AAEA;CACC,uFAAuF;CACvF,cAAc;CACd,gDAAgD;AACjD;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,gBAAgB;CAChB,gCAAgC;CAChC,2CAA2C;AAC5C;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;CACtB;;sBAEqB;AACtB;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,aAAa;CACb,SAAS;CACT,0CAA0C;CAC1C,sBAAsB;AACvB;;AAEA;CACC,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;AACf;;AAEA;;CAEC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,0CAA0C;CAC1C,SAAS;CACT,kBAAkB;CAClB,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,oBAAoB;CACpB,+EAA+E;CAC/E,6CAA6C;AAC9C;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,OAAO;AACR;;AAEA;CACC,4BAA4B;CAC5B,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;CACpB,2CAA2C;CAC3C,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;CACrC,cAAc;AACf;;AAEA;CACC,oCAAoC;CACpC,cAAc;AACf;;AAEA;CACC,oCAAoC;CACpC,cAAc;AACf;;AAEA;CACC,mCAAmC;CACnC,cAAc;AACf;;AAEA;CACC,qCAAqC;CACrC,cAAc;CACd,eAAe;CACf,6DAA6D;AAC9D;AACA;CACC,oCAAoC;CACpC,cAAc;CACd,qCAAqC;AACtC;AACA;CACC,oCAAoC;CACpC,cAAc;CACd,qCAAqC;AACtC;;AAEA;CACC,cAAc;CACd,qCAAqC;CACrC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;CACnC,cAAc;AACf;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC;EACC,UAAU;EACV,2BAA2B;CAC5B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD;;AAEA;CACC;;EAEC,0BAA0B;CAC3B;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC;;iEAE+D;CAChE;;CAEA;EACC,aAAa;CACd;;CAEA;;;;EAIC,mBAAmB;CACpB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;;EAEC,iBAAiB;CAClB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,OAAO;CACR;AACD;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;CACb,gCAAgC;CAChC,0BAA0B;CAC1B,kCAAkC;CAClC,qCAAqC;AACtC;;AAEA;CACC,oCAAoC;CACpC,4BAA4B;CAC5B,aAAa;CACb,sBAAsB;CACtB,sCAAsC;CACtC,mBAAmB;CACnB,6BAA6B;CAC7B,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,8BAA8B;CAC9B,SAAS;CACT,kBAAkB;CAClB,yCAAyC;CACzC,6EAA6E;AAC9E;;AAEA;;;CAGC,SAAS;CACT,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,cAAc;CACd,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,iCAAiC;CACjC,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,kCAAkC;CAClC,6BAA6B;CAC7B,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,+BAA+B;CAC/B,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,aAAa;AACd;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,aAAa;CACb,wCAAwC;CACxC,iCAAiC;CACjC,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,kBAAkB;CAClB,uBAAuB;CACvB,2BAA2B;CAC3B,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,eAAe;CACf,sBAAsB;CACtB,oBAAoB;CACpB,mBAAmB;CACnB,2BAA2B;CAC3B,WAAW;CACX,eAAe;CACf,4EAA4E;AAC7E;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,kCAAkC;CAClC,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,aAAa;CACb,6BAA6B;AAC9B;;AAEA;;CAEC,WAAW;CACX,YAAY;AACb;;AAEA;;CAEC,qCAAqC;CACrC,oBAAoB;CACpB,6BAA6B;CAC7B,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,aAAa;CACb,kBAAkB;CAClB,kCAAkC;CAClC,iCAAiC;AAClC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;;CAKC,aAAa;CACb,uBAAuB;CACvB,8BAA8B;CAC9B,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,+CAA+C;CAC/C,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,kCAAkC;CAClC,+BAA+B;CAC/B,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;;8DAE8D;AAC9D;CACC,mBAAmB;CACnB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,aAAa;CACb,SAAS;CACT,YAAY;AACb;;AAEA;CACC,yGAAyG;CACzG,gBAAgB;AACjB;;AAEA;CACC,kFAAkF;CAClF,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kCAAkC;CAClC,kBAAkB;CAClB,wBAAwB;CACxB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,mCAAmC;CACnC,mBAAmB;AACpB;;AAEA;;8DAE8D;AAC9D;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,sCAAsC;CACtC,iBAAiB;CACjB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,2BAA2B;CAC3B,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;;8DAE8D;AAC9D;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,cAAc;CACd,cAAc;CACd,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,aAAa;CACb,6BAA6B;CAC7B,sCAAsC;CACtC,+BAA+B;CAC/B,4CAA4C;CAC5C,aAAa;CACb,sBAAsB;CACtB,0BAA0B;CAC1B,yCAAyC;CACzC,uFAAuF;CACvF,8BAA8B;CAC9B,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA,yFAAyF;AACzF;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;CAC9B;AACD;;AAEA;;;;8DAI8D;AAC9D;CACC,2DAA2D;CAC3D;EACC,aAAa;EACb,qCAAqC;EACrC,uCAAuC;CACxC;;CAEA;EACC,YAAY;CACb;;CAEA,yEAAyE;CACzE;EACC,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iFAAiF;EACjF,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;;EAEC,UAAU;EACV,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,WAAW;CACZ;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;CAC3B;;CAEA,2CAA2C;CAC3C;EACC,UAAU;EACV,YAAY;EACZ,aAAa;CACd;;CAEA,4DAA4D;CAC5D;EACC,mBAAmB;EACnB,6BAA6B;EAC7B,iEAAiE;EACjE,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA,8DAA8D;CAC9D;EACC,uDAAuD;EACvD,wDAAwD;EACxD,mDAAmD;EACnD,oDAAoD;EACpD,cAAc;CACf;;CAEA;;;EAGC,gDAAgD;EAChD,kDAAkD;EAClD,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,oBAAoB;EACpB,2EAA2E;EAC3E,4BAA4B;CAC7B;;CAEA;EACC,gDAAgD;EAChD,QAAQ;EACR,oBAAoB;CACrB;;CAEA;EACC,uBAAuB;CACxB;;CAEA;;;;;;;;EAQC,gBAAgB;CACjB;;CAEA;;EAEC,gBAAgB;CACjB;;CAEA;;EAEC,aAAa;CACd;;CAEA;;EAEC,QAAQ;CACT;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,uBAAuB;CACxB;;CAEA,wDAAwD;CACxD;EACC,eAAe;EACf,sEAAsE;EACtE,iDAAiD;EACjD,oBAAoB;EACpB,4EAA4E;CAC7E;;CAEA;EACC,gBAAgB;EAChB,OAAO;EACP,eAAe;CAChB;;CAEA,sCAAsC;CACtC;EACC,gBAAgB;EAChB,eAAe;CAChB;AACD;;AAEA;CACC;;;EAGC,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,oBAAoB;EACpB,YAAY;EACZ,4BAA4B;CAC7B;;CAEA;;EAEC,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;;;;;;;;EAQC,gBAAgB;CACjB;AACD;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,YAAY;CACZ,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kCAAkC;CAClC,kBAAkB;CAClB,wBAAwB;CACxB,qBAAqB;CACrB,aAAa;CACb,eAAe;CACf,iFAAiF;AAClF;;AAEA;;CAEC,aAAa;CACb,8BAA8B;CAC9B,8CAA8C;AAC/C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,2BAA2B;CAC3B,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,2BAA2B;CAC3B,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,YAAY;AACb;;AAEA;;CAEC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,aAAa;CACb,kBAAkB;CAClB,kCAAkC;CAClC,6BAA6B;CAC7B,eAAe;CACf,0DAA0D;AAC3D;;AAEA;CACC,kCAAkC;CAClC,wBAAwB;AACzB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,sCAAsC;CACtC,oDAAoD;AACrD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;CACjB,gBAAgB;CAChB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;;CAEC,iBAAiB;CACjB,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;;;CAGC,aAAa;CACb,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,eAAe;CACf,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,0CAA0C;CAC1C,+BAA+B;CAC/B,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,kCAAkC;CAClC,4BAA4B;CAC5B,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,oCAAoC;CACpC,cAAc;AACf;;AAEA;CACC,uCAAuC;CACvC,qCAAqC;CACrC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,mCAAmC;CACnC,6BAA6B;CAC7B,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,kBAAkB;CAClB,kBAAkB;CAClB,kCAAkC;CAClC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,kCAAkC;CAClC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,2DAA2D;CAC3D,SAAS;CACT,YAAY;AACb;;AAEA;CACC,aAAa;CACb,2DAA2D;CAC3D,SAAS;CACT,YAAY;AACb;;AAEA;CACC,2DAA2D;AAC5D;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,iBAAiB;CACjB,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,0CAA0C;CAC1C,mBAAmB;CACnB,SAAS;AACV;;AAEA;;;;;CAKC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;CAC1C;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,uBAAuB;CACxB;;CAEA;EACC,gDAAgD;CACjD;AACD;;AAEA;CACC;EACC,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;;;;EAIC,aAAa;CACd;;CAEA;EACC,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;;EAEC,0BAA0B;CAC3B;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;;;EAGC,sBAAsB;CACvB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA,0FAA0F;AAC1F;CACC,qBAAqB;CACrB,iDAAiD;AAClD;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B","sourcesContent":["@import \"../lib/styles/chart-theme.css\";\r\n@import \"../lib/styles/chart-splitter.css\";\r\n\r\n:root,\r\n[data-chart-theme] {\r\n\t--gc-bg: var(--rsc-bg, #08101d);\r\n\t--gc-surface: var(--rsc-surface, #0f172a);\r\n\t--gc-surface-sub: var(--rsc-surface-sub, #111827);\r\n\t--gc-border: var(--rsc-border, rgba(148, 163, 184, 0.18));\r\n\t--gc-border-mid: var(--rsc-border-mid, rgba(148, 163, 184, 0.26));\r\n\t--gc-text: var(--rsc-text, #e2e8f0);\r\n\t--gc-text-muted: var(--rsc-text-muted, #94a3b8);\r\n\t--gc-text-micro: var(--rsc-text-micro, #64748b);\r\n\t--gc-accent: var(--rsc-accent, #22d3ee);\r\n\t--gc-accent-bg: var(--rsc-accent-bg, rgba(34, 211, 238, 0.14));\r\n\t--gc-up: var(--rsc-up, rgb(38, 166, 154));\r\n\t--gc-dn: var(--rsc-dn, rgb(239, 83, 80));\r\n\t/* UI/UX GAP AUDIT: Chart-first layout adjustments */\r\n\t--gc-topbar-h: 48px;\r\n\t--gc-bottombar-h: 32px;\r\n\t--gc-toolbar-w: 40px;\r\n\t--gc-toolbar-handle-w: 20px;\r\n\t--gc-toolbar-handle-h: 44px;\r\n\t--gc-toolbar-button-size: 32px;\r\n\t--gc-toolbar-gap: 4px;\r\n\t--gc-toolbar-section-gap: 4px;\r\n\t--gc-toolbar-flyout-padding: 6px;\r\n\t--gc-toolbar-flyout-margin: 8px;\r\n\t--gc-toolbar-flyout-button-size: 32px;\r\n\t--gc-toolbar-flyout-button-size-compact: 32px;\r\n\t/* UI/UX: Touch target min 44px per accessibility checklist */\r\n\t--gc-touch-target-min: 44px;\r\n\t--gc-touch-spacing-min: 8px;\r\n\t--gc-safe-top: env(safe-area-inset-top, 0px);\r\n\t--gc-safe-right: env(safe-area-inset-right, 0px);\r\n\t--gc-safe-bottom: env(safe-area-inset-bottom, 0px);\r\n\t--gc-safe-left: env(safe-area-inset-left, 0px);\r\n\t--gc-keyboard-inset-bottom: 0px;\r\n\t--gc-toolbar-motion-fast: 120ms;\r\n\t--gc-toolbar-motion-default: 150ms;\r\n\t/* UI/UX: Unified radius token */\r\n\t--gc-radius: 8px;\r\n\t--gc-radius-btn: 6px;\r\n\t/* UI/UX: Context rail width - narrower for chart-first */\r\n\t--gc-context-rail-w: 240px;\r\n\t--gc-context-rail-collapsed-w: 48px;\r\n\t--gc-font: \"Inter\", \"Segoe UI Variable Text\", \"Aptos\", \"Segoe UI\", system-ui, sans-serif;\r\n\t--gc-mono: \"JetBrains Mono\", \"Cascadia Code\", \"Consolas\", monospace;\r\n\t--demo-bg: #0b1120;\r\n\t--demo-bg-soft: #111827;\r\n\t--demo-panel: rgba(15, 23, 42, 0.82);\r\n\t--demo-panel-border: rgba(148, 163, 184, 0.18);\r\n\t--demo-panel-border-strong: rgba(148, 163, 184, 0.26);\r\n\t--demo-text: #e2e8f0;\r\n\t--demo-text-soft: #94a3b8;\r\n\t--demo-accent: #22d3ee;\r\n\t--demo-accent-alt: #f59e0b;\r\n\t--demo-success: rgb(38, 166, 154);\r\n\t--demo-danger: rgb(239, 83, 80);\r\n\t--demo-warning: #fb923c;\r\n}\r\n\r\nhtml, body, #root {\r\n\theight: 100%;\r\n\toverflow: hidden;\r\n}\r\n\r\nhtml[data-chart-theme=\"classic-dark\"],\r\nhtml[data-chart-theme=\"trading-night\"],\r\nhtml[data-chart-theme=\"high-contrast\"] {\r\n\tcolor-scheme: dark;\r\n}\r\n\r\nhtml[data-chart-theme=\"modern-light\"],\r\nhtml[data-chart-theme=\"neutral-pro\"] {\r\n\tcolor-scheme: light;\r\n}\r\n\r\nbody {\r\n\tmargin: 0;\r\n\tbackground: linear-gradient(180deg, #08101d 0%, #0b1120 38%, #0d1525 100%);\r\n\tcolor: var(--gc-text);\r\n\tfont-family: \"Inter\", \"Segoe UI Variable Text\", \"Aptos\", \"Segoe UI\", sans-serif;\r\n\toverflow: hidden;\r\n}\r\n\r\nhtml[data-chart-theme=\"classic-dark\"] body,\r\nhtml[data-chart-theme=\"trading-night\"] body,\r\nhtml[data-chart-theme=\"high-contrast\"] body {\r\n\tbackground:\r\n\t\tradial-gradient(circle at top left, rgba(34, 211, 238, 0.16), transparent 28%),\r\n\t\tradial-gradient(circle at top right, rgba(245, 158, 11, 0.14), transparent 26%),\r\n\t\tlinear-gradient(180deg, #08101d 0%, #0b1120 38%, #0d1525 100%);\r\n}\r\n\r\nhtml[data-chart-theme=\"modern-light\"] body,\r\nhtml[data-chart-theme=\"neutral-pro\"] body {\r\n\tbackground:\r\n\t\tradial-gradient(circle at top left, rgba(11, 116, 222, 0.1), transparent 28%),\r\n\t\tradial-gradient(circle at top right, rgba(245, 158, 11, 0.08), transparent 24%),\r\n\t\tlinear-gradient(180deg, #f0f4ff 0%, #f8fbff 42%, #eef2f8 100%);\r\n}\r\n\r\nbody::before {\r\n\tcontent: \"\";\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tpointer-events: none;\r\n\tbackground-image:\r\n\t\tlinear-gradient(rgba(148, 163, 184, 0.05) 1px, transparent 1px),\r\n\t\tlinear-gradient(90deg, rgba(148, 163, 184, 0.05) 1px, transparent 1px);\r\n\tbackground-size: 42px 42px;\r\n\topacity: 0.35;\r\n\tmask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.9), transparent 92%);\r\n}\r\n\r\nhtml[data-chart-mode=\"light\"] body::before {\r\n\topacity: 0.18;\r\n}\r\n\r\n#root {\r\n\theight: 100%;\r\n}\r\n\r\n/* Legacy demo layout restored for the current JSX markup. */\r\n.gc-terminal {\r\n\tdisplay: grid;\r\n\tgrid-template-rows: var(--gc-topbar-h) minmax(0, 1fr) var(--gc-bottombar-h);\r\n\theight: 100%;\r\n\tpadding: var(--gc-safe-top) var(--gc-safe-right) var(--gc-safe-bottom) var(--gc-safe-left);\r\n\tbox-sizing: border-box;\r\n\tbackground: var(--gc-bg);\r\n\tborder: 1px solid var(--gc-border);\r\n\toverflow: hidden;\r\n\tuser-select: none;\r\n\t-webkit-user-select: none;\r\n\t-ms-user-select: none;\r\n}\r\n\r\n.gc-terminal input,\r\n.gc-terminal textarea {\r\n\tuser-select: text;\r\n\t-webkit-user-select: text;\r\n\t-ms-user-select: text;\r\n}\r\n\r\n.gc-topbar {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 0 12px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-topbar__left,\r\n.gc-topbar__right {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-logo {\r\n\tflex-shrink: 0;\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tdisplay: grid;\r\n\tplace-items: center;\r\n\tborder-radius: 7px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: linear-gradient(135deg, var(--gc-surface-sub), var(--gc-surface));\r\n\tcolor: var(--gc-text);\r\n\tfont-size: 10px;\r\n\tfont-weight: 800;\r\n\tletter-spacing: -0.3px;\r\n}\r\n\r\n.gc-symbol-block {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpadding: 0 4px;\r\n}\r\n\r\n.gc-symbol-name {\r\n\tfont-size: 15px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-symbol-name--btn {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 3px;\r\n\tbackground: none;\r\n\tborder: none;\r\n\tpadding: 0;\r\n\tcursor: pointer;\r\n\ttransition: color 0.15s;\r\n}\r\n\r\n.gc-symbol-name--btn:hover {\r\n\tcolor: var(--gc-accent, #2196f3);\r\n}\r\n\r\n.gc-symbol-exchange {\r\n\tfont-size: 9px;\r\n\tfont-weight: 500;\r\n\tcolor: var(--gc-text-muted);\r\n\tletter-spacing: 0.4px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.gc-symbol-exchange__caret {\r\n\tfont-size: 9px;\r\n\topacity: 0.55;\r\n}\r\n\r\n.gc-topbar-sep {\r\n\twidth: 1px;\r\n\theight: 20px;\r\n\tbackground: var(--gc-border);\r\n\tflex-shrink: 0;\r\n\tmargin: 0 4px;\r\n}\r\n\r\n.gc-tf-chips {\r\n\tdisplay: flex;\r\n\tgap: 2px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-tf-chip {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n\tpadding: 4px 7px;\r\n\tborder-radius: var(--gc-radius-btn);\r\n\tcursor: pointer;\r\n\ttransition: background 100ms, color 100ms;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-tf-chip:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-tf-chip--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.gc-topbar-btn {\r\n\tappearance: none;\r\n\tborder: 1px solid transparent;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text);\r\n\tfont-size: 12px;\r\n\tpadding: 0 8px;\r\n\theight: 28px;\r\n\tbox-sizing: border-box;\r\n\tborder-radius: var(--gc-radius-btn);\r\n\tcursor: pointer;\r\n\twhite-space: nowrap;\r\n\ttransition: background 120ms, color 120ms;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n}\r\n\r\n.gc-topbar-btn:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-topbar-btn--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n}\r\n\r\n.gc-datasource-switcher {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tflex-wrap: wrap;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-datasource-btn {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11.5px;\r\n\tpadding: 5px 9px;\r\n\tborder-radius: var(--gc-radius-btn);\r\n\tcursor: pointer;\r\n\twhite-space: nowrap;\r\n\ttransition: background 100ms, color 100ms, border-color 100ms;\r\n}\r\n\r\n.gc-datasource-btn:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-datasource-btn--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n\tborder-color: transparent;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.gc-paper-trade-panel {\r\n\tposition: absolute;\r\n\tleft: 16px;\r\n\tbottom: 16px;\r\n\tz-index: 37;\r\n\twidth: min(320px, calc(100vw - 32px));\r\n\tpadding: 12px 14px;\r\n\tborder-radius: 16px;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 16px 38px rgba(2, 6, 23, 0.18);\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\nhtml[data-chart-mode=\"dark\"] .gc-paper-trade-panel {\r\n\tbackground: rgba(var(--gc-surface, 30 33 48) / 0.96);\r\n\tbackdrop-filter: blur(12px);\r\n\t-webkit-backdrop-filter: blur(12px);\r\n}\r\n\r\n.gc-paper-trade-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 10px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-paper-trade-panel__header-actions {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: flex-end;\r\n}\r\n\r\n.gc-paper-trade-panel__chip {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 5px 8px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.gc-paper-trade-panel__header strong {\r\n\tfont-size: 13px;\r\n\tfont-weight: 800;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-paper-trade-panel__reset {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tpadding: 5px 8px;\r\n\tborder-radius: 5px;\r\n\tcursor: pointer;\r\n\twhite-space: nowrap;\r\n\ttransition: background 100ms ease, color 100ms ease, border-color 100ms ease;\r\n}\r\n\r\n.gc-paper-trade-panel__reset:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-paper-trade-panel__hint {\r\n\tfont-size: 11px;\r\n\tline-height: 1.45;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-paper-trade-panel__report {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tpadding-top: 4px;\r\n\tborder-top: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-paper-trade-panel__section-title {\r\n\tfont-size: 11px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-paper-trade-panel__stats {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(3, minmax(0, 1fr));\r\n\tgap: 8px;\r\n}\r\n\r\n.gc-paper-trade-panel__stat {\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tpadding: 8px 9px;\r\n\tborder-radius: 10px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n}\r\n\r\n.gc-paper-trade-panel__label {\r\n\tfont-size: 10px;\r\n\tfont-weight: 600;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.08em;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-paper-trade-panel__value {\r\n\tfont-size: 13px;\r\n\tfont-weight: 800;\r\n\tfont-variant-numeric: tabular-nums;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-paper-trade-panel__position {\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tpadding: 8px 9px;\r\n\tborder-radius: 10px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-paper-trade-panel__position-label {\r\n\tfont-size: 10px;\r\n\tfont-weight: 600;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.08em;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-paper-trade-panel__position strong {\r\n\tfont-size: 13px;\r\n\tfont-weight: 800;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-paper-trade-panel__position-meta {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px 10px;\r\n\tfont-size: 11px;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-variant-numeric: tabular-nums;\r\n}\r\n\r\n.gc-paper-trade-panel__position--idle {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.gc-paper-trade-panel__journal-list {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n}\r\n\r\n.gc-paper-trade-panel__journal-item {\r\n\tdisplay: grid;\r\n\tgap: 5px;\r\n\tpadding: 10px 11px;\r\n\tborder-radius: 12px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n}\r\n\r\n.gc-paper-trade-panel__journal-item--positive {\r\n\tborder-color: rgba(16, 185, 129, 0.3);\r\n\tbox-shadow: 0 0 0 1px rgba(16, 185, 129, 0.08) inset;\r\n}\r\n\r\n.gc-paper-trade-panel__journal-item--negative {\r\n\tborder-color: rgba(239, 68, 68, 0.3);\r\n\tbox-shadow: 0 0 0 1px rgba(239, 68, 68, 0.08) inset;\r\n}\r\n\r\n.gc-paper-trade-panel__journal-top,\r\n.gc-paper-trade-panel__journal-meta {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 8px;\r\n\tfont-size: 11px;\r\n\tfont-variant-numeric: tabular-nums;\r\n\tcolor: var(--gc-text-muted);\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-paper-trade-panel__journal-top strong {\r\n\tfont-size: 12px;\r\n\tfont-weight: 800;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-paper-trade-panel__journal-empty {\r\n\tpadding: 12px 10px;\r\n\tborder-radius: 12px;\r\n\tborder: 1px dashed var(--gc-border-mid);\r\n\tbackground: rgba(15, 23, 42, 0.35);\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.gc-theme-toggle {\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tjustify-content: center;\r\n\tpadding: 0;\r\n}\r\n\r\n.vnsc-candle-type-select {\r\n\tappearance: none;\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tmin-width: 110px;\r\n\theight: 28px;\r\n\tpadding: 0 20px 0 8px;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: var(--gc-radius-btn);\r\n\tbackground-color: transparent;\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cpath fill='%23787b86' d='M0 2.5 L4 6.5 L8 2.5 Z'/%3E%3C/svg%3E\");\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: right 8px center;\r\n\tcolor: var(--gc-text);\r\n\tfont-family: var(--gc-font);\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n\tcursor: pointer;\r\n\ttransition: background-color 120ms, color 120ms;\r\n}\r\n\r\n.vnsc-candle-type-select:hover {\r\n\tbackground-color: var(--gc-surface-sub);\r\n}\r\n\r\n.vnsc-candle-type-select:focus-visible {\r\n\toutline: none;\r\n\tbackground-color: var(--gc-surface-sub);\r\n}\r\n\r\n.vnsc-candle-type-select--tf {\r\n\tmin-width: 54px;\r\n\tpadding: 0 16px 0 8px;\r\n\tbackground-position: right 6px center;\r\n}\r\n\r\n.gc-source-label-btn {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 2px;\r\n\theight: 28px;\r\n\tpadding: 0 8px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: var(--gc-radius-btn);\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text);\r\n\tfont-family: var(--gc-font);\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-source-label-btn:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n}\r\n\r\n.gc-chart-type-wrap {\r\n\tposition: relative;\r\n}\r\n\r\n.gc-chart-type-btn {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n}\r\n\r\n.gc-chart-type-menu {\r\n\tposition: absolute;\r\n\ttop: calc(100% + 4px);\r\n\tleft: 0;\r\n\tz-index: 220;\r\n\tmin-width: 170px;\r\n\tpadding: 4px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 8px 24px rgba(17, 24, 39, 0.16);\r\n}\r\n\r\n.gc-chart-type-menu--right {\r\n\tleft: auto;\r\n\tright: 0;\r\n}\r\n\r\n.gc-chart-type-item {\r\n\twidth: 100%;\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text);\r\n\tfont-family: var(--gc-font);\r\n\tfont-size: 12.5px;\r\n\tpadding: 7px 10px;\r\n\tborder-radius: var(--gc-radius-btn);\r\n\ttext-align: left;\r\n\tcursor: pointer;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.gc-chart-type-item:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n}\r\n\r\n.gc-chart-type-item--active {\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 600;\r\n}\r\n\r\n.gc-chart-type-item--inline {\r\n\twidth: auto;\r\n\tpadding: 6px 10px;\r\n}\r\n\r\n.gc-profile-menu__lang-row {\r\n\tdisplay: flex;\r\n\tgap: 2px;\r\n\tpadding: 2px 4px;\r\n}\r\n\r\n.gc-profile-menu__section-label {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 5px;\r\n\tpadding: 6px 10px 2px;\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--gc-text-soft);\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.04em;\r\n}\r\n\r\n.gc-profile-menu__divider {\r\n\theight: 1px;\r\n\tmargin: 4px 0;\r\n\tbackground: var(--gc-border);\r\n}\r\n\r\n/* Icon + text alignment for profile menu items */\r\n.gc-profile-menu .gc-chart-type-item {\r\n\tgap: 8px;\r\n}\r\n\r\n.gc-profile-menu .gc-chart-type-item svg {\r\n\tflex-shrink: 0;\r\n\topacity: 0.75;\r\n}\r\n\r\n.gc-version-text {\r\n\tfont-size: 11px;\r\n\tcolor: var(--gc-text-micro);\r\n}\r\n\r\n.gc-live-badge {\r\n\tfont-size: 10.5px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-up);\r\n\tbackground: var(--gc-accent-bg);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tpadding: 3px 8px;\r\n\tborder-radius: 999px;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-offline-badge {\r\n\tfont-size: 10.5px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--demo-warning, #fb923c);\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tpadding: 3px 8px;\r\n\tborder-radius: 999px;\r\n\tcursor: help;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-loading-badge {\r\n\tfont-size: 10.5px;\r\n\tcolor: var(--gc-text-muted);\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-upgrade-btn {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: #6e3fef;\r\n\tcolor: #fff;\r\n\tfont-size: 11.5px;\r\n\tfont-weight: 700;\r\n\tpadding: 6px 14px;\r\n\tborder-radius: 999px;\r\n\tcursor: pointer;\r\n\ttransition: opacity 120ms;\r\n}\r\n\r\n.gc-upgrade-btn:hover {\r\n\topacity: 0.9;\r\n}\r\n\r\n.gc-main {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: var(--gc-context-rail-w, 240px) var(--gc-toolbar-w) minmax(0, 1fr);\r\n\tgrid-template-rows: minmax(0, 1fr);\r\n\tmin-height: 0;\r\n\toverflow: hidden;\r\n\tposition: relative;\r\n\t/* GAP 1 FIX: Contain layout/style/paint to prevent layout trashing */\r\n\tcontain: layout style paint;\r\n}\r\n\r\n/* Context rail collapsed state */\r\n.gc-main:has(.gc-context-rail--collapsed) {\r\n\tgrid-template-columns: var(--gc-context-rail-collapsed-w, 48px) var(--gc-toolbar-w) minmax(0, 1fr);\r\n}\r\n\r\n/* Mobile: context rail becomes overlay */\r\n@media (max-width: 768px) {\r\n\t.gc-main {\r\n\t\tgrid-template-columns: var(--gc-toolbar-w) minmax(0, 1fr);\r\n\t}\r\n\t\r\n\t.gc-main:has(.gc-context-rail--open) {\r\n\t\tgrid-template-columns: var(--gc-toolbar-w) minmax(0, 1fr);\r\n\t}\r\n}\r\n\r\n.gc-tools {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\twidth: var(--gc-toolbar-w);\r\n\tborder-right: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tpadding: 8px 0;\r\n\tgap: 3px;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\tscrollbar-width: thin;\r\n\tscrollbar-color: color-mix(in srgb, var(--gc-border-mid) 86%, transparent) transparent;\r\n}\r\n\r\n.gc-tools-shell {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\twidth: var(--gc-toolbar-w);\r\n\tz-index: 360;\r\n\toverflow: visible;\r\n\ttransition: width var(--gc-toolbar-motion-default) ease;\r\n}\r\n\r\n.gc-tools-handle {\r\n\tdisplay: none;\r\n}\r\n\r\n@media (min-width: 768px) and (hover: hover) and (pointer: fine) {\r\n\t.gc-tools-shell {\r\n\t\twidth: var(--gc-toolbar-handle-w);\r\n\t\tpointer-events: none;\r\n\t\tz-index: 360;\r\n\t}\r\n\r\n\t.gc-tools {\r\n\t\tleft: calc(-1 * var(--gc-toolbar-w));\r\n\t\toverflow: visible;\r\n\t\tborder-right-color: transparent;\r\n\t\tbox-shadow: none;\r\n\t\tpointer-events: auto;\r\n\t\tz-index: 3;\r\n\t\ttransition: left var(--gc-toolbar-motion-default) ease, box-shadow var(--gc-toolbar-motion-default) ease, border-color var(--gc-toolbar-motion-default) ease;\r\n\t}\r\n\r\n\t.gc-tools-shell:hover .gc-tools,\r\n\t.gc-tools:hover,\r\n\t.gc-tools:focus-within,\r\n\t.gc-tools-shell:focus-within .gc-tools {\r\n\t\tleft: 0;\r\n\t\tbox-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);\r\n\t\tborder-right-color: var(--gc-border);\r\n\t}\r\n\r\n\t.gc-tools-handle {\r\n\t\tdisplay: flex;\r\n\t\tposition: absolute;\r\n\t\ttop: 50%;\r\n\t\tleft: 0;\r\n\t\twidth: var(--gc-toolbar-handle-w);\r\n\t\theight: var(--gc-toolbar-handle-h);\r\n\t\ttransform: translateY(-50%);\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tborder-radius: 0 999px 999px 0;\r\n\t\tborder: 1px solid color-mix(in srgb, var(--gc-border-mid) 100%, transparent);\r\n\t\tborder-left: none;\r\n\t\tbackground: linear-gradient(\r\n\t\t\t180deg,\r\n\t\t\tcolor-mix(in srgb, var(--gc-surface) 92%, var(--gc-accent) 8%),\r\n\t\t\tcolor-mix(in srgb, var(--gc-surface-sub) 88%, var(--gc-accent) 12%)\r\n\t\t);\r\n\t\tbox-shadow: 6px 10px 22px rgba(15, 23, 42, 0.16);\r\n\t\tpointer-events: auto;\r\n\t\topacity: 1;\r\n\t\tz-index: 2;\r\n\t\ttransition: opacity var(--gc-toolbar-motion-fast) ease, transform var(--gc-toolbar-motion-fast) ease, box-shadow var(--gc-toolbar-motion-fast) ease;\r\n\t}\r\n\r\n\t.gc-tools-handle::before {\r\n\t\tcontent: \"\";\r\n\t\twidth: 3px;\r\n\t\theight: 3px;\r\n\t\tborder-radius: 999px;\r\n\t\tbackground: color-mix(in srgb, var(--gc-text-muted) 82%, white 18%);\r\n\t\tbox-shadow:\r\n\t\t\t0 -6px 0 color-mix(in srgb, var(--gc-text-muted) 82%, white 18%),\r\n\t\t\t0 6px 0 color-mix(in srgb, var(--gc-text-muted) 82%, white 18%);\r\n\t}\r\n\r\n\t.gc-tools-shell:hover .gc-tools-handle,\r\n\t.gc-tools-shell:focus-within .gc-tools-handle {\r\n\t\tbox-shadow: 8px 12px 24px rgba(15, 23, 42, 0.2);\r\n\t}\r\n\r\n}\r\n\r\n.gc-tools-group {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tgap: var(--gc-toolbar-section-gap);\r\n}\r\n\r\n.rsc-toolbar-divider {\r\n\twidth: 24px;\r\n\theight: 1px;\r\n\tmargin: 5px 0;\r\n\tbackground: rgba(148, 163, 184, 0.28);\r\n}\r\n\r\n.gc-tool-btn {\r\n\tappearance: none;\r\n\tborder: 1px solid transparent;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\twidth: var(--gc-toolbar-button-size);\r\n\theight: var(--gc-toolbar-button-size);\r\n\tpadding: 0;\r\n\tdisplay: grid;\r\n\tplace-items: center;\r\n\tborder-radius: 9px;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms, color 100ms, border-color 100ms, transform 100ms;\r\n}\r\n\r\n.gc-tool-btn:hover {\r\n\ttransform: translateY(-1px);\r\n}\r\n\r\n/* PRIORITY 3 FIX: Focus visible outline for accessibility */\r\n.gc-tool-btn:focus-visible {\r\n\toutline: 2px solid var(--gc-accent);\r\n\toutline-offset: 2px;\r\n}\r\n\r\n.gc-tool-btn--active {\r\n\tbackground: linear-gradient(180deg, var(--gc-accent-bg), color-mix(in srgb, var(--gc-accent-bg) 68%, transparent));\r\n\tcolor: var(--gc-accent);\r\n\tborder-color: color-mix(in srgb, var(--gc-accent) 38%, transparent);\r\n\tbox-shadow: inset 0 0 0 1px color-mix(in srgb, var(--gc-accent) 16%, transparent);\r\n}\r\n\r\n.gc-chart-area {\r\n\tposition: absolute;\r\n\tinset: 0 0 0 var(--gc-toolbar-w);\r\n\tmin-width: 0;\r\n\tmin-height: 0;\r\n\tdisplay: grid;\r\n\tgrid-template-rows: 32px minmax(0, 1fr);\r\n\tbackground: var(--gc-surface);\r\n\toverflow: hidden;\r\n}\r\n\r\n@media (min-width: 768px) and (hover: hover) and (pointer: fine) {\r\n\t.gc-chart-area {\r\n\t\tinset: 0;\r\n\t}\r\n}\r\n\r\n.gc-ohlc-strip {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 14px;\r\n\tpadding: 0 12px;\r\n\tfont-size: 11.5px;\r\n\tcolor: var(--gc-text-muted);\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\ttransition: padding-left var(--gc-toolbar-motion-default, 150ms) ease;\r\n}\r\n\r\n@media (min-width: 768px) and (hover: hover) and (pointer: fine) {\r\n\t.gc-ohlc-strip {\r\n\t\tpadding-left: calc(var(--gc-toolbar-handle-w, 24px) + 12px);\r\n\t}\r\n\t.gc-tools-shell:hover ~ .gc-chart-area .gc-ohlc-strip,\r\n\t.gc-tools-shell:focus-within ~ .gc-chart-area .gc-ohlc-strip {\r\n\t\tpadding-left: calc(var(--gc-toolbar-w, 56px) + 12px);\r\n\t}\r\n}\r\n\r\n.gc-ohlc-pair {\r\n\tfont-weight: 600;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-ohlc-tf {\r\n\tfont-weight: 400;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-ohlc-item b {\r\n\tfont-weight: 600;\r\n\tcolor: var(--gc-text);\r\n\tmargin-left: 2px;\r\n}\r\n\r\n.gc-ohlc-vol {\r\n\tcolor: var(--gc-text-micro);\r\n}\r\n\r\n.gc-col-up {\r\n\tcolor: var(--gc-up) !important;\r\n}\r\n\r\n.gc-col-dn {\r\n\tcolor: var(--gc-dn) !important;\r\n}\r\n\r\n.gc-chart-shell {\r\n\tmin-height: 0;\r\n\theight: 100%;\r\n\toverflow: hidden;\r\n\tbackground: var(--gc-surface);\r\n\tposition: relative;\r\n}\r\n\r\n.gc-vni-panel {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tpadding: 10px 12px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n\tbackground: linear-gradient(180deg, rgba(41, 98, 255, 0.08), rgba(41, 98, 255, 0.02));\r\n\tbackdrop-filter: blur(8px);\r\n\t-webkit-backdrop-filter: blur(8px);\r\n}\r\n\r\n.gc-vni-panel__row {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tflex-wrap: wrap;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-vni-panel__error {\r\n\tfont-size: 12px;\r\n\tcolor: var(--gc-dn);\r\n\tline-height: 1.35;\r\n}\r\n\r\n.gc-symbol-search {\r\n\tposition: relative;\r\n\tmin-width: min(280px, 100%);\r\n\tflex: 1 1 280px;\r\n}\r\n\r\n/* In topbar, constrain to compact inline width */\r\n.gc-symbol-block .gc-symbol-search {\r\n\tflex: 0 1 180px;\r\n\tmin-width: 120px;\r\n}\r\n\r\n.gc-symbol-search__input,\r\n.gc-form-input {\r\n\twidth: 100%;\r\n\tbox-sizing: border-box;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text);\r\n\tfont: inherit;\r\n\tfont-size: 12px;\r\n\tline-height: 1.4;\r\n\tpadding: 8px 10px;\r\n\tborder-radius: 6px;\r\n\toutline: none;\r\n\ttransition: border-color 100ms ease, box-shadow 100ms ease;\r\n}\r\n\r\n/* Compact height when inside topbar symbol block */\r\n.gc-symbol-block .gc-symbol-search__input {\r\n\theight: 28px;\r\n\tpadding: 0 8px;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.gc-symbol-search__input:focus,\r\n.gc-form-input:focus {\r\n\tborder-color: var(--gc-accent);\r\n\tbox-shadow: 0 0 0 2px rgba(41, 98, 255, 0.12);\r\n}\r\n\r\n.gc-symbol-search__dropdown {\r\n\tposition: absolute;\r\n\tz-index: 22;\r\n\ttop: calc(100% + 6px);\r\n\tleft: 0;\r\n\tright: 0;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tborder-radius: 10px;\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 20px 40px rgba(2, 6, 23, 0.2);\r\n\tmax-height: 320px;\r\n\toverflow: auto;\r\n}\r\n\r\n/* Inner ul inside results panel */\r\n.gc-symbol-search__dropdown ul {\r\n\tmargin: 0;\r\n\tpadding: 6px;\r\n\tlist-style: none;\r\n}\r\n\r\n.gc-symbol-search__item {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpadding: 8px 10px;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 12px;\r\n\ttransition: background 100ms ease, color 100ms ease;\r\n}\r\n\r\n.gc-symbol-search__item:hover,\r\n.gc-symbol-search__item--highlighted {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-symbol-search__symbol {\r\n\tfont-weight: 700;\r\n\tcolor: inherit;\r\n}\r\n\r\n.gc-symbol-search__name {\r\n\tfont-size: 11px;\r\n\tcolor: inherit;\r\n}\r\n\r\n/* M-02: Exchange filter bar inside dropdown */\r\n.gc-symbol-search__exchange-bar {\r\n\tdisplay: flex;\r\n\tgap: 4px;\r\n\tpadding: 6px 8px 4px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-symbol-search__ex-btn {\r\n\tpadding: 2px 8px;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tcursor: pointer;\r\n\ttransition: background 0.15s, color 0.15s;\r\n}\r\n\r\n.gc-symbol-search__ex-btn:hover {\r\n\tbackground: var(--gc-bg-active);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-symbol-search__ex-btn--active {\r\n\tbackground: var(--gc-accent, #3b82f6);\r\n\tborder-color: var(--gc-accent, #3b82f6);\r\n\tcolor: #fff;\r\n}\r\n\r\n/* Exchange badge in result rows */\r\n.gc-symbol-search__ex-badge {\r\n\tfont-size: 9px;\r\n\tfont-weight: 700;\r\n\tpadding: 1px 4px;\r\n\tborder-radius: 3px;\r\n\tbackground: var(--gc-bg-active);\r\n\tcolor: var(--gc-text-muted);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.gc-symbol-search__ex-badge--hose { background: rgba(16, 185, 129, 0.18); color: #10b981; }\r\n.gc-symbol-search__ex-badge--hnx { background: rgba(59, 130, 246, 0.18); color: #3b82f6; }\r\n.gc-symbol-search__ex-badge--upcom { background: rgba(245, 158, 11, 0.18); color: #f59e0b; }\r\n\r\n/* M-03/M-04: Empty-query panel sections */\r\n.gc-symbol-search__section {\r\n\tpadding: 6px 8px 4px;\r\n}\r\n\r\n.gc-symbol-search__section + .gc-symbol-search__section {\r\n\tborder-top: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-symbol-search__section-label {\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text-muted);\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.06em;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.gc-symbol-search__chip-row {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 4px;\r\n}\r\n\r\n.gc-symbol-search__chip {\r\n\tpadding: 2px 7px;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: background 0.12s;\r\n}\r\n\r\n.gc-symbol-search__chip:hover {\r\n\tbackground: var(--gc-bg-active);\r\n}\r\n\r\n.gc-symbol-search__chip--vn30 {\r\n\tborder-color: rgba(16, 185, 129, 0.35);\r\n\tcolor: #10b981;\r\n}\r\n\r\n.gc-symbol-search__chip--vn30:hover {\r\n\tbackground: rgba(16, 185, 129, 0.12);\r\n}\r\n\r\n/* M-05: Top bar company breadcrumb */\r\n.gc-symbol-breadcrumb {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 5px;\r\n\tmax-width: 220px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-symbol-ex-badge {\r\n\tfont-size: 9px;\r\n\tfont-weight: 700;\r\n\tpadding: 1px 5px;\r\n\tborder-radius: 3px;\r\n\tbackground: var(--gc-bg-active);\r\n\tcolor: var(--gc-text-muted);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.gc-symbol-ex-badge--hose { background: rgba(16, 185, 129, 0.18); color: #10b981; }\r\n.gc-symbol-ex-badge--hnx { background: rgba(59, 130, 246, 0.18); color: #3b82f6; }\r\n.gc-symbol-ex-badge--upcom { background: rgba(245, 158, 11, 0.18); color: #f59e0b; }\r\n\r\n.gc-symbol-company-name {\r\n\tfont-size: 11px;\r\n\tcolor: var(--gc-text-muted);\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.gc-whale-panel {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\tpadding: 10px 12px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: 10px;\r\n\tbackground: rgba(15, 23, 42, 0.04);\r\n\tmin-width: min(420px, 100%);\r\n}\r\n\r\n.gc-whale-panel--empty {\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 12px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-whale-panel__title {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-whale-panel__net {\r\n\tdisplay: flex;\r\n\talign-items: baseline;\r\n\tjustify-content: space-between;\r\n\tgap: 10px;\r\n\tpadding: 8px 10px;\r\n\tborder-radius: 8px;\r\n\tbackground: var(--gc-surface-sub);\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.gc-whale-panel__net[data-positive=\"true\"] {\r\n\tcolor: var(--gc-up);\r\n}\r\n\r\n.gc-whale-panel__net[data-positive=\"false\"] {\r\n\tcolor: var(--gc-dn);\r\n}\r\n\r\n.gc-whale-panel__net-value {\r\n\tfont-variant-numeric: tabular-nums;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-whale-panel__table {\r\n\twidth: 100%;\r\n\tborder-collapse: collapse;\r\n\tfont-size: 11.5px;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-whale-panel__table th,\r\n.gc-whale-panel__table td {\r\n\tpadding: 5px 0;\r\n\ttext-align: right;\r\n\tfont-variant-numeric: tabular-nums;\r\n}\r\n\r\n.gc-whale-panel__table th:first-child,\r\n.gc-whale-panel__table td:first-child {\r\n\ttext-align: left;\r\n}\r\n\r\n.gc-whale-panel__row-label {\r\n\tcolor: var(--gc-text);\r\n\tfont-weight: 600;\r\n}\r\n\r\n.gc-whale-panel__buy {\r\n\tcolor: var(--gc-up);\r\n}\r\n\r\n.gc-whale-panel__sell {\r\n\tcolor: var(--gc-dn);\r\n}\r\n\r\n.gc-form-label {\r\n\tdisplay: inline-block;\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--gc-text-muted);\r\n\tmargin-bottom: 6px;\r\n}\r\n\r\n.gc-btn {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont: inherit;\r\n\tfont-size: 12px;\r\n\tpadding: 8px 12px;\r\n\tborder-radius: 6px;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms ease, color 100ms ease, border-color 100ms ease;\r\n}\r\n\r\n.gc-btn:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-btn--primary {\r\n\tbackground: var(--gc-accent);\r\n\tborder-color: var(--gc-accent);\r\n\tcolor: #fff;\r\n}\r\n\r\n.gc-btn--primary:hover {\r\n\tbackground: color-mix(in srgb, var(--gc-accent) 88%, black);\r\n\tborder-color: var(--gc-accent);\r\n\tcolor: #fff;\r\n}\r\n\r\n.gc-btn--ghost {\r\n\tbackground: transparent;\r\n}\r\n\r\n.gc-form-feedback {\r\n\tpadding: 10px 12px;\r\n\tborder-radius: 8px;\r\n\tfont-size: 12px;\r\n\tline-height: 1.4;\r\n\tborder: 1px solid transparent;\r\n}\r\n\r\n.gc-form-feedback--success {\r\n\tcolor: var(--gc-up);\r\n\tbackground: rgba(0, 166, 81, 0.08);\r\n\tborder-color: rgba(0, 166, 81, 0.18);\r\n}\r\n\r\n.gc-form-feedback--error {\r\n\tcolor: var(--gc-dn);\r\n\tbackground: rgba(239, 68, 68, 0.08);\r\n\tborder-color: rgba(239, 68, 68, 0.18);\r\n}\r\n\r\n.gc-modal-backdrop {\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tz-index: var(--vnsc-z-modal-backdrop);\r\n\tdisplay: grid;\r\n\tplace-items: center;\r\n\tpadding: 24px;\r\n\tbackground: rgba(2, 6, 23, 0.62);\r\n\tbackdrop-filter: blur(10px);\r\n\t-webkit-backdrop-filter: blur(10px);\r\n}\r\n\r\n.gc-modal {\r\n\twidth: min(640px, 100%);\r\n\tmax-height: min(88vh, 860px);\r\n\tdisplay: grid;\r\n\tgrid-template-rows: auto auto minmax(0, 1fr);\r\n\tborder-radius: 18px;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 28px 80px rgba(2, 6, 23, 0.42);\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-pat-modal {\r\n\twidth: min(560px, 100%);\r\n}\r\n\r\n.gc-modal__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n\tpadding: 16px 18px 12px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-modal__title {\r\n\tfont-size: 15px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n\tletter-spacing: -0.01em;\r\n}\r\n\r\n.gc-modal__close {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms ease, color 100ms ease, border-color 100ms ease;\r\n}\r\n\r\n.gc-modal__close:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-modal__tabs {\r\n\tdisplay: flex;\r\n\tgap: 6px;\r\n\tpadding: 10px 18px 0;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n\tbackground: linear-gradient(180deg, rgba(15, 23, 42, 0.06), transparent);\r\n}\r\n\r\n.gc-modal__tab {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-bottom-color: transparent;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont: inherit;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tpadding: 8px 12px;\r\n\tborder-radius: 10px 10px 0 0;\r\n\tcursor: pointer;\r\n\ttransform: translateY(1px);\r\n}\r\n\r\n.gc-modal__tab--active {\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text);\r\n\tborder-color: var(--gc-border-mid);\r\n\tborder-bottom-color: var(--gc-surface);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.gc-modal__body {\r\n\tdisplay: grid;\r\n\tgap: 14px;\r\n\tpadding: 18px;\r\n\toverflow: auto;\r\n\tmin-height: 0;\r\n}\r\n\r\n.gc-pat-tab,\r\n.gc-login-tab,\r\n.gc-pat-offline {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n}\r\n\r\n.gc-pat-offline__hint {\r\n\tfont-size: 11px;\r\n\tcolor: var(--gc-text-muted);\r\n\tmargin: 0;\r\n}\r\n\r\n.gc-pat-offline__loaded {\r\n\tfont-size: 12px;\r\n\tcolor: var(--gc-text-muted);\r\n\tmax-width: 220px;\r\n\ttruncate: ellipsis;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-pat-source-info {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tgap: 8px;\r\n\tpadding: 10px 12px;\r\n\tborder-radius: 8px;\r\n\tbackground: var(--gc-surface-sub, rgba(37,99,235,0.07));\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 12.5px;\r\n}\r\n\r\n.gc-pat-tab__actions {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 8px;\r\n\tmargin-top: 4px;\r\n}\r\n\r\n.rsc-drawing-storage-toolbar,\r\n.rsc-drawing-dock,\r\n.rsc-drawing-inspector,\r\n.rsc-drawing-list-panel {\r\n\tposition: absolute;\r\n\tz-index: 36;\r\n\tbackdrop-filter: blur(18px);\r\n\t-webkit-backdrop-filter: blur(18px);\r\n}\r\n\r\n.rsc-drawing-dock {\r\n\twidth: min(364px, calc(100vw - 32px));\r\n\tborder-radius: calc(var(--gc-radius) + 2px);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: color-mix(in srgb, var(--gc-surface) 92%, transparent);\r\n\tbox-shadow: 0 12px 34px rgba(2, 6, 23, 0.34);\r\n\tcolor: var(--gc-text);\r\n\tdisplay: grid;\r\n\tgrid-template-rows: auto auto minmax(0, 1fr);\r\n\toverflow: hidden;\r\n\tmax-height: calc(100% - 32px);\r\n}\r\n\r\n.rsc-drawing-dock__header {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n\tpadding: 12px 14px 10px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n\tbackground: color-mix(in srgb, var(--gc-surface-sub) 86%, transparent);\r\n}\r\n\r\n.rsc-drawing-dock__title-block {\r\n\tdisplay: grid;\r\n\tgap: 3px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.rsc-drawing-dock__title-block strong {\r\n\tfont-size: 13px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.01em;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.rsc-drawing-dock__title-block span {\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.1em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.rsc-drawing-dock__header-actions {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: flex-end;\r\n}\r\n\r\n.rsc-drawing-dock__icon,\r\n.rsc-drawing-dock__tab {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tcursor: pointer;\r\n\ttransition: background 100ms ease, color 100ms ease, border-color 100ms ease;\r\n}\r\n\r\n.rsc-drawing-dock__icon {\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder-radius: 5px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.rsc-drawing-dock__tabs {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(3, minmax(0, 1fr));\r\n\tgap: 6px;\r\n\tpadding: 10px 14px 0;\r\n}\r\n\r\n.rsc-drawing-dock__tab {\r\n\tborder-radius: 999px;\r\n\tpadding: 7px 10px;\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.rsc-drawing-dock__tab--active {\r\n\tborder-color: var(--gc-accent);\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n}\r\n\r\n.rsc-drawing-dock__icon:hover,\r\n.rsc-drawing-dock__tab:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.rsc-drawing-dock__body {\r\n\tmin-height: 0;\r\n\toverflow: auto;\r\n\tpadding: 12px 14px 14px;\r\n\toverscroll-behavior: contain;\r\n}\r\n\r\n.rsc-drawing-dock__stack {\r\n\tdisplay: grid;\r\n\tgap: 12px;\r\n}\r\n\r\n.rsc-drawing-dock__empty {\r\n\tpadding: 14px;\r\n\tborder-radius: var(--gc-radius);\r\n\tborder: 1px dashed var(--gc-border-mid);\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 13px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.rsc-drawing-point-legend {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tpadding: 12px 14px 14px;\r\n\tborder-radius: calc(var(--gc-radius) + 1px);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: color-mix(in srgb, var(--gc-surface-sub) 72%, transparent);\r\n}\r\n\r\n.rsc-drawing-point-legend--empty {\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 12px;\r\n\tline-height: 1.5;\r\n\tpadding: 12px 14px 14px;\r\n}\r\n\r\n.rsc-drawing-point-legend__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 8px;\r\n}\r\n\r\n.rsc-drawing-point-legend__header strong {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.01em;\r\n}\r\n\r\n.rsc-drawing-point-legend__clear {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tborder-radius: 999px;\r\n\tpadding: 5px 10px;\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tcursor: pointer;\r\n}\r\n\r\n.rsc-drawing-point-legend__clear:hover {\r\n\tcolor: var(--gc-text);\r\n\tbackground: var(--gc-surface);\r\n\tborder-color: var(--gc-border-mid);\r\n}\r\n\r\n.rsc-drawing-point-legend__hint {\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.rsc-drawing-point-legend__items {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(auto-fit, minmax(74px, 1fr));\r\n\tgap: 8px;\r\n}\r\n\r\n.rsc-drawing-point-legend__item {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: 10px;\r\n\tbackground: rgba(15, 23, 42, 0.36);\r\n\tcolor: var(--gc-text);\r\n\tpadding: 9px 10px;\r\n\tdisplay: grid;\r\n\tgap: 5px;\r\n\tjustify-items: center;\r\n\tcursor: pointer;\r\n\ttransition: transform 120ms ease, background 120ms ease, border-color 120ms ease, box-shadow 120ms ease;\r\n}\r\n\r\n.rsc-drawing-point-legend__item:hover,\r\n.rsc-drawing-point-legend__item:focus-visible,\r\n.rsc-drawing-point-legend__item--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tborder-color: var(--gc-accent);\r\n\tbox-shadow: 0 0 0 1px color-mix(in srgb, var(--gc-accent) 55%, transparent);\r\n\ttransform: translateY(-1px);\r\n}\r\n\r\n.rsc-drawing-point-legend__index {\r\n\tfont-size: 11px;\r\n\tfont-weight: 800;\r\n\tletter-spacing: 0.04em;\r\n\tcolor: var(--gc-text-muted);\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.rsc-drawing-point-legend__label {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.rsc-drawing-storage-toolbar {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tpadding: 6px 8px;\r\n\tborder-radius: var(--gc-radius);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 4px 16px rgba(2, 6, 23, 0.24);\r\n\tflex-wrap: wrap;\r\n\tbackdrop-filter: blur(8px);\r\n\t-webkit-backdrop-filter: blur(8px);\r\n}\r\n\r\n.rsc-drawing-storage-toolbar__button {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.02em;\r\n\tpadding: 5px 9px;\r\n\tborder-radius: 5px;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms ease, color 100ms ease, border-color 100ms ease;\r\n}\r\n\r\n.rsc-drawing-storage-toolbar__button:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.rsc-drawing-inspector,\r\n.rsc-drawing-list-panel {\r\n\twidth: min(348px, calc(100vw - 32px));\r\n\tborder-radius: var(--gc-radius);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 8px 28px rgba(2, 6, 23, 0.32);\r\n\tcolor: var(--gc-text);\r\n\tpadding: 14px;\r\n\tdisplay: grid;\r\n\tgap: 14px;\r\n\tmax-height: calc(100% - 32px);\r\n\toverflow: auto;\r\n\toverscroll-behavior: contain;\r\n}\r\n\r\n.rsc-drawing-inspector--embedded,\r\n.rsc-drawing-list-panel--embedded {\r\n\tposition: static;\r\n\tz-index: auto;\r\n\twidth: auto;\r\n\tmax-height: none;\r\n\toverflow: visible;\r\n\tpadding: 0;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tbox-shadow: none;\r\n\tbackdrop-filter: none;\r\n\t-webkit-backdrop-filter: none;\r\n}\r\n\r\n.rsc-drawing-inspector--embedded .rsc-drawing-inspector__header,\r\n.rsc-drawing-list-panel--embedded .rsc-drawing-list-panel__header {\r\n\tdisplay: none;\r\n}\r\n\r\n.rsc-drawing-inspector__header,\r\n.rsc-drawing-list-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n}\r\n\r\n.rsc-drawing-inspector__title {\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.rsc-drawing-inspector__title strong,\r\n.rsc-drawing-list-panel__header strong {\r\n\tfont-size: 13px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n\tletter-spacing: 0.01em;\r\n}\r\n\r\n.rsc-drawing-inspector__title span,\r\n.rsc-drawing-list-panel__header span {\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.1em;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.rsc-drawing-inspector__icon,\r\n.rsc-drawing-list-panel__icon {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder-radius: 5px;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms ease, color 100ms ease, border-color 100ms ease;\r\n}\r\n\r\n.rsc-drawing-inspector__icon:hover,\r\n.rsc-drawing-list-panel__icon:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.rsc-drawing-inspector__swatches {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\r\n\tgap: 10px;\r\n}\r\n\r\n.rsc-drawing-inspector__field {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.06em;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.rsc-drawing-inspector__field label {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n}\r\n\r\n.rsc-drawing-inspector__field input[type=\"color\"] {\r\n\tappearance: none;\r\n\twidth: 100%;\r\n\theight: 36px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: var(--gc-radius);\r\n\tbackground: var(--gc-surface-sub);\r\n\tpadding: 3px;\r\n\tcursor: pointer;\r\n}\r\n\r\n.rsc-drawing-inspector__field input[type=\"range\"] {\r\n\twidth: 100%;\r\n\taccent-color: var(--gc-accent);\r\n}\r\n\r\n.rsc-drawing-inspector__field select {\r\n\tappearance: none;\r\n\twidth: 100%;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: var(--gc-radius);\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n\tpadding: 8px 10px;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.rsc-drawing-inspector__actions {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\r\n\tgap: 8px;\r\n}\r\n\r\n.rsc-drawing-inspector__button {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tborder-radius: var(--gc-radius);\r\n\tpadding: 8px 10px;\r\n\tfont-size: 11.5px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms ease, border-color 100ms ease, color 100ms ease;\r\n}\r\n\r\n.rsc-drawing-inspector__button:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.rsc-drawing-inspector__button:disabled {\r\n\topacity: 0.42;\r\n\tcursor: default;\r\n\ttransform: none;\r\n}\r\n\r\n.rsc-drawing-inspector__button--danger {\r\n\tgrid-column: 1 / -1;\r\n\tborder-color: rgba(239, 68, 68, 0.28);\r\n\tbackground: rgba(239, 68, 68, 0.1);\r\n\tcolor: #fecaca;\r\n}\r\n\r\n.rsc-drawing-inspector__button--danger:hover {\r\n\tbackground: rgba(239, 68, 68, 0.18);\r\n\tborder-color: rgba(239, 68, 68, 0.38);\r\n\tcolor: #fff1f2;\r\n}\r\n\r\n/* Drawing list panel: flex layout with sticky header + scrollable items */\r\n.rsc-drawing-list-panel {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tmax-height: min(560px, calc(100vh - 160px));\r\n\toverflow: hidden;\r\n\tpadding: 0;\r\n\tgap: 0;\r\n}\r\n\r\n.rsc-drawing-list-panel--embedded {\r\n\tgap: 0;\r\n\tmax-height: none;\r\n\tmin-height: 0;\r\n}\r\n\r\n.rsc-drawing-list-panel--embedded .rsc-drawing-list-panel__items {\r\n\tpadding: 0;\r\n}\r\n\r\n.rsc-drawing-list-panel--embedded .rsc-drawing-list-panel__empty {\r\n\tmargin: 0;\r\n}\r\n\r\n.rsc-drawing-list-panel__header {\r\n\tflex-shrink: 0;\r\n\tpadding: 12px 14px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n}\r\n\r\n.rsc-drawing-list-panel__items {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\toverscroll-behavior: contain;\r\n\tflex: 1 1 auto;\r\n\tmin-height: 0;\r\n\tpadding: 10px 14px 12px;\r\n\tscrollbar-width: thin;\r\n\tscrollbar-color: var(--gc-border-mid) transparent;\r\n}\r\n\r\n.rsc-drawing-list-panel__items::-webkit-scrollbar {\r\n\twidth: 4px;\r\n}\r\n\r\n.rsc-drawing-list-panel__items::-webkit-scrollbar-track {\r\n\tbackground: transparent;\r\n}\r\n\r\n.rsc-drawing-list-panel__items::-webkit-scrollbar-thumb {\r\n\tbackground: var(--gc-border-mid);\r\n\tborder-radius: 4px;\r\n}\r\n\r\n.rsc-drawing-list-panel__empty {\r\n\tmargin: 10px 14px 12px;\r\n\tpadding: 16px 14px;\r\n\tborder-radius: var(--gc-radius);\r\n\tborder: 1px dashed var(--gc-border-mid);\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 13px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.rsc-drawing-list-panel__item {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tpadding: 12px;\r\n\tborder-radius: var(--gc-radius);\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n\ttransition: border-color 120ms ease;\r\n}\r\n\r\n.rsc-drawing-list-panel__item--selected {\r\n\tborder-color: var(--gc-accent);\r\n\tbox-shadow: 0 0 0 1px var(--gc-accent-bg) inset;\r\n}\r\n\r\n.rsc-drawing-list-panel__select {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tpadding: 0;\r\n\ttext-align: left;\r\n\tcursor: pointer;\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tcolor: inherit;\r\n}\r\n\r\n.rsc-drawing-list-panel__label {\r\n\tfont-size: 13px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n\tletter-spacing: 0.01em;\r\n}\r\n\r\n.rsc-drawing-list-panel__meta {\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.rsc-drawing-list-panel__actions {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 8px;\r\n\talign-items: center;\r\n}\r\n\r\n.rsc-drawing-list-panel__badge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 4px 9px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.rsc-drawing-list-panel__icon {\r\n\twidth: auto;\r\n\theight: auto;\r\n\tpadding: 5px 10px;\r\n\tborder-radius: 999px;\r\n\tfont-size: 11px;\r\n\tfont-weight: 700;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.08em;\r\n}\r\n\r\n.rsc-long-tp-zone {\r\n\tfill: rgba(34, 197, 94, 0.16);\r\n}\r\n\r\n.rsc-long-sl-zone {\r\n\tfill: rgba(239, 68, 68, 0.16);\r\n}\r\n\r\n.rsc-short-tp-zone {\r\n\tfill: rgba(239, 68, 68, 0.16);\r\n}\r\n\r\n.rsc-short-sl-zone {\r\n\tfill: rgba(34, 197, 94, 0.16);\r\n}\r\n\r\n.rsc-rr-badge {\r\n\tfont-family: \"Segoe UI Variable Text\", \"Aptos\", \"Segoe UI\", sans-serif;\r\n\tfont-size: 11px;\r\n\tfont-weight: 800;\r\n\tletter-spacing: 0.08em;\r\n\tfill: #e2e8f0;\r\n}\r\n\r\n.gc-chart-placeholder {\r\n\theight: 100%;\r\n\tdisplay: grid;\r\n\tplace-items: center;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 13px;\r\n}\r\n\r\n.gc-chart-loading {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 12px;\r\n}\r\n\r\n.gc-spinner {\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder: 3px solid var(--gc-border);\r\n\tborder-top-color: var(--gc-accent);\r\n\tborder-radius: 50%;\r\n\tanimation: gc-spin 0.7s linear infinite;\r\n}\r\n\r\n.gc-spinner--sm {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tborder-width: 2px;\r\n}\r\n\r\n/* N-06: Shimmer overlay for VNI backfill / range reload while chart is visible */\r\n.gc-vni-backfill-overlay {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 8px;\r\n\tbackground: rgba(0, 0, 0, 0.18);\r\n\tcolor: var(--gc-text);\r\n\tfont-size: 12px;\r\n\tpointer-events: none;\r\n\tz-index: 20;\r\n}\r\n\r\n/* ── Dark Flow Strength Badge (H-04) ─────────────────────────────────────── */\r\n.gc-darkflow-badge {\r\n\tposition: absolute;\r\n\ttop: 8px;\r\n\tright: 72px; /* clear the y-axis */\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tpadding: 3px 8px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tpointer-events: none;\r\n\tz-index: 6;\r\n\tbackground: rgba(0, 0, 0, 0.5);\r\n\tcolor: #ccc;\r\n\tborder: 1px solid rgba(255, 255, 255, 0.1);\r\n\tbackdrop-filter: blur(4px);\r\n}\r\n\r\n.gc-darkflow-badge__label {\r\n\topacity: 0.7;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.gc-darkflow-badge__strength {\r\n\tfont-size: 13px;\r\n}\r\n\r\n.gc-darkflow-badge__tier,\r\n.gc-darkflow-badge__sig {\r\n\tfont-size: 10px;\r\n\topacity: 0.85;\r\n}\r\n\r\n.gc-darkflow-badge--strong {\r\n\tcolor: #ff5252;\r\n\tborder-color: rgba(255, 82, 82, 0.4);\r\n}\r\n\r\n.gc-darkflow-badge--mid {\r\n\tcolor: #29b6f6;\r\n\tborder-color: rgba(41, 182, 246, 0.4);\r\n}\r\n\r\n.gc-darkflow-badge--low {\r\n\tcolor: #ffb300;\r\n\tborder-color: rgba(255, 179, 0, 0.35);\r\n}\r\n\r\n.gc-darkflow-badge--none {\r\n\tcolor: #888;\r\n\tborder-color: rgba(136, 136, 136, 0.25);\r\n}\r\n\r\n@keyframes gc-spin {\r\n\tto { transform: rotate(360deg); }\r\n}\r\n\r\n.gc-row {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-gap4 {\r\n\tgap: 4px;\r\n}\r\n\r\n.gc-btn {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text);\r\n\tfont-size: 11px;\r\n\tpadding: 5px 9px;\r\n\tborder-radius: var(--gc-radius);\r\n\tcursor: pointer;\r\n\ttransition: background 100ms;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-btn:hover {\r\n\tbackground: var(--gc-border);\r\n}\r\n\r\n.gc-btn:disabled {\r\n\topacity: 0.4;\r\n\tcursor: default;\r\n}\r\n\r\n.gc-btn--accent {\r\n\tbackground: var(--gc-accent);\r\n\tborder-color: var(--gc-accent);\r\n\tcolor: #fff;\r\n}\r\n\r\n.gc-btn--accent:hover {\r\n\topacity: 0.9;\r\n}\r\n\r\n.gc-btn--danger {\r\n\tcolor: #fecaca;\r\n\tborder-color: rgba(239, 68, 68, 0.28);\r\n\tbackground: rgba(239, 68, 68, 0.1);\r\n}\r\n\r\n.gc-btn--danger:hover {\r\n\tbackground: rgba(239, 68, 68, 0.18);\r\n\tcolor: #fff1f2;\r\n}\r\n\r\n\r\n.gc-bottombar {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 3px;\r\n\tpadding: 0 calc(10px + var(--gc-safe-right)) 0 calc(10px + var(--gc-safe-left));\r\n\tborder-top: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n}\r\n\r\n.gc-bottombar-sep {\r\n\twidth: 1px;\r\n\theight: 16px;\r\n\tbackground: var(--gc-border);\r\n\tmargin: 0 5px;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.gc-bottom-btn {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11.5px;\r\n\tpadding: 4px 8px;\r\n\tborder-radius: 4px;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms, color 100ms;\r\n}\r\n\r\n.gc-bottom-btn:hover {\r\n\tbackground: var(--gc-border);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-bottom-btn--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.gc-grow {\r\n\tflex: 1;\r\n}\r\n\r\n.gc-version-badge {\r\n\tfont-size: 10px;\r\n\tcolor: var(--gc-text-micro);\r\n\tfont-family: var(--gc-mono);\r\n\tpadding: 0 4px;\r\n}\r\n\r\n.gc-publish-btn {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: #2962ff;\r\n\tcolor: #fff;\r\n\tfont-size: 11.5px;\r\n\tfont-weight: 700;\r\n\tpadding: 5px 13px;\r\n\tborder-radius: 4px;\r\n\tcursor: pointer;\r\n\ttransition: opacity 120ms;\r\n}\r\n\r\n.gc-publish-btn:hover {\r\n\topacity: 0.9;\r\n}\r\n\r\n/* Canvas DrawTools helpers */\r\n.rsc-drawing-snap-active {\r\n\tcursor: crosshair;\r\n}\r\n\r\n.vninvestcharts-widget-magnet-cursor {\r\n\tcursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Cpath d='M5 2h2.5v3a1.5 1.5 0 0 0 3 0V2H13v4a4 4 0 0 1-8 0V2Zm2.5 0V5a1.5 1.5 0 0 0 3 0V2h-3Z' fill='%23d97706'/%3E%3Cpath d='M4.5 14.5A1.5 1.5 0 1 1 7.5 14.5A1.5 1.5 0 0 1 4.5 14.5Zm6 0A1.5 1.5 0 1 1 13.5 14.5A1.5 1.5 0 0 1 10.5 14.5Z' fill='%23d97706'/%3E%3C/svg%3E\") 9 9, crosshair;\r\n}\r\n\r\n.rsc-long-tp-zone {\r\n\tfill: rgba(34, 171, 92, 0.18);\r\n}\r\n\r\n.rsc-long-sl-zone {\r\n\tfill: rgba(215, 50, 75, 0.18);\r\n}\r\n\r\n.rsc-short-tp-zone {\r\n\tfill: rgba(34, 171, 92, 0.18);\r\n}\r\n\r\n.rsc-short-sl-zone {\r\n\tfill: rgba(215, 50, 75, 0.18);\r\n}\r\n\r\n@media (max-width: 1150px) {\r\n\t.gc-main {\r\n\t\tgrid-template-columns: var(--gc-toolbar-w) minmax(0, 1fr);\r\n\t}\r\n\r\n\t.gc-tf-chips .gc-tf-chip:nth-child(n+7) {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n@media (max-width: 820px) {\r\n\t.gc-tf-chips {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.gc-topbar-btn:not(.gc-theme-toggle) {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.gc-upgrade-btn {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.gc-symbol-name {\r\n\t\tfont-size: 13px;\r\n\t}\r\n}\r\n\r\n/* UI/UX LAYOUT PROPOSAL: Chart-first context rail */\r\n.gc-context-rail {\r\n\twidth: var(--gc-context-rail-w, 240px);\r\n\tbackground: var(--gc-surface);\r\n\tborder-right: 1px solid var(--gc-border);\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\ttransition: width var(--gc-toolbar-motion-default) ease;\r\n\t/* Chart-first: sidebar should support overlay mode */\r\n\tposition: relative;\r\n}\r\n\r\n.gc-context-rail--collapsed {\r\n\twidth: var(--gc-context-rail-collapsed-w, 48px);\r\n}\r\n\r\n/* UI/UX Phase 1.1: Collapsible context rail toggle */\r\n.gc-context-rail__toggle {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text-muted);\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder-radius: var(--gc-radius);\r\n\tcursor: pointer;\r\n\tdisplay: grid;\r\n\tplace-items: center;\r\n\ttransition: background 100ms, color 100ms;\r\n}\r\n\r\n.gc-context-rail__toggle:hover {\r\n\tbackground: var(--gc-border);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n/* UI/UX Phase 1.1: Accordion for long content */\r\n.gc-context-rail__accordion {\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: var(--gc-radius);\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-context-rail__accordion-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 10px 12px;\r\n\tbackground: var(--gc-surface-sub);\r\n\tcursor: pointer;\r\n\ttransition: background 100ms;\r\n}\r\n\r\n.gc-context-rail__accordion-header:hover {\r\n\tbackground: var(--gc-surface);\r\n}\r\n\r\n.gc-context-rail__accordion-title {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-context-rail__accordion-chevron {\r\n\tfont-size: 10px;\r\n\tcolor: var(--gc-text-muted);\r\n\ttransition: transform 150ms ease;\r\n}\r\n\r\n.gc-context-rail__accordion-content {\r\n\tpadding: 12px;\r\n\tborder-top: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-context-rail__accordion--collapsed .gc-context-rail__accordion-content {\r\n\tdisplay: none;\r\n}\r\n\r\n.gc-context-rail__accordion--collapsed .gc-context-rail__accordion-chevron {\r\n\ttransform: rotate(-90deg);\r\n}\r\n\r\n/* UI/UX: Header grouping - prioritized clusters */\r\n.gc-topbar__cluster {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.gc-topbar__cluster--primary {\r\n\t/* Brand, symbol, timeframe - most important */\r\n}\r\n\r\n.gc-topbar__cluster--secondary {\r\n\t/* Mode, actions - less important */\r\n}\r\n\r\n.gc-topbar__cluster--tertiary {\r\n\t/* Panes, status, profile - least important, right-aligned */\r\n\tmargin-left: auto;\r\n}\r\n\r\n/* Right-aligned cluster for status badges and profile */\r\n.gc-topbar__right {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tmargin-left: auto;\r\n}\r\n\r\n/* UI/UX CHECKLIST: Unified card styling */\r\n.gc-card {\r\n\tborder-radius: var(--gc-radius, 6px);\r\n\tborder: 1px solid var(--gc-border);\r\n\tpadding: 12px;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n/* UI/UX LAYOUT PROPOSAL: Mobile context rail overlay */\r\n@media (max-width: 768px) {\r\n\t.gc-context-rail {\r\n\t\tposition: fixed;\r\n\t\tleft: 0;\r\n\t\ttop: var(--gc-topbar-h, 48px);\r\n\t\tbottom: 0;\r\n\t\tz-index: 100;\r\n\t\ttransform: translateX(-100%);\r\n\t\ttransition: transform var(--gc-toolbar-motion-default) ease;\r\n\t}\r\n\t\r\n\t.gc-context-rail--open {\r\n\t\ttransform: translateX(0);\r\n\t}\r\n}\r\n\r\n.gc-context-rail__summary {\r\n\tpadding: 12px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-context-rail__summary-title {\r\n\tfont-size: 11px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-muted);\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.gc-context-rail__chips {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px;\r\n}\r\n\r\n.gc-context-rail__chip {\r\n\tpadding: 4px 8px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: background 100ms, color 100ms, border-color 100ms;\r\n}\r\n\r\n.gc-context-rail__chip:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-context-rail__chip--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tborder-color: var(--gc-accent);\r\n\tcolor: var(--gc-accent);\r\n}\r\n\r\n.gc-context-rail__notes {\r\n\tpadding: 12px;\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n}\r\n\r\n.gc-context-rail__note {\r\n\tfont-size: 11px;\r\n\tline-height: 1.5;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-context-rail__note-title {\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n/* UI/UX: Chart stage with more breathing room */\r\n.gc-chart-stage {\r\n\tflex: 1;\r\n\tmin-width: 0;\r\n\tmin-height: 0;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbackground: var(--gc-surface);\r\n\tposition: relative;\r\n}\r\n\r\n/* UI/UX: Chart-first - give chart more width */\r\n@media (min-width: 1280px) {\r\n\t.gc-chart-stage {\r\n\t\t/* Chart should take ~65%+ of width in chart-first layout */\r\n\t}\r\n}\r\n\r\n/* UI/UX: Accessibility - enhanced focus states */\r\n.gc-tool-btn:focus-visible,\r\n.gc-topbar-btn:focus-visible,\r\n.gc-tf-chip:focus-visible {\r\n\toutline: 2px solid var(--gc-accent);\r\n\toutline-offset: 2px;\r\n}\r\n\r\n/* UI/UX: Progressive disclosure - accordion patterns */\r\n.gc-accordion {\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: var(--gc-radius);\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-accordion__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 10px 12px;\r\n\tbackground: var(--gc-surface-sub);\r\n\tcursor: pointer;\r\n\ttransition: background 100ms;\r\n}\r\n\r\n.gc-accordion__header:hover {\r\n\tbackground: var(--gc-surface);\r\n}\r\n\r\n.gc-accordion__title {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-accordion__chevron {\r\n\tfont-size: 10px;\r\n\tcolor: var(--gc-text-muted);\r\n\ttransition: transform 150ms ease;\r\n}\r\n\r\n.gc-accordion__content {\r\n\tpadding: 12px;\r\n\tborder-top: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-accordion--collapsed .gc-accordion__content {\r\n\tdisplay: none;\r\n}\r\n\r\n.gc-accordion--collapsed .gc-accordion__chevron {\r\n\ttransform: rotate(-90deg);\r\n}\r\n\r\n.demo-page {\r\n\tposition: relative;\r\n\tmin-height: 100%;\r\n\tpadding: 12px;\r\n\tbackground: transparent;\r\n}\r\n\r\n.demo-page--classic {\r\n\tpadding: 12px;\r\n}\r\n\r\n.demo-page--terminal {\r\n\tbox-sizing: border-box;\r\n\theight: 100%;\r\n\tpadding: 12px;\r\n}\r\n\r\n.demo-page::before,\r\n.demo-page::after {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tborder-radius: 999px;\r\n\tfilter: blur(60px);\r\n\tpointer-events: none;\r\n\topacity: 0.38;\r\n}\r\n\r\n.demo-page::before {\r\n\ttop: 5%;\r\n\tright: 6%;\r\n\twidth: 260px;\r\n\theight: 260px;\r\n\tbackground: rgba(34, 211, 238, 0.18);\r\n}\r\n\r\n.demo-page::after {\r\n\tleft: 4%;\r\n\tbottom: 8%;\r\n\twidth: 320px;\r\n\theight: 320px;\r\n\tbackground: rgba(245, 158, 11, 0.12);\r\n}\r\n\r\n.demo-frame {\r\n\tposition: relative;\r\n\tz-index: 1;\r\n\tmax-width: 1640px;\r\n\tmargin: 0 auto;\r\n\tdisplay: grid;\r\n\tgap: 12px;\r\n}\r\n\r\n.demo-frame--classic {\r\n\tmax-width: 1400px;\r\n\tgap: 12px;\r\n}\r\n\r\n.demo-frame--terminal {\r\n\theight: 100%;\r\n\tmin-height: 0;\r\n\tgap: 12px;\r\n}\r\n\r\n.demo-frame--full-bleed {\r\n\tmax-width: none;\r\n\twidth: 100%;\r\n}\r\n\r\n.demo-hero {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);\r\n\tgap: 24px;\r\n\talign-items: stretch;\r\n\tanimation: demo-reveal 520ms ease-out both;\r\n}\r\n\r\n.demo-hero__content,\r\n.demo-summary-card,\r\n.demo-chart-card,\r\n.demo-panel {\r\n\tbackground: var(--demo-panel);\r\n\tborder: 1px solid var(--demo-panel-border);\r\n\tborder-radius: 28px;\r\n\tbackdrop-filter: blur(20px);\r\n\t-webkit-backdrop-filter: blur(20px);\r\n\tbox-shadow: 0 30px 80px rgba(2, 6, 23, 0.38);\r\n}\r\n\r\n.demo-chart-card--terminal {\r\n\tmin-height: 0;\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-terminal--embedded {\r\n\theight: 100%;\r\n\tmin-height: 0;\r\n\tborder: 0;\r\n}\r\n\r\n.demo-hero__content {\r\n\tpadding: clamp(24px, 3vw, 40px);\r\n\tdisplay: grid;\r\n\tgap: 18px;\r\n\talign-content: start;\r\n\tborder: 1px solid rgba(34, 211, 238, 0.16);\r\n\tbackground:\r\n\t\tlinear-gradient(140deg, rgba(15, 23, 42, 0.82), rgba(2, 6, 23, 0.74)),\r\n\t\tradial-gradient(circle at top right, rgba(245, 158, 11, 0.18), transparent 42%);\r\n}\r\n\r\n.demo-eyebrow {\r\n\tdisplay: inline-flex;\r\n\twidth: fit-content;\r\n\tpadding: 8px 14px;\r\n\tborder-radius: 999px;\r\n\tbackground: rgba(34, 211, 238, 0.12);\r\n\tborder: 1px solid rgba(34, 211, 238, 0.24);\r\n\tcolor: #c0f9ff;\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.14em;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.demo-title {\r\n\tmargin: 0;\r\n\tmax-width: 15ch;\r\n\tfont-family: \"Bahnschrift\", \"Segoe UI Variable Display\", \"Aptos Display\", sans-serif;\r\n\tfont-size: clamp(2.5rem, 6vw, 4.8rem);\r\n\tline-height: 0.92;\r\n\tletter-spacing: -0.05em;\r\n\tcolor: #f8fafc;\r\n}\r\n\r\n.demo-subtitle {\r\n\tmargin: 0;\r\n\tmax-width: 72ch;\r\n\tfont-size: 1.02rem;\r\n\tline-height: 1.7;\r\n\tcolor: var(--demo-text-soft);\r\n}\r\n\r\n.demo-badges {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 10px;\r\n}\r\n\r\n.demo-badge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 8px 12px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid rgba(148, 163, 184, 0.18);\r\n\tbackground: rgba(15, 23, 42, 0.72);\r\n\tcolor: #dbeafe;\r\n\tfont-size: 0.86rem;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.demo-summary-card {\r\n\tpadding: 20px;\r\n\tdisplay: grid;\r\n\tgap: 16px;\r\n\talign-content: start;\r\n\tbackground:\r\n\t\tlinear-gradient(180deg, rgba(15, 23, 42, 0.88), rgba(15, 23, 42, 0.74)),\r\n\t\tradial-gradient(circle at top left, rgba(34, 211, 238, 0.12), transparent 48%);\r\n\tanimation: demo-reveal 620ms ease-out both;\r\n\tanimation-delay: 70ms;\r\n}\r\n\r\n.demo-summary-card__header {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.demo-summary-card__meta {\r\n\tcolor: var(--demo-text-soft);\r\n\tfont-size: 0.92rem;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.demo-summary-grid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\r\n\tgap: 12px;\r\n}\r\n\r\n.metric-tile {\r\n\tmin-height: 120px;\r\n\tpadding: 16px;\r\n\tborder-radius: 22px;\r\n\tbackground: rgba(255, 255, 255, 0.03);\r\n\tborder: 1px solid rgba(255, 255, 255, 0.08);\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\talign-content: start;\r\n}\r\n\r\n.metric-tile__label {\r\n\tfont-size: 11px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.14em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--demo-text-soft);\r\n}\r\n\r\n.metric-tile__value {\r\n\tfont-size: 1.22rem;\r\n\tfont-weight: 800;\r\n\tline-height: 1.15;\r\n\tcolor: #f8fafc;\r\n\tfont-family: \"Bahnschrift\", \"Segoe UI Variable Display\", \"Aptos Display\", sans-serif;\r\n}\r\n\r\n.metric-tile__detail {\r\n\tfont-size: 0.9rem;\r\n\tline-height: 1.45;\r\n\tcolor: var(--demo-text-soft);\r\n}\r\n\r\n.metric-tile--positive .metric-tile__value { color: #86efac; }\r\n.metric-tile--negative .metric-tile__value { color: #fca5a5; }\r\n.metric-tile--accent .metric-tile__value { color: #67e8f9; }\r\n\r\n.demo-grid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: minmax(0, 1.68fr) minmax(300px, 0.82fr);\r\n\tgap: 24px;\r\n\talign-items: start;\r\n\tanimation: demo-reveal 720ms ease-out both;\r\n\tanimation-delay: 90ms;\r\n}\r\n\r\n.demo-chart-card {\r\n\toverflow: hidden;\r\n\tborder: 1px solid rgba(148, 163, 184, 0.16);\r\n\tbackground:\r\n\t\tlinear-gradient(180deg, rgba(15, 23, 42, 0.86), rgba(15, 23, 42, 0.78)),\r\n\t\tradial-gradient(circle at top left, rgba(34, 211, 238, 0.08), transparent 36%);\r\n}\r\n\r\n.demo-chart-card__header {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: flex-start;\r\n\tgap: 16px;\r\n\tpadding: 12px 16px 10px;\r\n\tborder-bottom: 1px solid rgba(148, 163, 184, 0.12);\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.demo-chart-card__header--classic {\r\n\tpadding: 12px 16px 10px;\r\n}\r\n\r\n.demo-chart-card__chips {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: flex-end;\r\n\tgap: 10px;\r\n\talign-items: center;\r\n}\r\n\r\n.demo-chart-card__title {\r\n\tmargin: 0;\r\n\tfont-size: 1.18rem;\r\n\tfont-weight: 800;\r\n\tcolor: #f8fafc;\r\n\tletter-spacing: -0.02em;\r\n}\r\n\r\n.demo-chart-card__meta {\r\n\tmargin: 8px 0 0;\r\n\tcolor: var(--demo-text-soft);\r\n\tfont-size: 0.94rem;\r\n\tline-height: 1.55;\r\n}\r\n\r\n.source-switch {\r\n\tdisplay: inline-flex;\r\n\tpadding: 4px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid rgba(148, 163, 184, 0.14);\r\n\tbackground: rgba(15, 23, 42, 0.72);\r\n\tgap: 4px;\r\n}\r\n\r\n.source-switch__button {\r\n\tappearance: none;\r\n\tborder: 0;\r\n\tborder-radius: 999px;\r\n\tpadding: 11px 16px;\r\n\tbackground: transparent;\r\n\tcolor: var(--demo-text-soft);\r\n\tfont-size: 0.92rem;\r\n\tfont-weight: 700;\r\n\tcursor: pointer;\r\n\ttransition: background-color 160ms ease, color 160ms ease, transform 160ms ease, box-shadow 160ms ease;\r\n}\r\n\r\n.source-switch__button:hover {\r\n\tcolor: #f8fafc;\r\n\ttransform: translateY(-1px);\r\n}\r\n\r\n.source-switch__button[aria-pressed=\"true\"] {\r\n\tbackground: linear-gradient(135deg, rgba(34, 211, 238, 0.92), rgba(245, 158, 11, 0.92));\r\n\tcolor: #07111f;\r\n\tbox-shadow: 0 10px 24px rgba(34, 211, 238, 0.24);\r\n}\r\n\r\n.chart-shell {\r\n\tpadding: 8px;\r\n}\r\n\r\n.chart-shell--classic {\r\n\tpadding: 4px;\r\n}\r\n\r\n.chart-surface {\r\n\tmin-height: 600px;\r\n\twidth: 100%;\r\n\tborder-radius: 24px;\r\n\toverflow: hidden;\r\n\tbackground: rgba(2, 6, 23, 0.56);\r\n\tborder: 1px solid rgba(148, 163, 184, 0.12);\r\n}\r\n\r\n.chart-surface--classic {\r\n\tmin-height: 0;\r\n}\r\n\r\n.demo-chart-card--classic {\r\n\toverflow: hidden;\r\n}\r\n\r\n.chart-placeholder {\r\n\tmin-height: 600px;\r\n\tdisplay: grid;\r\n\tplace-items: center;\r\n\tpadding: 24px;\r\n\tcolor: var(--demo-text-soft);\r\n\ttext-align: center;\r\n\tfont-size: 0.98rem;\r\n\tletter-spacing: 0.01em;\r\n\tbackground:\r\n\t\tradial-gradient(circle at center, rgba(34, 211, 238, 0.08), transparent 42%),\r\n\t\trgba(2, 6, 23, 0.48);\r\n}\r\n\r\n.demo-side {\r\n\tdisplay: grid;\r\n\tgap: 16px;\r\n}\r\n\r\n.demo-panel {\r\n\tpadding: 20px;\r\n\tdisplay: grid;\r\n\tgap: 14px;\r\n\tanimation: demo-reveal 720ms ease-out both;\r\n\tanimation-delay: 110ms;\r\n}\r\n\r\n.demo-panel h2 {\r\n\tmargin: 0;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 800;\r\n\tletter-spacing: -0.01em;\r\n\tcolor: #f8fafc;\r\n}\r\n\r\n.feature-list,\r\n.legend-list {\r\n\tdisplay: grid;\r\n\tgap: 12px;\r\n}\r\n\r\n.feature-item {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 10px minmax(0, 1fr);\r\n\tgap: 12px;\r\n\talign-items: start;\r\n\tcolor: var(--demo-text-soft);\r\n\tline-height: 1.55;\r\n\tfont-size: 0.95rem;\r\n}\r\n\r\n.feature-dot {\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tmargin-top: 7px;\r\n\tborder-radius: 999px;\r\n\tbackground: linear-gradient(135deg, var(--demo-accent), var(--demo-accent-alt));\r\n\tbox-shadow: 0 0 16px rgba(34, 211, 238, 0.26);\r\n}\r\n\r\n.legend-row {\r\n\tdisplay: grid;\r\n\tgap: 6px;\r\n\tpadding: 12px 14px;\r\n\tborder-radius: 18px;\r\n\tbackground: rgba(255, 255, 255, 0.04);\r\n\tborder: 1px solid rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.legend-row__key {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.legend-row__label {\r\n\tfont-weight: 700;\r\n\tcolor: #f8fafc;\r\n\tflex: 1;\r\n}\r\n\r\n.legend-row__detail {\r\n\tcolor: var(--demo-text-soft);\r\n\tfont-size: 0.9rem;\r\n\tline-height: 1.45;\r\n}\r\n\r\n.legend-swatch {\r\n\tflex: none;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.legend-swatch--line {\r\n\twidth: 18px;\r\n\theight: 4px;\r\n\tborder-radius: 999px;\r\n}\r\n\r\n.legend-swatch--block {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.demo-note {\r\n\tmargin: 0;\r\n\tcolor: var(--demo-text-soft);\r\n\tline-height: 1.65;\r\n\tfont-size: 0.95rem;\r\n}\r\n\r\n.source-chip {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 8px 12px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid rgba(148, 163, 184, 0.18);\r\n\tfont-size: 0.8rem;\r\n\tfont-weight: 800;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.source-chip--neutral {\r\n\tbackground: rgba(148, 163, 184, 0.12);\r\n\tcolor: #cbd5e1;\r\n}\r\n\r\n.source-chip--accent {\r\n\tbackground: rgba(34, 211, 238, 0.14);\r\n\tcolor: #c0f9ff;\r\n}\r\n\r\n.source-chip--positive {\r\n\tbackground: rgba(16, 185, 129, 0.14);\r\n\tcolor: #bbf7d0;\r\n}\r\n\r\n.source-chip--negative {\r\n\tbackground: rgba(239, 68, 68, 0.14);\r\n\tcolor: #fecaca;\r\n}\r\n\r\n.source-chip--btn {\r\n\tbackground: rgba(148, 163, 184, 0.10);\r\n\tcolor: #94a3b8;\r\n\tcursor: pointer;\r\n\ttransition: background 0.15s, color 0.15s, border-color 0.15s;\r\n}\r\n.source-chip--btn:hover {\r\n\tbackground: rgba(34, 211, 238, 0.14);\r\n\tcolor: #c0f9ff;\r\n\tborder-color: rgba(34, 211, 238, 0.4);\r\n}\r\n.source-chip--btn-active {\r\n\tbackground: rgba(34, 211, 238, 0.22);\r\n\tcolor: #22d3ee;\r\n\tborder-color: rgba(34, 211, 238, 0.6);\r\n}\r\n\r\n.gc-btn--danger {\r\n\tcolor: #fecaca;\r\n\tborder-color: rgba(239, 68, 68, 0.28);\r\n\tbackground: rgba(239, 68, 68, 0.1);\r\n}\r\n\r\n.gc-btn--danger:hover {\r\n\tbackground: rgba(239, 68, 68, 0.18);\r\n\tcolor: #fff1f2;\r\n}\r\n\r\n.chart-surface .vninvestcharts-widget-crosshair line {\r\n\tpointer-events: none;\r\n}\r\n\r\n@keyframes demo-reveal {\r\n\tfrom {\r\n\t\topacity: 0;\r\n\t\ttransform: translateY(10px);\r\n\t}\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: translateY(0);\r\n\t}\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\t.demo-hero,\r\n\t.demo-grid {\r\n\t\tgrid-template-columns: 1fr;\r\n\t}\r\n\r\n\t.demo-title {\r\n\t\tmax-width: 11ch;\r\n\t}\r\n}\r\n\r\n@media (max-width: 760px) {\r\n\tbody {\r\n\t\tbackground:\r\n\t\t\tradial-gradient(circle at top left, rgba(34, 211, 238, 0.1), transparent 30%),\r\n\t\t\tlinear-gradient(180deg, #08101d 0%, #0b1120 44%, #0d1525 100%);\r\n\t}\r\n\r\n\t.demo-page {\r\n\t\tpadding: 16px;\r\n\t}\r\n\r\n\t.demo-hero__content,\r\n\t.demo-summary-card,\r\n\t.demo-chart-card,\r\n\t.demo-panel {\r\n\t\tborder-radius: 22px;\r\n\t}\r\n\r\n\t.demo-summary-grid {\r\n\t\tgrid-template-columns: 1fr;\r\n\t}\r\n\r\n\t.demo-chart-card__header {\r\n\t\tpadding: 18px;\r\n\t}\r\n\r\n\t.chart-shell {\r\n\t\tpadding: 12px;\r\n\t}\r\n\r\n\t.chart-surface,\r\n\t.chart-placeholder {\r\n\t\tmin-height: 420px;\r\n\t}\r\n\r\n\t.source-switch {\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.source-switch__button {\r\n\t\tflex: 1;\r\n\t}\r\n}\r\n\r\n.gc-settings-backdrop {\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tz-index: 400;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 24px;\r\n\tbackground: rgba(2, 6, 23, 0.58);\r\n\tbackdrop-filter: blur(6px);\r\n\t-webkit-backdrop-filter: blur(6px);\r\n\tanimation: demo-reveal 180ms ease-out;\r\n}\r\n\r\n.gc-settings-modal {\r\n\twidth: min(980px, calc(100% - 32px));\r\n\tmax-height: min(88vh, 860px);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tborder-radius: 10px;\r\n\tbackground: var(--gc-surface);\r\n\tbox-shadow: 0 20px 52px rgba(2, 6, 23, 0.44);\r\n\toverflow: hidden;\r\n}\r\n\r\n.gc-settings-modal__header {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tjustify-content: space-between;\r\n\tgap: 16px;\r\n\tpadding: 14px 16px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n\tbackground: linear-gradient(180deg, var(--gc-surface-sub), var(--gc-surface));\r\n}\r\n\r\n.gc-settings-modal__header h2,\r\n.gc-settings-panel__header h3,\r\n.gc-settings-composer__head h4 {\r\n\tmargin: 0;\r\n\tcolor: var(--gc-text);\r\n\tletter-spacing: -0.02em;\r\n}\r\n\r\n.gc-settings-modal__header h2 {\r\n\tfont-size: 15px;\r\n\tfont-weight: 700;\r\n\tline-height: 1.35;\r\n}\r\n\r\n.gc-settings-modal__hero {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-modal__close {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--gc-border);\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder-radius: 5px;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 18px;\r\n\tline-height: 1;\r\n\tcursor: pointer;\r\n\ttransition: background 120ms ease, color 120ms ease, border-color 120ms ease;\r\n}\r\n\r\n.gc-settings-modal__close:hover {\r\n\tbackground: var(--gc-surface-sub);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-settings-modal__meta {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-settings-badge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 3px 8px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.04em;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.gc-settings-badge--accent {\r\n\tborder-color: rgba(34, 211, 238, 0.28);\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n}\r\n\r\n.gc-settings-modal__body {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 190px minmax(0, 1fr);\r\n\tmin-height: 0;\r\n}\r\n\r\n.gc-settings-modal__nav {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 4px;\r\n\tpadding: 12px;\r\n\tborder-right: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-modal__nav-head {\r\n\tpadding: 2px 2px 10px;\r\n\tmargin-bottom: 4px;\r\n\tborder-bottom: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-settings-modal__nav-item {\r\n\tappearance: none;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: 6px;\r\n\tbackground: transparent;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont: inherit;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\theight: 32px;\r\n\tline-height: 1;\r\n\tpadding: 0 10px;\r\n\tbox-sizing: border-box;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: flex-start;\r\n\twidth: 100%;\r\n\tcursor: pointer;\r\n\ttransition: background 120ms ease, color 120ms ease, border-color 120ms ease;\r\n}\r\n\r\n.gc-settings-modal__nav-item:hover {\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-settings-modal__nav-item--active {\r\n\tbackground: var(--gc-accent-bg);\r\n\tborder-color: var(--gc-border-mid);\r\n\tcolor: var(--gc-accent);\r\n}\r\n\r\n.gc-settings-modal__content {\r\n\tmin-width: 0;\r\n\toverflow: auto;\r\n\tpadding: 12px;\r\n\tbackground: var(--gc-surface);\r\n}\r\n\r\n.gc-settings-modal__content::-webkit-scrollbar,\r\n.gc-settings-modal__nav::-webkit-scrollbar {\r\n\twidth: 10px;\r\n\theight: 10px;\r\n}\r\n\r\n.gc-settings-modal__content::-webkit-scrollbar-thumb,\r\n.gc-settings-modal__nav::-webkit-scrollbar-thumb {\r\n\tbackground: rgba(148, 163, 184, 0.28);\r\n\tborder-radius: 999px;\r\n\tborder: 2px solid transparent;\r\n\tbackground-clip: padding-box;\r\n}\r\n\r\n.gc-settings-modal__surface {\r\n\tdisplay: grid;\r\n\tgap: 12px;\r\n}\r\n\r\n.gc-settings-panel {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n\tpadding: 14px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface-sub);\r\n}\r\n\r\n.gc-settings-panel + .gc-settings-panel {\r\n\tmargin-top: 12px;\r\n}\r\n\r\n.gc-settings-panel__header,\r\n.gc-settings-composer__head,\r\n.gc-settings-series__head,\r\n.gc-settings-pane__head,\r\n.gc-settings-pane__footer {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-settings-series__head {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: minmax(0, 1fr) auto auto;\r\n\talign-items: center;\r\n\tflex-wrap: nowrap;\r\n}\r\n\r\n.gc-settings-series__head > :first-child {\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-series__head .gc-settings-field--compact {\r\n\tmin-width: 140px;\r\n}\r\n\r\n.gc-settings-series__head .gc-settings-series__actions {\r\n\tjustify-self: end;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-settings-panel__header h3 {\r\n\tfont-size: 15px;\r\n\tfont-weight: 700;\r\n\tline-height: 1.3;\r\n}\r\n\r\n.gc-settings-composer__head h4 {\r\n\tfont-size: 13px;\r\n\tfont-weight: 700;\r\n\tline-height: 1.25;\r\n}\r\n\r\n.gc-settings-kicker {\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-micro);\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n.gc-settings-stat {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 4px 8px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\twhite-space: nowrap;\r\n\tletter-spacing: 0.04em;\r\n}\r\n\r\n/* =========================================================\r\n   Color picker for indicator settings\r\n   ========================================================= */\r\n.gc-settings-field--color {\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.gc-settings-field--color > span {\r\n\tflex: 1;\r\n}\r\n\r\n.gc-settings-bollinger-stack {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-bollinger-grid {\r\n\tgrid-template-columns: minmax(100px, 0.6fr) minmax(120px, 0.7fr) minmax(92px, 0.5fr) minmax(260px, 1.3fr);\r\n\talign-items: end;\r\n}\r\n\r\n.gc-settings-bollinger-grid--fill {\r\n\tgrid-template-columns: minmax(130px, 0.85fr) minmax(0, 1.15fr) minmax(92px, 0.6fr);\r\n\talign-items: end;\r\n}\r\n\r\n.gc-settings-bollinger-grid--fill .gc-settings-field--color > span {\r\n\tflex: 0 0 auto;\r\n}\r\n\r\n.gc-settings-bollinger-grid__short-field {\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-bollinger-grid .gc-settings-field--compact {\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-color-input {\r\n\twidth: 36px;\r\n\theight: 28px;\r\n\tpadding: 2px 3px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: 6px;\r\n\tbackground: var(--gc-bg);\r\n\tcursor: pointer;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.gc-settings-color-input:focus-visible {\r\n\toutline: 2px solid var(--gc-accent);\r\n\toutline-offset: 1px;\r\n}\r\n\r\n/* =========================================================\r\n   Sub-component colors section (MACD, BB, KDJ, etc.)\r\n   ========================================================= */\r\n.gc-settings-sub-colors {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tflex-wrap: wrap;\r\n\talign-items: center;\r\n\tgap: 8px 16px;\r\n\tborder-top: 1px solid var(--gc-border);\r\n\tpadding-top: 10px;\r\n\tmargin-top: 6px;\r\n\tgrid-column: 1 / -1;\r\n}\r\n\r\n.gc-settings-sub-colors__label {\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.1em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--gc-text-muted);\r\n\twidth: 100%;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.gc-settings-sub-colors .gc-settings-field--color {\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tflex: 0 0 auto;\r\n}\r\n\r\n.gc-settings-sub-colors .gc-settings-field--color > span {\r\n\tfont-size: 11px;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n/* =========================================================\r\n   Drawing tools grouped flyout sub-menus\r\n   ========================================================= */\r\n.gc-tools-group-container {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n}\r\n\r\n.gc-tool-btn--group {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tgap: 1px;\r\n}\r\n\r\n.gc-tools-chevron {\r\n\tfont-size: 7px;\r\n\tline-height: 1;\r\n\topacity: 0.6;\r\n\tpointer-events: none;\r\n}\r\n\r\n.gc-tools-flyout {\r\n\tposition: fixed;\r\n\tz-index: 2000;\r\n\tbackground: var(--gc-surface);\r\n\tborder: 1px solid var(--gc-border-mid);\r\n\tborder-radius: var(--gc-radius);\r\n\tbox-shadow: 4px 4px 20px rgba(0, 0, 0, 0.22);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: var(--gc-toolbar-gap);\r\n\tpadding: var(--gc-toolbar-flyout-padding);\r\n\tmin-width: calc(var(--gc-toolbar-button-size) + (var(--gc-toolbar-flyout-padding) * 2));\r\n\tmax-height: calc(100vh - 24px);\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n}\r\n\r\n/* Desktop safety guard: always preserve a visible, scrollable tools region in flyouts. */\r\n@media (min-width: 768px) {\r\n\t.gc-tools-flyout {\r\n\t\toverflow: hidden;\r\n\t}\r\n\r\n\t.gc-tools-flyout > div {\r\n\t\tflex-shrink: 0;\r\n\t}\r\n\r\n\t.gc-tools-flyout > div:last-child {\r\n\t\tflex: 1 1 auto;\r\n\t\tmin-height: 120px;\r\n\t\toverflow-y: auto !important;\r\n\t\toverflow-x: hidden !important;\r\n\t}\r\n}\r\n\r\n/* =========================================================\r\n   CE21: Responsive / Mobile (≤767px)\r\n   Toolbar collapses from vertical column to horizontal row\r\n   with touch-friendly tap targets and scroll overflow.\r\n   ========================================================= */\r\n@media (max-width: 767px) {\r\n\t/* Reconfigure layout: toolbar becomes top horizontal bar */\r\n\t.gc-main {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: minmax(0, 1fr);\r\n\t\tgrid-template-rows: auto minmax(0, 1fr);\r\n\t}\r\n\r\n\t.gc-chart-shell {\r\n\t\tpadding: 8px;\r\n\t}\r\n\r\n\t/* Toolbar rotates: column → row, scrolls horizontally; reset auto-hide */\r\n\t.gc-tools-shell {\r\n\t\tposition: relative;\r\n\t\tleft: auto;\r\n\t\ttop: auto;\r\n\t\tbottom: auto;\r\n\t\twidth: auto;\r\n\t\tz-index: auto;\r\n\t\toverflow: visible;\r\n\t}\r\n\r\n\t.gc-tools {\r\n\t\tposition: relative;\r\n\t\tleft: auto;\r\n\t\twidth: auto;\r\n\t\ttop: auto;\r\n\t\tbottom: auto;\r\n\t\tflex-direction: row;\r\n\t\talign-items: center;\r\n\t\tpadding: 4px calc(8px + var(--gc-safe-right)) 4px calc(8px + var(--gc-safe-left));\r\n\t\tgap: var(--gc-toolbar-gap);\r\n\t\toverflow-x: auto;\r\n\t\toverflow-y: visible;\r\n\t\t-webkit-overflow-scrolling: touch;\r\n\t\tscrollbar-width: none;\r\n\t\tborder-right: none;\r\n\t\tborder-bottom: 1px solid var(--gc-border);\r\n\t\tbox-shadow: none;\r\n\t\ttransition: none;\r\n\t}\r\n\r\n\t.gc-tools-handle {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.gc-tools::after {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.gc-tools:hover,\r\n\t.gc-tools:focus-within {\r\n\t\tleft: auto;\r\n\t\tbox-shadow: none;\r\n\t}\r\n\r\n\t.gc-chart-area {\r\n\t\tposition: relative;\r\n\t\tinset: auto;\r\n\t}\r\n\r\n\t.gc-tools::-webkit-scrollbar {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.gc-tools-group {\r\n\t\tflex-direction: row;\r\n\t\talign-items: center;\r\n\t\tgap: var(--gc-toolbar-gap);\r\n\t}\r\n\r\n\t/* Vertical divider instead of horizontal */\r\n\t.rsc-toolbar-divider {\r\n\t\twidth: 1px;\r\n\t\theight: 20px;\r\n\t\tmargin: 0 4px;\r\n\t}\r\n\r\n\t/* Flyout opens downward on mobile (toolbar is horizontal) */\r\n\t.gc-tools-flyout {\r\n\t\tflex-direction: row;\r\n\t\tmax-width: calc(100vw - 16px);\r\n\t\tmax-height: calc(100dvh - 16px - var(--gc-keyboard-inset-bottom));\r\n\t\toverflow-x: auto;\r\n\t\toverflow-y: auto;\r\n\t}\r\n\r\n\t/* Ensure all tool buttons meet 44×44px touch target minimum */\r\n\t.gc-tool-btn {\r\n\t\tmin-width: var(--gc-toolbar-flyout-button-size-compact);\r\n\t\tmin-height: var(--gc-toolbar-flyout-button-size-compact);\r\n\t\twidth: var(--gc-toolbar-flyout-button-size-compact);\r\n\t\theight: var(--gc-toolbar-flyout-button-size-compact);\r\n\t\tflex-shrink: 0;\r\n\t}\r\n\r\n\t.rsc-drawing-dock,\r\n\t.rsc-drawing-inspector,\r\n\t.rsc-drawing-list-panel {\r\n\t\tleft: calc(8px + var(--gc-safe-left)) !important;\r\n\t\tright: calc(8px + var(--gc-safe-right)) !important;\r\n\t\twidth: auto;\r\n\t\tmax-width: none;\r\n\t}\r\n\r\n\t.rsc-drawing-dock {\r\n\t\ttop: auto !important;\r\n\t\tbottom: calc(8px + var(--gc-safe-bottom) + var(--gc-keyboard-inset-bottom));\r\n\t\tmax-height: min(48vh, 520px);\r\n\t}\r\n\r\n\t.rsc-drawing-dock__tabs {\r\n\t\tgrid-template-columns: repeat(3, minmax(0, 1fr));\r\n\t\tgap: 4px;\r\n\t\tpadding: 10px 12px 0;\r\n\t}\r\n\r\n\t.rsc-drawing-dock__body {\r\n\t\tpadding: 10px 12px 12px;\r\n\t}\r\n\r\n\t.rsc-drawing-dock__icon,\r\n\t.rsc-drawing-dock__tab,\r\n\t.rsc-drawing-inspector__icon,\r\n\t.rsc-drawing-inspector__button,\r\n\t.rsc-drawing-list-panel__icon,\r\n\t.rsc-drawing-list-panel__select,\r\n\t.rsc-drawing-point-legend__item,\r\n\t.rsc-drawing-point-legend__clear {\r\n\t\tmin-height: 44px;\r\n\t}\r\n\r\n\t.rsc-drawing-inspector,\r\n\t.rsc-drawing-list-panel {\r\n\t\tmax-height: 44vh;\r\n\t}\r\n\r\n\t.rsc-drawing-inspector--embedded,\r\n\t.rsc-drawing-list-panel--embedded {\r\n\t\tpadding: 10px;\r\n\t}\r\n\r\n\t.rsc-drawing-inspector__actions,\r\n\t.rsc-drawing-list-panel__actions {\r\n\t\tgap: 6px;\r\n\t}\r\n\r\n\t.rsc-drawing-list-panel__item {\r\n\t\tpadding: 10px;\r\n\t}\r\n\r\n\t.rsc-drawing-list-panel__select {\r\n\t\tpadding: 8px 10px;\r\n\t}\r\n\r\n\t.rsc-drawing-point-legend {\r\n\t\tpadding: 10px 12px 12px;\r\n\t}\r\n\r\n\t/* Drawing storage toolbar: stack vertically and widen */\r\n\t.rsc-drawing-storage-toolbar {\r\n\t\tflex-wrap: wrap;\r\n\t\twidth: calc(100vw - 32px - var(--gc-safe-left) - var(--gc-safe-right));\r\n\t\tleft: calc(16px + var(--gc-safe-left)) !important;\r\n\t\ttop: auto !important;\r\n\t\tbottom: calc(60px + var(--gc-safe-bottom) + var(--gc-keyboard-inset-bottom));\r\n\t}\r\n\r\n\t.rsc-drawing-storage-toolbar__button {\r\n\t\tmin-height: 44px;\r\n\t\tflex: 1;\r\n\t\tfont-size: 12px;\r\n\t}\r\n\r\n\t/* Candle type select touch-friendly */\r\n\t.vnsc-candle-type-select {\r\n\t\tmin-height: 44px;\r\n\t\tfont-size: 13px;\r\n\t}\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1023px) {\r\n\t.rsc-drawing-dock,\r\n\t.rsc-drawing-inspector,\r\n\t.rsc-drawing-list-panel {\r\n\t\tleft: 12px !important;\r\n\t\tright: 12px !important;\r\n\t\twidth: auto;\r\n\t\tmax-width: none;\r\n\t}\r\n\r\n\t.rsc-drawing-dock {\r\n\t\ttop: 12px !important;\r\n\t\tbottom: auto;\r\n\t\tmax-height: min(56vh, 640px);\r\n\t}\r\n\r\n\t.rsc-drawing-inspector,\r\n\t.rsc-drawing-list-panel {\r\n\t\tmax-height: 38vh;\r\n\t}\r\n\r\n\t.rsc-drawing-dock__tabs {\r\n\t\tpadding-left: 12px;\r\n\t\tpadding-right: 12px;\r\n\t}\r\n\r\n\t.rsc-drawing-dock__icon,\r\n\t.rsc-drawing-dock__tab,\r\n\t.rsc-drawing-inspector__icon,\r\n\t.rsc-drawing-inspector__button,\r\n\t.rsc-drawing-list-panel__icon,\r\n\t.rsc-drawing-list-panel__select,\r\n\t.rsc-drawing-point-legend__item,\r\n\t.rsc-drawing-point-legend__clear {\r\n\t\tmin-height: 40px;\r\n\t}\r\n}\r\n\r\n.gc-settings-row {\r\n\tdisplay: flex;\r\n\talign-items: flex-end;\r\n\tgap: 10px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-settings-row--split {\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.gc-settings-field {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.gc-settings-field--compact {\r\n\tmin-width: 180px;\r\n}\r\n\r\n.gc-settings-field > span {\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-settings-input,\r\n.gc-settings-select {\r\n\twidth: 100%;\r\n\tmin-width: 0;\r\n\tpadding: 8px 10px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tborder-radius: 6px;\r\n\tbackground: var(--gc-bg);\r\n\tcolor: var(--gc-text);\r\n\tfont: inherit;\r\n\tfont-size: 12px;\r\n\ttransition: border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;\r\n}\r\n\r\n.gc-settings-input:focus,\r\n.gc-settings-select:focus {\r\n\toutline: none;\r\n\tborder-color: var(--gc-accent);\r\n\tbox-shadow: 0 0 0 2px rgba(34, 211, 238, 0.12);\r\n}\r\n\r\n.gc-settings-select {\r\n\tappearance: none;\r\n}\r\n\r\n.gc-settings-range {\r\n\twidth: 100%;\r\n\tmargin-top: 4px;\r\n\taccent-color: var(--gc-accent);\r\n}\r\n\r\n.gc-settings-slider-shell {\r\n\tdisplay: grid;\r\n\tgap: 6px;\r\n}\r\n\r\n.gc-settings-slider-steps {\r\n\tposition: relative;\r\n\tmargin-top: 6px;\r\n\tmin-height: 16px;\r\n\tfont-size: 10px;\r\n\tcolor: var(--gc-text-dim);\r\n}\r\n\r\n.gc-settings-slider-steps__label {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\ttransform: translateX(-50%);\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-settings-slider-steps__label--active {\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.gc-settings-slider-steps__current {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\ttransform: translateX(-50%);\r\n\twhite-space: nowrap;\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 700;\r\n\tpointer-events: none;\r\n}\r\n\r\n.gc-settings-slider-readout {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tmin-height: 16px;\r\n\tfont-size: 10px;\r\n\tcolor: var(--gc-text-dim);\r\n}\r\n\r\n.gc-settings-slider-readout__edge {\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.gc-settings-slider-readout__edge--active {\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.gc-settings-slider-readout__current {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\ttransform: translateX(-50%);\r\n\twhite-space: nowrap;\r\n\tcolor: var(--gc-accent);\r\n\tfont-weight: 700;\r\n\tpointer-events: none;\r\n}\r\n\r\n.gc-settings-field--toggle {\r\n\tflex-direction: row;\r\n\talign-items: flex-start;\r\n\tgap: 10px;\r\n\tmin-width: 220px;\r\n}\r\n\r\n.gc-settings-field--toggle > input {\r\n\tmargin-top: 3px;\r\n\tflex: none;\r\n}\r\n\r\n.gc-settings-field--toggle > div {\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-pane-list,\r\n.gc-settings-series-list {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n}\r\n\r\n.gc-settings-pane {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 10px;\r\n\tpadding: 14px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n\tcursor: pointer;\r\n\ttransition: border-color 120ms ease, background 120ms ease;\r\n}\r\n\r\n.gc-settings-pane:hover {\r\n\tborder-color: var(--gc-border-mid);\r\n\tbackground: var(--gc-bg);\r\n}\r\n\r\n.gc-settings-pane--hidden {\r\n\topacity: 0.78;\r\n}\r\n\r\n.gc-settings-pane--selected {\r\n\tborder-color: rgba(34, 211, 238, 0.36);\r\n\tbox-shadow: inset 0 0 0 1px rgba(34, 211, 238, 0.16);\r\n}\r\n\r\n.gc-settings-pane__label {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tfont-size: 12.5px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-settings-pane__meta,\r\n.gc-settings-series__meta {\r\n\tfont-size: 10.5px;\r\n\tline-height: 1.4;\r\n\tcolor: var(--gc-text-micro);\r\n}\r\n\r\n.gc-settings-pane__actions,\r\n.gc-settings-pane__arrows,\r\n.gc-settings-series__actions {\r\n\tdisplay: flex;\r\n\tgap: 8px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.gc-settings-pane__footer {\r\n\talign-items: center;\r\n}\r\n\r\n.gc-settings-pane__tags {\r\n\tdisplay: flex;\r\n\tgap: 6px;\r\n\tflex-wrap: wrap;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-tag {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 3px 8px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid rgba(34, 211, 238, 0.24);\r\n\tbackground: var(--gc-accent-bg);\r\n\tcolor: var(--gc-accent);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.03em;\r\n}\r\n\r\n.gc-settings-pill {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 2px 6px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-border);\r\n\tcolor: var(--gc-text-muted);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.05em;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.gc-settings-pill--ok {\r\n\tborder-color: rgba(16, 185, 129, 0.24);\r\n\tbackground: rgba(16, 185, 129, 0.12);\r\n\tcolor: #8ef0c4;\r\n}\r\n\r\n.gc-settings-pill--muted {\r\n\tborder-color: rgba(148, 163, 184, 0.16);\r\n\tbackground: rgba(148, 163, 184, 0.08);\r\n\tcolor: var(--gc-text-micro);\r\n}\r\n\r\n.gc-settings-note {\r\n\tfont-size: 11px;\r\n\tline-height: 1.55;\r\n\tcolor: var(--gc-text-muted);\r\n}\r\n\r\n.gc-settings-note--tight {\r\n\tmax-width: 28ch;\r\n}\r\n\r\n.gc-settings-note--warn {\r\n\tcolor: #fecaca;\r\n}\r\n\r\n.gc-settings-empty {\r\n\tpadding: 24px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px dashed var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n\tcolor: var(--gc-text-muted);\r\n\ttext-align: center;\r\n}\r\n\r\n.gc-settings-pane-summary {\r\n\tdisplay: grid;\r\n\tgap: 6px;\r\n\tpadding: 12px 14px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n}\r\n\r\n.gc-settings-pane-summary__title {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tflex-wrap: wrap;\r\n\tfont-size: 12.5px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-settings-series {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 10px;\r\n\tpadding: 12px 14px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid var(--gc-border);\r\n\tbackground: var(--gc-surface);\r\n}\r\n\r\n.gc-settings-series__title {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--gc-text);\r\n}\r\n\r\n.gc-settings-series__params {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n\tgap: 10px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-param-grid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n\tgap: 10px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.gc-settings-param-grid--three {\r\n\tgrid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n}\r\n\r\n.gc-settings-composer {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n\tpadding-top: 12px;\r\n\tborder-top: 1px solid var(--gc-border);\r\n}\r\n\r\n.gc-settings-composer__head {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: minmax(0, 1fr) auto;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n}\r\n\r\n.gc-settings-panel .gc-btn,\r\n.gc-settings-composer .gc-btn,\r\n.gc-settings-series__actions .gc-btn,\r\n.gc-settings-pane__actions .gc-btn,\r\n.gc-settings-pane__arrows .gc-btn {\r\n\tmin-height: 30px;\r\n\tpadding: 6px 10px;\r\n\tborder-radius: 6px;\r\n\tfont-size: 11.5px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n@media (max-width: 980px) {\r\n\t.gc-settings-backdrop {\r\n\t\tpadding: 12px;\r\n\t}\r\n\r\n\t.gc-settings-modal__body {\r\n\t\tgrid-template-columns: 1fr;\r\n\t}\r\n\r\n\t.gc-settings-modal__nav {\r\n\t\tflex-direction: row;\r\n\t\tflex-wrap: wrap;\r\n\t\talign-items: center;\r\n\t\tborder-right: none;\r\n\t\tborder-bottom: 1px solid var(--gc-border);\r\n\t}\r\n\r\n\t.gc-settings-modal__nav-head {\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.gc-settings-modal__nav-item {\r\n\t\tflex: 1 1 140px;\r\n\t\tjustify-content: center;\r\n\t}\r\n\r\n\t.gc-settings-bollinger-row {\r\n\t\tgrid-template-columns: repeat(2, minmax(0, 1fr));\r\n\t}\r\n}\r\n\r\n@media (max-width: 640px) {\r\n\t.gc-settings-modal {\r\n\t\tmax-height: 92vh;\r\n\t\tborder-radius: 8px;\r\n\t}\r\n\r\n\t.gc-settings-modal__header,\r\n\t.gc-settings-modal__content,\r\n\t.gc-settings-modal__nav,\r\n\t.gc-settings-panel {\r\n\t\tpadding: 14px;\r\n\t}\r\n\r\n\t.gc-settings-row--split {\r\n\t\tflex-direction: column;\r\n\t\talign-items: stretch;\r\n\t}\r\n\r\n\t.gc-settings-field--compact {\r\n\t\tmin-width: 0;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.gc-settings-param-grid,\r\n\t.gc-settings-param-grid--three {\r\n\t\tgrid-template-columns: 1fr;\r\n\t}\r\n\r\n\t.gc-settings-bollinger-row {\r\n\t\tgrid-template-columns: 1fr;\r\n\t}\r\n\r\n\t.gc-settings-series__head,\r\n\t.gc-settings-composer__head,\r\n\t.gc-settings-panel__header {\r\n\t\tflex-direction: column;\r\n\t}\r\n\r\n\t.gc-settings-modal__header h2 {\r\n\t\tfont-size: 14px;\r\n\t}\r\n}\r\n\r\n/* Custom scrollbars for Sidebar and Tools to make them super thin and clean (WE2 UI/UX) */\r\n.demo-sidebar-aside {\r\n\tscrollbar-width: thin;\r\n\tscrollbar-color: var(--gc-border-mid) transparent;\r\n}\r\n\r\n.demo-sidebar-aside::-webkit-scrollbar {\r\n\twidth: 5px;\r\n\theight: 5px;\r\n}\r\n\r\n.demo-sidebar-aside::-webkit-scrollbar-track {\r\n\tbackground: transparent;\r\n}\r\n\r\n.demo-sidebar-aside::-webkit-scrollbar-thumb {\r\n\tbackground: var(--gc-border-mid);\r\n\tborder-radius: 4px;\r\n}\r\n\r\n.demo-sidebar-aside::-webkit-scrollbar-thumb:hover {\r\n\tbackground: var(--gc-accent);\r\n}\r\n\r\n.gc-tools::-webkit-scrollbar {\r\n\twidth: 4px;\r\n\theight: 4px;\r\n}\r\n\r\n.gc-tools::-webkit-scrollbar-track {\r\n\tbackground: transparent;\r\n}\r\n\r\n.gc-tools::-webkit-scrollbar-thumb {\r\n\tbackground: var(--gc-border-mid);\r\n\tborder-radius: 4px;\r\n}\r\n\r\n.gc-tools::-webkit-scrollbar-thumb:hover {\r\n\tbackground: var(--gc-accent);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
